// This file is auto-generated by @hey-api/openapi-ts

import { type DefaultError, type InfiniteData, infiniteQueryOptions, queryOptions, type UseMutationOptions } from '@tanstack/react-query';
import type { AxiosError } from 'axios';

import { client } from '../client.gen';
import { ApiKeys, AssistantV2, Authentication, Default, Diagnostics, Documents, DocumentWebhooks, GoogleMaps, GuestAccess, Health, Legal, MaintenanceV2, Notifications, OAuth, Observability, type Options, ProfessionalContacts, Properties, PropertyOwnership, PropertyPayments, Sharing, SlackIntake, StagedDocuments, StripeWebhooks, Tasks, UserActivity, UserRegistration, Users } from '../sdk.gen';
import type { AbortRolloutEndpointObservabilityRolloutsRolloutIdAbortPostData, AbortRolloutEndpointObservabilityRolloutsRolloutIdAbortPostError, AcceptExtractedContactHousesHouseIdContactsFromExtractionExtractedContactIdPostData, AcceptExtractedContactHousesHouseIdContactsFromExtractionExtractedContactIdPostError, AcceptExtractedContactHousesHouseIdContactsFromExtractionExtractedContactIdPostResponse, AcceptSharingInvitationHousesHouseIdSharingAcceptPostData, AcceptSharingInvitationHousesHouseIdSharingAcceptPostError, AcceptSharingInvitationHousesHouseIdSharingAcceptPostResponse, ActivateProSubscriptionDirectUsersMeProSubscriptionActivatePostData, ActivateProSubscriptionDirectUsersMeProSubscriptionActivatePostResponse, AddContactToPropertyHousesHouseIdContactsPostData, AddContactToPropertyHousesHouseIdContactsPostError, AddContactToPropertyHousesHouseIdContactsPostResponse, AddTagToDocumentHousesHouseIdDocumentsTagsPostData, AddTagToDocumentHousesHouseIdDocumentsTagsPostError, AddTagToDocumentHousesHouseIdDocumentsTagsPostResponse, AddUserToHouseHousesHouseIdUsersPostData, AddUserToHouseHousesHouseIdUsersPostError, AddUserToHouseHousesHouseIdUsersPostResponse, AddUserToSharingHousesHouseIdSharingUsersPostData, AddUserToSharingHousesHouseIdSharingUsersPostError, AddUserToSharingHousesHouseIdSharingUsersPostResponse, ApproveAccessGrantGuestAccessGrantIdApprovePostData, ApproveAccessGrantGuestAccessGrantIdApprovePostError, ApproveAccessGrantGuestAccessGrantIdApprovePostResponse, ApproveBundleProposalHousesHouseIdStagedDocumentsProposalsPublicIdApprovePostData, ApproveBundleProposalHousesHouseIdStagedDocumentsProposalsPublicIdApprovePostError, ApproveBundleProposalHousesHouseIdStagedDocumentsProposalsPublicIdApprovePostResponse, ApproveOauthAuthorizeRequestIdApprovePostData, ApproveOauthAuthorizeRequestIdApprovePostError, ApproveOauthAuthorizeRequestIdApprovePostResponse, ApproveViaMagicTokenGuestAccessManageApproveViaTokenPostData, ApproveViaMagicTokenGuestAccessManageApproveViaTokenPostError, ApproveViaMagicTokenGuestAccessManageApproveViaTokenPostResponse, AssistantTurnStreamV2HousesHouseIdAssistantTurnStreamPostData, AssistantTurnStreamV2HousesHouseIdAssistantTurnStreamPostError, AssistantTurnStreamV2HousesHouseIdAssistantTurnStreamPostResponse, AssistantTurnV2HousesHouseIdAssistantTurnPostData, AssistantTurnV2HousesHouseIdAssistantTurnPostError, AssistantTurnV2HousesHouseIdAssistantTurnPostResponse, AuthenticatedQrAccessRequestHousesHouseIdQrAccessRequestPostData, AuthenticatedQrAccessRequestHousesHouseIdQrAccessRequestPostError, AuthenticatedQrAccessRequestHousesHouseIdQrAccessRequestPostResponse, AuthorizationIsNotHereOauthAuthorizeGetData, AuthorizationIsNotHereOauthAuthorizeGetError, AuthorizationServerMetadataWellKnownOauthAuthorizationServerGetData, AuthorizationServerMetadataWellKnownOauthAuthorizationServerGetError, CancelPendingPropertyTransferHousesHouseIdPendingTransferDeleteData, CancelPendingPropertyTransferHousesHouseIdPendingTransferDeleteError, ChangePasswordMeChangePasswordPostData, ChangePasswordMeChangePasswordPostError, ChangePasswordMeChangePasswordPostResponse, CheckResourceStateResourcesResourceIdStateGetData, CheckResourceStateResourcesResourceIdStateGetError, CheckResourceStateResourcesResourceIdStateGetResponse, CheckTaskCompletedTasksTaskIdStatusGetData, CheckTaskCompletedTasksTaskIdStatusGetError, CheckTaskCompletedTasksTaskIdStatusGetResponse, ClaimPendingPropertyTransferClaimPropertyTransferPostData, ClaimPendingPropertyTransferClaimPropertyTransferPostError, ClaimPendingPropertyTransferClaimPropertyTransferPostResponse, CompleteUserAccountMeCompleteAccountPutData, CompleteUserAccountMeCompleteAccountPutError, CompleteUserAccountMeCompleteAccountPutResponse, ConfirmOneOffPaymentMePaymentsPostData, ConfirmOneOffPaymentMePaymentsPostError, ConfirmOneOffPaymentMePaymentsPostResponse, CreateBillingPortalMeBillingPortalPostData, CreateBillingPortalMeBillingPortalPostResponse, CreateCreditCheckoutCreditsCheckoutPostData, CreateCreditCheckoutCreditsCheckoutPostError, CreateCreditCheckoutCreditsCheckoutPostResponse, CreateCustomCategoryServiceCategoriesPostData, CreateCustomCategoryServiceCategoriesPostError, CreateCustomCategoryServiceCategoriesPostResponse, CreateCustomContactCategoryHousesHouseIdContactsCategoriesPostData, CreateCustomContactCategoryHousesHouseIdContactsCategoriesPostError, CreateCustomContactCategoryHousesHouseIdContactsCategoriesPostResponse, CreateCustomContactRoleHousesHouseIdContactsRolesPostData, CreateCustomContactRoleHousesHouseIdContactsRolesPostError, CreateCustomContactRoleHousesHouseIdContactsRolesPostResponse, CreateCustomEntryV2HousesHouseIdMaintenanceCustomEntriesPostData, CreateCustomEntryV2HousesHouseIdMaintenanceCustomEntriesPostError, CreateCustomEntryV2HousesHouseIdMaintenanceCustomEntriesPostResponse, CreateGuestInvitationHousesHouseIdGuestAccessInvitePostData, CreateGuestInvitationHousesHouseIdGuestAccessInvitePostError, CreateGuestInvitationHousesHouseIdGuestAccessInvitePostResponse, CreateHouseV2V2HousesPostData, CreateHouseV2V2HousesPostError, CreateHouseV2V2HousesPostResponse, CreateKeyUsersMeApiKeysPostData, CreateKeyUsersMeApiKeysPostError, CreateKeyUsersMeApiKeysPostResponse, CreatePendingPropertyTransferHousesHouseIdPendingTransferPostData, CreatePendingPropertyTransferHousesHouseIdPendingTransferPostError, CreatePendingPropertyTransferHousesHouseIdPendingTransferPostResponse, CreateProCheckoutUsersMeProSubscriptionCheckoutPostData, CreateProCheckoutUsersMeProSubscriptionCheckoutPostResponse, CreatePropertyBundleAdminPropertyBundlesPostData, CreatePropertyBundleAdminPropertyBundlesPostError, CreatePropertyBundleAdminPropertyBundlesPostResponse, CreateRolloutEndpointObservabilityRolloutsPostData, CreateRolloutEndpointObservabilityRolloutsPostError, DeleteDocumentV2V2HousesHouseIdDocumentsDocumentIdDeleteData, DeleteDocumentV2V2HousesHouseIdDocumentsDocumentIdDeleteError, DeleteDocumentV2V2HousesHouseIdDocumentsDocumentIdDeleteResponse, DeleteHouseHousesHouseIdDeleteData, DeleteHouseHousesHouseIdDeleteError, DeleteQrCodesEndpointHousesHouseIdQrCodesDeleteData, DeleteQrCodesEndpointHousesHouseIdQrCodesDeleteError, DeleteScopeConfigV2HousesHouseIdAssistantConfigDeleteData, DeleteScopeConfigV2HousesHouseIdAssistantConfigDeleteError, DeleteScopeConfigV2HousesHouseIdAssistantConfigDeleteResponse, DeleteUserUsersUserIdDeleteData, DeleteUserUsersUserIdDeleteError, DenyAccessGrantGuestAccessGrantIdDenyPostData, DenyAccessGrantGuestAccessGrantIdDenyPostError, DenyAccessGrantGuestAccessGrantIdDenyPostResponse, DenyViaMagicTokenGuestAccessManageDenyViaTokenPostData, DenyViaMagicTokenGuestAccessManageDenyViaTokenPostError, DenyViaMagicTokenGuestAccessManageDenyViaTokenPostResponse, DescribeRequestOauthAuthorizeRequestIdGetData, DescribeRequestOauthAuthorizeRequestIdGetError, DescribeRequestOauthAuthorizeRequestIdGetResponse, DownloadDocumentOptimizedHousesHouseIdDocumentsDocumentIdDownloadGetData, DownloadDocumentOptimizedHousesHouseIdDocumentsDocumentIdDownloadGetError, DrainRekicksEndpointObservabilityRekicksDrainPostData, DrainRekicksEndpointObservabilityRekicksDrainPostError, DrainRekicksEndpointObservabilityRekicksDrainPostResponse, EditContactCandidateHousesHouseIdContactsCandidatesExtractedContactIdPatchData, EditContactCandidateHousesHouseIdContactsCandidatesExtractedContactIdPatchError, EditContactCandidateHousesHouseIdContactsCandidatesExtractedContactIdPatchResponse, FinalizeHouseSetupHousesHouseIdFinalizePostData, FinalizeHouseSetupHousesHouseIdFinalizePostError, FinalizeHouseSetupHousesHouseIdFinalizePostResponse, FinalizeUserFinalizeUserPostData, FinalizeUserFinalizeUserPostError, FinalizeUserFinalizeUserPostResponse, ForgotPasswordForgotPasswordPostData, ForgotPasswordForgotPasswordPostError, ForgotPasswordForgotPasswordPostResponse, GenerateQrCodeEndpointHousesHouseIdQrCodeGuestPostData, GenerateQrCodeEndpointHousesHouseIdQrCodeGuestPostError, GetAvailableBundlesPropertyBundlesGetData, GetAvailableBundlesPropertyBundlesGetResponse, GetBatchDownloadUrlsHousesHouseIdDocumentsBatchDownloadUrlsPostData, GetBatchDownloadUrlsHousesHouseIdDocumentsBatchDownloadUrlsPostError, GetBatchDownloadUrlsHousesHouseIdDocumentsBatchDownloadUrlsPostResponse, GetBundlePropertyBundlesBundleIdGetData, GetBundlePropertyBundlesBundleIdGetError, GetBundlePropertyBundlesBundleIdGetResponse, GetCardTimelineV2HousesHouseIdMaintenanceTimelineGetData, GetCardTimelineV2HousesHouseIdMaintenanceTimelineGetError, GetCardTimelineV2HousesHouseIdMaintenanceTimelineGetResponse, GetClassificationTagsTagsClassificationsGetData, GetClassificationTagsTagsClassificationsGetError, GetClassificationTagsTagsClassificationsGetResponse, GetCreditBalanceCreditsBalanceGetData, GetCreditBalanceCreditsBalanceGetResponse, GetCurrentLegalVersionLegalCurrentVersionGetData, GetCurrentLegalVersionLegalCurrentVersionGetResponse, GetDatabaseConnectionsDiagnosticsDbConnectionsGetData, GetDatabaseConnectionsDiagnosticsDbConnectionsGetResponse, GetDiscardedCardsV2HousesHouseIdMaintenanceDiscardedGetData, GetDiscardedCardsV2HousesHouseIdMaintenanceDiscardedGetError, GetDiscardedCardsV2HousesHouseIdMaintenanceDiscardedGetResponse, GetDocumentHousesHouseIdDocumentsDocumentIdGetData, GetDocumentHousesHouseIdDocumentsDocumentIdGetError, GetDocumentHousesHouseIdDocumentsDocumentIdGetResponse, GetExchangeTraceV2HousesHouseIdAssistantExchangesExchangeIdTraceGetData, GetExchangeTraceV2HousesHouseIdAssistantExchangesExchangeIdTraceGetError, GetExchangeTraceV2HousesHouseIdAssistantExchangesExchangeIdTraceGetResponse, GetFeedbackStateV2HousesHouseIdAssistantFeedbackStateGetData, GetFeedbackStateV2HousesHouseIdAssistantFeedbackStateGetError, GetFeedbackStateV2HousesHouseIdAssistantFeedbackStateGetResponse, GetFullDiagnosticsDiagnosticsDbFullReportGetData, GetFullDiagnosticsDiagnosticsDbFullReportGetResponse, GetGrantInfoGuestAccessManageInfoGetData, GetGrantInfoGuestAccessManageInfoGetError, GetGrantInfoGuestAccessManageInfoGetResponse, GetGuestAccessStatusAccessStatusRequestIdGetData, GetGuestAccessStatusAccessStatusRequestIdGetError, GetGuestAccessStatusAccessStatusRequestIdGetResponse, GetGuestQrCodeImageHousesHouseIdQrCodeGuestGetData, GetGuestQrCodeImageHousesHouseIdQrCodeGuestGetError, GetHouseCriticalInfoHousesHouseIdCriticalInfoGetData, GetHouseCriticalInfoHousesHouseIdCriticalInfoGetError, GetHouseDocumentsStatusHousesHouseIdDocumentsStatusGetData, GetHouseDocumentsStatusHousesHouseIdDocumentsStatusGetError, GetHouseDocumentsStatusHousesHouseIdDocumentsStatusGetResponse, GetHouseDocumentsStatusV2HousesHouseIdDocumentsV2StatusGetData, GetHouseDocumentsStatusV2HousesHouseIdDocumentsV2StatusGetError, GetHouseDocumentsStatusV2HousesHouseIdDocumentsV2StatusGetResponse, GetHouseEmailAliasesHousesHouseIdAliasesGetData, GetHouseEmailAliasesHousesHouseIdAliasesGetError, GetHouseEmailAliasesHousesHouseIdAliasesGetResponse, GetHouseGrantsHousesHouseIdGuestAccessGrantsGetData, GetHouseGrantsHousesHouseIdGuestAccessGrantsGetError, GetHouseGrantsHousesHouseIdGuestAccessGrantsGetResponse, GetHousePipelineStatusV2HousesHouseIdPipelineV2StatusGetData, GetHousePipelineStatusV2HousesHouseIdPipelineV2StatusGetError, GetHousePipelineStatusV2HousesHouseIdPipelineV2StatusGetResponse, GetHouseSharingHousesHouseIdSharingGetData, GetHouseSharingHousesHouseIdSharingGetError, GetHouseSharingHousesHouseIdSharingGetResponse, GetHousesOfUserUsersUserIdHousesGetData, GetHousesOfUserUsersUserIdHousesGetError, GetHousesOfUserUsersUserIdHousesGetResponse, GetHouseTasksHousesHouseIdTasksGetData, GetHouseTasksHousesHouseIdTasksGetError, GetHouseTasksHousesHouseIdTasksGetResponse, GetKeyDocumentTagsHousesHouseIdDocumentsKeyDocTagsGetData, GetKeyDocumentTagsHousesHouseIdDocumentsKeyDocTagsGetError, GetKeyDocumentTagsHousesHouseIdDocumentsKeyDocTagsGetResponse, GetKeyUsersMeApiKeysPublicIdGetData, GetKeyUsersMeApiKeysPublicIdGetError, GetKeyUsersMeApiKeysPublicIdGetResponse, GetLongRunningConnectionsDiagnosticsDbLongRunningGetData, GetLongRunningConnectionsDiagnosticsDbLongRunningGetResponse, GetMagicTokenInfoGuestAccessMagicInfoGetData, GetMagicTokenInfoGuestAccessMagicInfoGetError, GetMagicTokenInfoGuestAccessMagicInfoGetResponse, GetMaintenancePlanV2HousesHouseIdMaintenancePlanGetData, GetMaintenancePlanV2HousesHouseIdMaintenancePlanGetError, GetMaintenancePlanV2HousesHouseIdMaintenancePlanGetResponse, GetMyOutgoingTransfersUsersMeOutgoingTransfersGetData, GetMyOutgoingTransfersUsersMeOutgoingTransfersGetResponse, GetMyPendingTransfersUsersMePendingTransfersGetData, GetMyPendingTransfersUsersMePendingTransfersGetResponse, GetNotificationHousesHouseIdNotificationsNotificationIdGetData, GetNotificationHousesHouseIdNotificationsNotificationIdGetError, GetNotificationHousesHouseIdNotificationsNotificationIdGetResponse, GetNotificationsHousesHouseIdNotificationsGetData, GetNotificationsHousesHouseIdNotificationsGetError, GetNotificationsHousesHouseIdNotificationsGetResponse, GetPendingPropertyTransferHousesHouseIdPendingTransferGetData, GetPendingPropertyTransferHousesHouseIdPendingTransferGetError, GetPendingPropertyTransferHousesHouseIdPendingTransferGetResponse, GetPendingShareHousesHouseIdDocumentsPendingShareIdGetData, GetPendingShareHousesHouseIdDocumentsPendingShareIdGetError, GetPendingShareHousesHouseIdDocumentsPendingShareIdGetResponse, GetPendingTransferDetailsPendingTransferTransferTokenGetData, GetPendingTransferDetailsPendingTransferTransferTokenGetError, GetPendingTransferDetailsPendingTransferTransferTokenGetResponse, GetPlaceInfoMapsPlacePlaceIdGetData, GetPlaceInfoMapsPlacePlaceIdGetError, GetPlaceInfoMapsPlacePlaceIdGetResponse, GetPoolStatsDiagnosticsDbPoolStatsGetData, GetPoolStatsDiagnosticsDbPoolStatsGetResponse, GetPropertyOwnershipHistoryHousesHouseIdOwnershipHistoryGetData, GetPropertyOwnershipHistoryHousesHouseIdOwnershipHistoryGetError, GetPropertyOwnershipHistoryHousesHouseIdOwnershipHistoryGetResponse, GetPropertyPaymentStatusHousesHouseIdPaymentStatusGetData, GetPropertyPaymentStatusHousesHouseIdPaymentStatusGetError, GetPropertyPaymentStatusHousesHouseIdPaymentStatusGetResponse, GetQrCodeSettingsEndpointHousesHouseIdQrCodeGuestSettingsGetData, GetQrCodeSettingsEndpointHousesHouseIdQrCodeGuestSettingsGetError, GetQrCodeSettingsEndpointHousesHouseIdQrCodeGuestSettingsGetResponse, GetResourceTasksResourcesResourceIdTasksGetData, GetResourceTasksResourcesResourceIdTasksGetError, GetResourceTasksResourcesResourceIdTasksGetResponse, GetRolloutEndpointObservabilityRolloutsRolloutIdGetData, GetRolloutEndpointObservabilityRolloutsRolloutIdGetError, GetSavedPaymentMethodMePaymentMethodGetData, GetSavedPaymentMethodMePaymentMethodGetResponse, GetScopeConfigV2HousesHouseIdAssistantConfigGetData, GetScopeConfigV2HousesHouseIdAssistantConfigGetError, GetScopeConfigV2HousesHouseIdAssistantConfigGetResponse, GetSharingUserActivityHousesHouseIdSharingUsersUserIdActivityGetData, GetSharingUserActivityHousesHouseIdSharingUsersUserIdActivityGetError, GetSharingUserActivityHousesHouseIdSharingUsersUserIdActivityGetResponse, GetStagedDocumentHousesHouseIdStagedDocumentsPublicIdGetData, GetStagedDocumentHousesHouseIdStagedDocumentsPublicIdGetError, GetStagedDocumentHousesHouseIdStagedDocumentsPublicIdGetResponse, GetSystemResourcesDiagnosticsSystemResourcesGetData, GetSystemResourcesDiagnosticsSystemResourcesGetResponse, GetTaskStatusPaginatedTasksStatusGetData, GetTaskStatusPaginatedTasksStatusGetError, GetTaskStatusPaginatedTasksStatusGetResponse, GetUserActivityHousesHouseIdUsersUserIdActivityGetData, GetUserActivityHousesHouseIdUsersUserIdActivityGetError, GetUserActivityHousesHouseIdUsersUserIdActivityGetResponse, GetUserCreditsAdminAdminUsersUserIdCreditsGetData, GetUserCreditsAdminAdminUsersUserIdCreditsGetError, GetUserCreditsAdminAdminUsersUserIdCreditsGetResponse, GetUsersOfHouseHousesHouseIdUsersGetData, GetUsersOfHouseHousesHouseIdUsersGetError, GetUsersOfHouseHousesHouseIdUsersGetResponse, GetUserUsersUserIdGetData, GetUserUsersUserIdGetError, GetUserUsersUserIdGetResponse, GoogleLoginGoogleTokenPostData, GoogleLoginGoogleTokenPostError, GoogleLoginGoogleTokenPostResponse, HealthCheckHealthGetData, InboundEmailHooksPostmarkInboundPostData, InboundEmailHooksPostmarkInboundPostError, IngestDeployObservabilityDeploysPostData, IngestDeployObservabilityDeploysPostError, IngestDeployObservabilityDeploysPostResponse, InteractivityObservabilitySlackInteractivityPostData, InviteSharingUserHousesHouseIdSharingUsersUserIdInvitePostData, InviteSharingUserHousesHouseIdSharingUsersUserIdInvitePostError, InviteSharingUserHousesHouseIdSharingUsersUserIdInvitePostResponse, ListArchivedPropertyContactsHousesHouseIdContactsArchivedGetData, ListArchivedPropertyContactsHousesHouseIdContactsArchivedGetError, ListArchivedPropertyContactsHousesHouseIdContactsArchivedGetResponse, ListAssistantSessionsV2HousesHouseIdAssistantSessionsGetData, ListAssistantSessionsV2HousesHouseIdAssistantSessionsGetError, ListAssistantSessionsV2HousesHouseIdAssistantSessionsGetResponse, ListBundleProposalsHousesHouseIdStagedDocumentsProposalsGetData, ListBundleProposalsHousesHouseIdStagedDocumentsProposalsGetError, ListBundleProposalsHousesHouseIdStagedDocumentsProposalsGetResponse, ListContactCandidatesHousesHouseIdContactsCandidatesGetData, ListContactCandidatesHousesHouseIdContactsCandidatesGetError, ListContactCandidatesHousesHouseIdContactsCandidatesGetResponse, ListContactTaxonomyHousesHouseIdContactsTaxonomyGetData, ListContactTaxonomyHousesHouseIdContactsTaxonomyGetError, ListContactTaxonomyHousesHouseIdContactsTaxonomyGetResponse, ListDiscardedContactCandidatesHousesHouseIdContactsCandidatesDiscardedGetData, ListDiscardedContactCandidatesHousesHouseIdContactsCandidatesDiscardedGetError, ListDiscardedContactCandidatesHousesHouseIdContactsCandidatesDiscardedGetResponse, ListDocumentsHousesHouseIdDocumentsGetData, ListDocumentsHousesHouseIdDocumentsGetError, ListDocumentsHousesHouseIdDocumentsGetResponse, ListFeedbackV2HousesHouseIdAssistantFeedbackGetData, ListFeedbackV2HousesHouseIdAssistantFeedbackGetError, ListFeedbackV2HousesHouseIdAssistantFeedbackGetResponse, ListGrantableScopesUsersMeApiKeysScopesGetData, ListGrantableScopesUsersMeApiKeysScopesGetError, ListGrantableScopesUsersMeApiKeysScopesGetResponse, ListHouseCorrectionsHousesHouseIdCorrectionsGetData, ListHouseCorrectionsHousesHouseIdCorrectionsGetError, ListHouseCorrectionsHousesHouseIdCorrectionsGetResponse, ListKeysUsersMeApiKeysGetData, ListKeysUsersMeApiKeysGetError, ListKeysUsersMeApiKeysGetResponse, ListPropertyContactsHousesHouseIdContactsGetData, ListPropertyContactsHousesHouseIdContactsGetError, ListPropertyContactsHousesHouseIdContactsGetResponse, ListReceivedPendingSharesHousesHouseIdDocumentsPendingReceivedGetData, ListReceivedPendingSharesHousesHouseIdDocumentsPendingReceivedGetError, ListReceivedPendingSharesHousesHouseIdDocumentsPendingReceivedGetResponse, ListRolloutsEndpointObservabilityRolloutsGetData, ListSentPendingSharesHousesHouseIdDocumentsPendingSentGetData, ListSentPendingSharesHousesHouseIdDocumentsPendingSentGetError, ListSentPendingSharesHousesHouseIdDocumentsPendingSentGetResponse, ListServiceCategoriesServiceCategoriesGetData, ListServiceCategoriesServiceCategoriesGetResponse, ListSessionExchangesV2HousesHouseIdAssistantSessionsSessionIdExchangesGetData, ListSessionExchangesV2HousesHouseIdAssistantSessionsSessionIdExchangesGetError, ListSessionExchangesV2HousesHouseIdAssistantSessionsSessionIdExchangesGetResponse, ListStagedDocumentsHousesHouseIdStagedDocumentsGetData, ListStagedDocumentsHousesHouseIdStagedDocumentsGetError, ListStagedDocumentsHousesHouseIdStagedDocumentsGetResponse, LockRolloutEndpointObservabilityRolloutsRolloutIdLockPostData, LockRolloutEndpointObservabilityRolloutsRolloutIdLockPostError, LoginForAccessTokenTokenPostData, LoginForAccessTokenTokenPostError, LoginForAccessTokenTokenPostResponse, ManageGuestAccessHousesHouseIdGuestAccessGrantIdAccessPutData, ManageGuestAccessHousesHouseIdGuestAccessGrantIdAccessPutError, ManageGuestAccessHousesHouseIdGuestAccessGrantIdAccessPutResponse, MarkNotificationAsReadHousesHouseIdNotificationsNotificationIdReadPostData, MarkNotificationAsReadHousesHouseIdNotificationsNotificationIdReadPostError, PauseRolloutEndpointObservabilityRolloutsRolloutIdPausePostData, PauseRolloutEndpointObservabilityRolloutsRolloutIdPausePostError, PostPlanActionV2HousesHouseIdMaintenanceActionsPostData, PostPlanActionV2HousesHouseIdMaintenanceActionsPostError, PostPlanActionV2HousesHouseIdMaintenanceActionsPostResponse, PreviewRolloutEndpointObservabilityRolloutsRolloutIdPreviewPostData, PreviewRolloutEndpointObservabilityRolloutsRolloutIdPreviewPostError, PromoteStagedDocumentHousesHouseIdStagedDocumentsPublicIdPromotePostData, PromoteStagedDocumentHousesHouseIdStagedDocumentsPublicIdPromotePostError, PromoteStagedDocumentHousesHouseIdStagedDocumentsPublicIdPromotePostResponse, PromoteStagedDocumentsHousesHouseIdStagedDocumentsPromotePostData, PromoteStagedDocumentsHousesHouseIdStagedDocumentsPromotePostError, PromoteStagedDocumentsHousesHouseIdStagedDocumentsPromotePostResponse, QrLandingPageQrPropertyPublicIdGetData, QrLandingPageQrPropertyPublicIdGetError, QrLandingPageQrPropertyPublicIdGetResponse, ReadHouseHousesHouseIdGetData, ReadHouseHousesHouseIdGetError, ReadHouseHousesHouseIdGetResponse, ReadHousesHousesGetData, ReadHousesHousesGetError, ReadHousesHousesGetResponse, ReadinessCheckGreenthumbGetData, ReadRegistrationOauthRegisterClientIdGetData, ReadRegistrationOauthRegisterClientIdGetError, ReadRegistrationOauthRegisterClientIdGetResponse, ReadRootGetData, ReadUsersMeUsersMeGetData, ReadUsersMeUsersMeGetResponse, ReadUsersUsersGetData, ReadUsersUsersGetError, ReadUsersUsersGetResponse, RedeemMagicTokenGuestAccessMagicRedeemPostData, RedeemMagicTokenGuestAccessMagicRedeemPostError, RedeemMagicTokenGuestAccessMagicRedeemPostResponse, RefreshAccessTokenTokenRefreshPostData, RefreshAccessTokenTokenRefreshPostError, RefreshAccessTokenTokenRefreshPostResponse, RefuseBundleProposalHousesHouseIdStagedDocumentsProposalsPublicIdRefusePostData, RefuseBundleProposalHousesHouseIdStagedDocumentsProposalsPublicIdRefusePostError, RefuseBundleProposalHousesHouseIdStagedDocumentsProposalsPublicIdRefusePostResponse, RefuseOauthAuthorizeRequestIdRefusePostData, RefuseOauthAuthorizeRequestIdRefusePostError, RefuseOauthAuthorizeRequestIdRefusePostResponse, RegisterGoogleUserUsersGooglePostData, RegisterGoogleUserUsersGooglePostError, RegisterGoogleUserUsersGooglePostResponse, RegisterOauthRegisterPostData, RegisterOauthRegisterPostError, RegisterOauthRegisterPostResponse, RegisterUserUsersPostData, RegisterUserUsersPostError, RegisterUserUsersPostResponse, RegistrationIsNotEditableOauthRegisterClientIdPutData, RegistrationIsNotEditableOauthRegisterClientIdPutError, RejectExtractedContactHousesHouseIdContactsCandidatesExtractedContactIdDiscardPostData, RejectExtractedContactHousesHouseIdContactsCandidatesExtractedContactIdDiscardPostError, RejectStagedDocumentHousesHouseIdStagedDocumentsPublicIdRejectPostData, RejectStagedDocumentHousesHouseIdStagedDocumentsPublicIdRejectPostError, RejectStagedDocumentHousesHouseIdStagedDocumentsPublicIdRejectPostResponse, RejectStagedDocumentsHousesHouseIdStagedDocumentsRejectPostData, RejectStagedDocumentsHousesHouseIdStagedDocumentsRejectPostError, RejectStagedDocumentsHousesHouseIdStagedDocumentsRejectPostResponse, ReleaseRolloutEndpointObservabilityRolloutsRolloutIdReleasePostData, ReleaseRolloutEndpointObservabilityRolloutsRolloutIdReleasePostError, RemoveContactFromPropertyHousesHouseIdContactsPropertyContactIdDeleteData, RemoveContactFromPropertyHousesHouseIdContactsPropertyContactIdDeleteError, RemoveRegistrationOauthRegisterClientIdDeleteData, RemoveRegistrationOauthRegisterClientIdDeleteError, RemoveRegistrationOauthRegisterClientIdDeleteResponse, RemoveSharingUserHousesHouseIdSharingUsersUserIdDeleteData, RemoveSharingUserHousesHouseIdSharingUsersUserIdDeleteError, RemoveSharingUserHousesHouseIdSharingUsersUserIdDeleteResponse, RemoveTagFromDocumentDocumentsTagsDeleteData, RemoveTagFromDocumentDocumentsTagsDeleteError, RemoveTagFromDocumentDocumentsTagsDeleteResponse, RemoveUserFromHouseHousesHouseIdUsersUserIdDeleteData, RemoveUserFromHouseHousesHouseIdUsersUserIdDeleteError, RemoveUserFromHouseHousesHouseIdUsersUserIdDeleteResponse, ReplaceTagInDocumentHousesHouseIdDocumentsTagsPutData, ReplaceTagInDocumentHousesHouseIdDocumentsTagsPutError, ReplaceTagInDocumentHousesHouseIdDocumentsTagsPutResponse, RequestGuestAccessHousesHouseIdAccessRequestPostData, RequestGuestAccessHousesHouseIdAccessRequestPostError, RequestGuestAccessHousesHouseIdAccessRequestPostResponse, RequestGuestCodeGuestAccessMagicCodePostData, RequestGuestCodeGuestAccessMagicCodePostError, RequestGuestCodeGuestAccessMagicCodePostResponse, ResetPasswordResetPasswordPostData, ResetPasswordResetPasswordPostError, ResetPasswordResetPasswordPostResponse, RestoreContactToPropertyHousesHouseIdContactsPropertyContactIdRestorePostData, RestoreContactToPropertyHousesHouseIdContactsPropertyContactIdRestorePostError, RestoreContactToPropertyHousesHouseIdContactsPropertyContactIdRestorePostResponse, ResumeRolloutEndpointObservabilityRolloutsRolloutIdResumePostData, ResumeRolloutEndpointObservabilityRolloutsRolloutIdResumePostError, RetryTransferFinalizationPendingTransferTransferIdRetryPostData, RetryTransferFinalizationPendingTransferTransferIdRetryPostError, RetryTransferFinalizationPendingTransferTransferIdRetryPostResponse, RevokeKeyUsersMeApiKeysPublicIdDeleteData, RevokeKeyUsersMeApiKeysPublicIdDeleteError, RevokeKeyUsersMeApiKeysPublicIdDeleteResponse, RevokeOauthRevokePostData, RevokeOauthRevokePostError, RunStressTestDiagnosticsDbStressTestPostData, RunStressTestDiagnosticsDbStressTestPostError, RunStressTestDiagnosticsDbStressTestPostResponse, SearchPlacesMapsAutocompleteGetData, SearchPlacesMapsAutocompleteGetError, SearchPlacesMapsAutocompleteGetResponse, SendWelcomeEmailEndpointHousesHouseIdOnboardedPostData, SendWelcomeEmailEndpointHousesHouseIdOnboardedPostError, SendWelcomeEmailEndpointHousesHouseIdOnboardedPostResponse, ShareDocumentsWithOwnerEndpointHousesHouseIdDocumentsSharePostData, ShareDocumentsWithOwnerEndpointHousesHouseIdDocumentsSharePostError, ShareDocumentsWithOwnerEndpointHousesHouseIdDocumentsSharePostResponse, SlashCommandObservabilitySlackCommandPostData, StartAuthorizationOauthAuthorizePostData, StartAuthorizationOauthAuthorizePostError, StartAuthorizationOauthAuthorizePostResponse, StripeWebhookStripeWebhookPostData, SubmitAccessRequestHousesHouseIdGuestAccessRequestsPostData, SubmitAccessRequestHousesHouseIdGuestAccessRequestsPostError, SubmitAccessRequestHousesHouseIdGuestAccessRequestsPostResponse, SubmitFeedbackV2HousesHouseIdAssistantFeedbackPostData, SubmitFeedbackV2HousesHouseIdAssistantFeedbackPostError, SubmitFeedbackV2HousesHouseIdAssistantFeedbackPostResponse, TokenOauthTokenPostData, TokenOauthTokenPostError, UndoContactDecisionHousesHouseIdContactsCandidatesExtractedContactIdUndoPostData, UndoContactDecisionHousesHouseIdContactsCandidatesExtractedContactIdUndoPostError, UndoContactDecisionHousesHouseIdContactsCandidatesExtractedContactIdUndoPostResponse, UpdateDocumentHousesHouseIdDocumentsDocumentIdPutData, UpdateDocumentHousesHouseIdDocumentsDocumentIdPutError, UpdateDocumentHousesHouseIdDocumentsDocumentIdPutResponse, UpdateDocumentVisibilityHousesHouseIdDocumentsDocumentIdVisibilityPatchData, UpdateDocumentVisibilityHousesHouseIdDocumentsDocumentIdVisibilityPatchError, UpdateDocumentVisibilityHousesHouseIdDocumentsDocumentIdVisibilityPatchResponse, UpdateHouseCriticalInfoHousesHouseIdCriticalInfoPutData, UpdateHouseCriticalInfoHousesHouseIdCriticalInfoPutError, UpdateHouseCriticalInfoHousesHouseIdCriticalInfoPutResponse, UpdateHouseHousesHouseIdPutData, UpdateHouseHousesHouseIdPutError, UpdateHouseHousesHouseIdPutResponse, UpdatePendingShareStatusHousesHouseIdDocumentsPendingShareIdStatusPutData, UpdatePendingShareStatusHousesHouseIdDocumentsPendingShareIdStatusPutError, UpdatePendingShareStatusHousesHouseIdDocumentsPendingShareIdStatusPutResponse, UpdatePropertyContactHousesHouseIdContactsPropertyContactIdPutData, UpdatePropertyContactHousesHouseIdContactsPropertyContactIdPutError, UpdatePropertyContactHousesHouseIdContactsPropertyContactIdPutResponse, UpdateQrCodeSettingsEndpointHousesHouseIdQrCodeGuestSettingsPatchData, UpdateQrCodeSettingsEndpointHousesHouseIdQrCodeGuestSettingsPatchError, UpdateQrCodeSettingsEndpointHousesHouseIdQrCodeGuestSettingsPatchResponse, UpdateSharingUserExpiryHousesHouseIdSharingUsersUserIdExpiryPatchData, UpdateSharingUserExpiryHousesHouseIdSharingUsersUserIdExpiryPatchError, UpdateSharingUserExpiryHousesHouseIdSharingUsersUserIdExpiryPatchResponse, UpdateSharingUserRoleHousesHouseIdSharingUsersUserIdPatchData, UpdateSharingUserRoleHousesHouseIdSharingUsersUserIdPatchError, UpdateSharingUserRoleHousesHouseIdSharingUsersUserIdPatchResponse, UpdateTosAcceptanceMeTosAcceptancePutData, UpdateTosAcceptanceMeTosAcceptancePutError, UpdateTosAcceptanceMeTosAcceptancePutResponse, UpdateUserUsersUserIdPutData, UpdateUserUsersUserIdPutError, UpdateUserUsersUserIdPutResponse, UploadDocumentsV2V2HousesHouseIdDocumentsPostData, UploadDocumentsV2V2HousesHouseIdDocumentsPostError, UploadDocumentsV2V2HousesHouseIdDocumentsPostResponse, UpsertScopeConfigV2HousesHouseIdAssistantConfigPutData, UpsertScopeConfigV2HousesHouseIdAssistantConfigPutError, UpsertScopeConfigV2HousesHouseIdAssistantConfigPutResponse, VerifyCreditPurchaseCreditsVerifyPurchasePostData, VerifyCreditPurchaseCreditsVerifyPurchasePostError, VerifyGuestCodeGuestAccessMagicVerifyPostData, VerifyGuestCodeGuestAccessMagicVerifyPostError, VerifyGuestCodeGuestAccessMagicVerifyPostResponse } from '../types.gen';

/**
 * Assistant Turn
 */
export const assistantTurnV2HousesHouseIdAssistantTurnPostMutation = (options?: Partial<Options<AssistantTurnV2HousesHouseIdAssistantTurnPostData>>): UseMutationOptions<AssistantTurnV2HousesHouseIdAssistantTurnPostResponse, AxiosError<AssistantTurnV2HousesHouseIdAssistantTurnPostError>, Options<AssistantTurnV2HousesHouseIdAssistantTurnPostData>> => {
    const mutationOptions: UseMutationOptions<AssistantTurnV2HousesHouseIdAssistantTurnPostResponse, AxiosError<AssistantTurnV2HousesHouseIdAssistantTurnPostError>, Options<AssistantTurnV2HousesHouseIdAssistantTurnPostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await AssistantV2.assistantTurnV2HousesHouseIdAssistantTurnPost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Assistant Turn Stream
 */
export const assistantTurnStreamV2HousesHouseIdAssistantTurnStreamPostMutation = (options?: Partial<Options<AssistantTurnStreamV2HousesHouseIdAssistantTurnStreamPostData>>): UseMutationOptions<AssistantTurnStreamV2HousesHouseIdAssistantTurnStreamPostResponse, AxiosError<AssistantTurnStreamV2HousesHouseIdAssistantTurnStreamPostError>, Options<AssistantTurnStreamV2HousesHouseIdAssistantTurnStreamPostData>> => {
    const mutationOptions: UseMutationOptions<AssistantTurnStreamV2HousesHouseIdAssistantTurnStreamPostResponse, AxiosError<AssistantTurnStreamV2HousesHouseIdAssistantTurnStreamPostError>, Options<AssistantTurnStreamV2HousesHouseIdAssistantTurnStreamPostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await AssistantV2.assistantTurnStreamV2HousesHouseIdAssistantTurnStreamPost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export type QueryKey<TOptions extends Options> = [
    Pick<TOptions, 'baseURL' | 'body' | 'headers' | 'path' | 'query'> & {
        _id: string;
        _infinite?: boolean;
        tags?: ReadonlyArray<string>;
    }
];

const createQueryKey = <TOptions extends Options>(id: string, options?: TOptions, infinite?: boolean, tags?: ReadonlyArray<string>): [
    QueryKey<TOptions>[0]
] => {
    const params: QueryKey<TOptions>[0] = { _id: id, baseURL: options?.baseURL || (options?.client ?? client).getConfig().baseURL } as QueryKey<TOptions>[0];
    if (infinite) {
        params._infinite = infinite;
    }
    if (tags) {
        params.tags = tags;
    }
    if (options?.body) {
        params.body = options.body;
    }
    if (options?.headers) {
        params.headers = options.headers;
    }
    if (options?.path) {
        params.path = options.path;
    }
    if (options?.query) {
        params.query = options.query;
    }
    return [params];
};

export const listAssistantSessionsV2HousesHouseIdAssistantSessionsGetQueryKey = (options: Options<ListAssistantSessionsV2HousesHouseIdAssistantSessionsGetData>) => createQueryKey('listAssistantSessionsV2HousesHouseIdAssistantSessionsGet', options);

/**
 * List Assistant Sessions
 */
export const listAssistantSessionsV2HousesHouseIdAssistantSessionsGetOptions = (options: Options<ListAssistantSessionsV2HousesHouseIdAssistantSessionsGetData>) => queryOptions<ListAssistantSessionsV2HousesHouseIdAssistantSessionsGetResponse, AxiosError<ListAssistantSessionsV2HousesHouseIdAssistantSessionsGetError>, ListAssistantSessionsV2HousesHouseIdAssistantSessionsGetResponse, ReturnType<typeof listAssistantSessionsV2HousesHouseIdAssistantSessionsGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await AssistantV2.listAssistantSessionsV2HousesHouseIdAssistantSessionsGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listAssistantSessionsV2HousesHouseIdAssistantSessionsGetQueryKey(options)
});

export const listSessionExchangesV2HousesHouseIdAssistantSessionsSessionIdExchangesGetQueryKey = (options: Options<ListSessionExchangesV2HousesHouseIdAssistantSessionsSessionIdExchangesGetData>) => createQueryKey('listSessionExchangesV2HousesHouseIdAssistantSessionsSessionIdExchangesGet', options);

/**
 * List Session Exchanges
 */
export const listSessionExchangesV2HousesHouseIdAssistantSessionsSessionIdExchangesGetOptions = (options: Options<ListSessionExchangesV2HousesHouseIdAssistantSessionsSessionIdExchangesGetData>) => queryOptions<ListSessionExchangesV2HousesHouseIdAssistantSessionsSessionIdExchangesGetResponse, AxiosError<ListSessionExchangesV2HousesHouseIdAssistantSessionsSessionIdExchangesGetError>, ListSessionExchangesV2HousesHouseIdAssistantSessionsSessionIdExchangesGetResponse, ReturnType<typeof listSessionExchangesV2HousesHouseIdAssistantSessionsSessionIdExchangesGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await AssistantV2.listSessionExchangesV2HousesHouseIdAssistantSessionsSessionIdExchangesGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listSessionExchangesV2HousesHouseIdAssistantSessionsSessionIdExchangesGetQueryKey(options)
});

export const listFeedbackV2HousesHouseIdAssistantFeedbackGetQueryKey = (options: Options<ListFeedbackV2HousesHouseIdAssistantFeedbackGetData>) => createQueryKey('listFeedbackV2HousesHouseIdAssistantFeedbackGet', options);

/**
 * List Feedback
 *
 * List full feedback records for a house — **admin/internal only**.
 *
 * This is the operational/admin view: it returns complete records (incl. comments and other
 * users' feedback) and is the place that may grow to include more metadata. Normal users do NOT
 * get a feedback-listing endpoint; they hydrate their own thumb state via
 * `GET .../assistant/feedback/state` instead.
 *
 * - Filter by rating with ?rating=thumbs_up or ?rating=thumbs_down.
 * - Results are ordered most-recent first (by id desc).
 * - Paginate with ?cursor=<last_feedback_id> to get the next page.
 */
export const listFeedbackV2HousesHouseIdAssistantFeedbackGetOptions = (options: Options<ListFeedbackV2HousesHouseIdAssistantFeedbackGetData>) => queryOptions<ListFeedbackV2HousesHouseIdAssistantFeedbackGetResponse, AxiosError<ListFeedbackV2HousesHouseIdAssistantFeedbackGetError>, ListFeedbackV2HousesHouseIdAssistantFeedbackGetResponse, ReturnType<typeof listFeedbackV2HousesHouseIdAssistantFeedbackGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await AssistantV2.listFeedbackV2HousesHouseIdAssistantFeedbackGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listFeedbackV2HousesHouseIdAssistantFeedbackGetQueryKey(options)
});

const createInfiniteParams = <K extends Pick<QueryKey<Options>[0], 'body' | 'headers' | 'path' | 'query'>>(queryKey: QueryKey<Options>, page: K) => {
    const params = { ...queryKey[0] };
    if (page.body) {
        params.body = {
            ...queryKey[0].body as any,
            ...page.body as any
        };
    }
    if (page.headers) {
        params.headers = {
            ...queryKey[0].headers,
            ...page.headers
        };
    }
    if (page.path) {
        params.path = {
            ...queryKey[0].path as any,
            ...page.path as any
        };
    }
    if (page.query) {
        params.query = {
            ...queryKey[0].query as any,
            ...page.query as any
        };
    }
    return params as unknown as typeof page;
};

export const listFeedbackV2HousesHouseIdAssistantFeedbackGetInfiniteQueryKey = (options: Options<ListFeedbackV2HousesHouseIdAssistantFeedbackGetData>): QueryKey<Options<ListFeedbackV2HousesHouseIdAssistantFeedbackGetData>> => createQueryKey('listFeedbackV2HousesHouseIdAssistantFeedbackGet', options, true);

/**
 * List Feedback
 *
 * List full feedback records for a house — **admin/internal only**.
 *
 * This is the operational/admin view: it returns complete records (incl. comments and other
 * users' feedback) and is the place that may grow to include more metadata. Normal users do NOT
 * get a feedback-listing endpoint; they hydrate their own thumb state via
 * `GET .../assistant/feedback/state` instead.
 *
 * - Filter by rating with ?rating=thumbs_up or ?rating=thumbs_down.
 * - Results are ordered most-recent first (by id desc).
 * - Paginate with ?cursor=<last_feedback_id> to get the next page.
 */
export const listFeedbackV2HousesHouseIdAssistantFeedbackGetInfiniteOptions = (options: Options<ListFeedbackV2HousesHouseIdAssistantFeedbackGetData>) => infiniteQueryOptions<ListFeedbackV2HousesHouseIdAssistantFeedbackGetResponse, AxiosError<ListFeedbackV2HousesHouseIdAssistantFeedbackGetError>, InfiniteData<ListFeedbackV2HousesHouseIdAssistantFeedbackGetResponse>, QueryKey<Options<ListFeedbackV2HousesHouseIdAssistantFeedbackGetData>>, number | null | Pick<QueryKey<Options<ListFeedbackV2HousesHouseIdAssistantFeedbackGetData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<ListFeedbackV2HousesHouseIdAssistantFeedbackGetData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                cursor: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await AssistantV2.listFeedbackV2HousesHouseIdAssistantFeedbackGet({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listFeedbackV2HousesHouseIdAssistantFeedbackGetInfiniteQueryKey(options)
});

/**
 * Submit Feedback
 *
 * Submit explicit feedback (thumbs up/down) for an assistant exchange.
 *
 * - Requires ASSISTANT_QUERY on the house (any member who can use the assistant).
 * - exchange_id must belong to the authenticated user for this house.
 * - Duplicate submissions for the same exchange_id are idempotent: the
 * original feedback record is returned unchanged.
 * - On thumbs_down, the pending Redis trace (if available) is promoted to
 * durable storage and trace_captured=True is returned.
 */
export const submitFeedbackV2HousesHouseIdAssistantFeedbackPostMutation = (options?: Partial<Options<SubmitFeedbackV2HousesHouseIdAssistantFeedbackPostData>>): UseMutationOptions<SubmitFeedbackV2HousesHouseIdAssistantFeedbackPostResponse, AxiosError<SubmitFeedbackV2HousesHouseIdAssistantFeedbackPostError>, Options<SubmitFeedbackV2HousesHouseIdAssistantFeedbackPostData>> => {
    const mutationOptions: UseMutationOptions<SubmitFeedbackV2HousesHouseIdAssistantFeedbackPostResponse, AxiosError<SubmitFeedbackV2HousesHouseIdAssistantFeedbackPostError>, Options<SubmitFeedbackV2HousesHouseIdAssistantFeedbackPostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await AssistantV2.submitFeedbackV2HousesHouseIdAssistantFeedbackPost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getFeedbackStateV2HousesHouseIdAssistantFeedbackStateGetQueryKey = (options: Options<GetFeedbackStateV2HousesHouseIdAssistantFeedbackStateGetData>) => createQueryKey('getFeedbackStateV2HousesHouseIdAssistantFeedbackStateGet', options);

/**
 * Get Feedback State
 *
 * The current user's feedback state on this house — (exchange_id, rating) pairs only.
 *
 * Used by the client to render thumbs as already-rated. Deliberately minimal: no comments, no
 * metadata, no other users' feedback — that is the admin-only `list_feedback` endpoint's job. This
 * keeps the normal-user surface as lightweight feedback *state*, not feedback *browsing*.
 */
export const getFeedbackStateV2HousesHouseIdAssistantFeedbackStateGetOptions = (options: Options<GetFeedbackStateV2HousesHouseIdAssistantFeedbackStateGetData>) => queryOptions<GetFeedbackStateV2HousesHouseIdAssistantFeedbackStateGetResponse, AxiosError<GetFeedbackStateV2HousesHouseIdAssistantFeedbackStateGetError>, GetFeedbackStateV2HousesHouseIdAssistantFeedbackStateGetResponse, ReturnType<typeof getFeedbackStateV2HousesHouseIdAssistantFeedbackStateGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await AssistantV2.getFeedbackStateV2HousesHouseIdAssistantFeedbackStateGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getFeedbackStateV2HousesHouseIdAssistantFeedbackStateGetQueryKey(options)
});

export const getExchangeTraceV2HousesHouseIdAssistantExchangesExchangeIdTraceGetQueryKey = (options: Options<GetExchangeTraceV2HousesHouseIdAssistantExchangesExchangeIdTraceGetData>) => createQueryKey('getExchangeTraceV2HousesHouseIdAssistantExchangesExchangeIdTraceGet', options);

/**
 * Get Exchange Trace
 *
 * Return the promoted debug trace for an exchange (admin only).
 *
 * Returns 404 if no trace has been promoted for this exchange (i.e. no
 * thumbs_down feedback was submitted while a pending trace was buffered).
 */
export const getExchangeTraceV2HousesHouseIdAssistantExchangesExchangeIdTraceGetOptions = (options: Options<GetExchangeTraceV2HousesHouseIdAssistantExchangesExchangeIdTraceGetData>) => queryOptions<GetExchangeTraceV2HousesHouseIdAssistantExchangesExchangeIdTraceGetResponse, AxiosError<GetExchangeTraceV2HousesHouseIdAssistantExchangesExchangeIdTraceGetError>, GetExchangeTraceV2HousesHouseIdAssistantExchangesExchangeIdTraceGetResponse, ReturnType<typeof getExchangeTraceV2HousesHouseIdAssistantExchangesExchangeIdTraceGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await AssistantV2.getExchangeTraceV2HousesHouseIdAssistantExchangesExchangeIdTraceGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getExchangeTraceV2HousesHouseIdAssistantExchangesExchangeIdTraceGetQueryKey(options)
});

/**
 * Delete Scope Config
 *
 * Delete the RAG scope config override for a house, reverting to code defaults.
 */
export const deleteScopeConfigV2HousesHouseIdAssistantConfigDeleteMutation = (options?: Partial<Options<DeleteScopeConfigV2HousesHouseIdAssistantConfigDeleteData>>): UseMutationOptions<DeleteScopeConfigV2HousesHouseIdAssistantConfigDeleteResponse, AxiosError<DeleteScopeConfigV2HousesHouseIdAssistantConfigDeleteError>, Options<DeleteScopeConfigV2HousesHouseIdAssistantConfigDeleteData>> => {
    const mutationOptions: UseMutationOptions<DeleteScopeConfigV2HousesHouseIdAssistantConfigDeleteResponse, AxiosError<DeleteScopeConfigV2HousesHouseIdAssistantConfigDeleteError>, Options<DeleteScopeConfigV2HousesHouseIdAssistantConfigDeleteData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await AssistantV2.deleteScopeConfigV2HousesHouseIdAssistantConfigDelete({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getScopeConfigV2HousesHouseIdAssistantConfigGetQueryKey = (options: Options<GetScopeConfigV2HousesHouseIdAssistantConfigGetData>) => createQueryKey('getScopeConfigV2HousesHouseIdAssistantConfigGet', options);

/**
 * Get Scope Config
 *
 * Return the RAG scope config for a house. Returns 404 if no override is set.
 */
export const getScopeConfigV2HousesHouseIdAssistantConfigGetOptions = (options: Options<GetScopeConfigV2HousesHouseIdAssistantConfigGetData>) => queryOptions<GetScopeConfigV2HousesHouseIdAssistantConfigGetResponse, AxiosError<GetScopeConfigV2HousesHouseIdAssistantConfigGetError>, GetScopeConfigV2HousesHouseIdAssistantConfigGetResponse, ReturnType<typeof getScopeConfigV2HousesHouseIdAssistantConfigGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await AssistantV2.getScopeConfigV2HousesHouseIdAssistantConfigGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getScopeConfigV2HousesHouseIdAssistantConfigGetQueryKey(options)
});

/**
 * Upsert Scope Config
 *
 * Create or update the RAG scope config for a house.
 *
 * Passing system_prompt=null clears the override (deletes the row) and
 * reverts to code defaults, equivalent to calling DELETE.
 */
export const upsertScopeConfigV2HousesHouseIdAssistantConfigPutMutation = (options?: Partial<Options<UpsertScopeConfigV2HousesHouseIdAssistantConfigPutData>>): UseMutationOptions<UpsertScopeConfigV2HousesHouseIdAssistantConfigPutResponse, AxiosError<UpsertScopeConfigV2HousesHouseIdAssistantConfigPutError>, Options<UpsertScopeConfigV2HousesHouseIdAssistantConfigPutData>> => {
    const mutationOptions: UseMutationOptions<UpsertScopeConfigV2HousesHouseIdAssistantConfigPutResponse, AxiosError<UpsertScopeConfigV2HousesHouseIdAssistantConfigPutError>, Options<UpsertScopeConfigV2HousesHouseIdAssistantConfigPutData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await AssistantV2.upsertScopeConfigV2HousesHouseIdAssistantConfigPut({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const readUsersUsersGetQueryKey = (options?: Options<ReadUsersUsersGetData>) => createQueryKey('readUsersUsersGet', options);

/**
 * Read Users
 */
export const readUsersUsersGetOptions = (options?: Options<ReadUsersUsersGetData>) => queryOptions<ReadUsersUsersGetResponse, AxiosError<ReadUsersUsersGetError>, ReadUsersUsersGetResponse, ReturnType<typeof readUsersUsersGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await Users.readUsersUsersGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: readUsersUsersGetQueryKey(options)
});

/**
 * Register User
 */
export const registerUserUsersPostMutation = (options?: Partial<Options<RegisterUserUsersPostData>>): UseMutationOptions<RegisterUserUsersPostResponse, AxiosError<RegisterUserUsersPostError>, Options<RegisterUserUsersPostData>> => {
    const mutationOptions: UseMutationOptions<RegisterUserUsersPostResponse, AxiosError<RegisterUserUsersPostError>, Options<RegisterUserUsersPostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await UserRegistration.registerUserUsersPost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Change Password
 */
export const changePasswordMeChangePasswordPostMutation = (options?: Partial<Options<ChangePasswordMeChangePasswordPostData>>): UseMutationOptions<ChangePasswordMeChangePasswordPostResponse, AxiosError<ChangePasswordMeChangePasswordPostError>, Options<ChangePasswordMeChangePasswordPostData>> => {
    const mutationOptions: UseMutationOptions<ChangePasswordMeChangePasswordPostResponse, AxiosError<ChangePasswordMeChangePasswordPostError>, Options<ChangePasswordMeChangePasswordPostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await Users.changePasswordMeChangePasswordPost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const readUsersMeUsersMeGetQueryKey = (options?: Options<ReadUsersMeUsersMeGetData>) => createQueryKey('readUsersMeUsersMeGet', options);

/**
 * Read Users Me
 */
export const readUsersMeUsersMeGetOptions = (options?: Options<ReadUsersMeUsersMeGetData>) => queryOptions<ReadUsersMeUsersMeGetResponse, AxiosError<DefaultError>, ReadUsersMeUsersMeGetResponse, ReturnType<typeof readUsersMeUsersMeGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await Users.readUsersMeUsersMeGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: readUsersMeUsersMeGetQueryKey(options)
});

/**
 * Delete User
 */
export const deleteUserUsersUserIdDeleteMutation = (options?: Partial<Options<DeleteUserUsersUserIdDeleteData>>): UseMutationOptions<unknown, AxiosError<DeleteUserUsersUserIdDeleteError>, Options<DeleteUserUsersUserIdDeleteData>> => {
    const mutationOptions: UseMutationOptions<unknown, AxiosError<DeleteUserUsersUserIdDeleteError>, Options<DeleteUserUsersUserIdDeleteData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await Users.deleteUserUsersUserIdDelete({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getUserUsersUserIdGetQueryKey = (options: Options<GetUserUsersUserIdGetData>) => createQueryKey('getUserUsersUserIdGet', options);

/**
 * Get User
 */
export const getUserUsersUserIdGetOptions = (options: Options<GetUserUsersUserIdGetData>) => queryOptions<GetUserUsersUserIdGetResponse, AxiosError<GetUserUsersUserIdGetError>, GetUserUsersUserIdGetResponse, ReturnType<typeof getUserUsersUserIdGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await Users.getUserUsersUserIdGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getUserUsersUserIdGetQueryKey(options)
});

/**
 * Update User
 */
export const updateUserUsersUserIdPutMutation = (options?: Partial<Options<UpdateUserUsersUserIdPutData>>): UseMutationOptions<UpdateUserUsersUserIdPutResponse, AxiosError<UpdateUserUsersUserIdPutError>, Options<UpdateUserUsersUserIdPutData>> => {
    const mutationOptions: UseMutationOptions<UpdateUserUsersUserIdPutResponse, AxiosError<UpdateUserUsersUserIdPutError>, Options<UpdateUserUsersUserIdPutData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await Users.updateUserUsersUserIdPut({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getHousesOfUserUsersUserIdHousesGetQueryKey = (options: Options<GetHousesOfUserUsersUserIdHousesGetData>) => createQueryKey('getHousesOfUserUsersUserIdHousesGet', options);

/**
 * Get Houses Of User
 *
 * Get all houses associated with a user.
 *
 * Parameters:
 * - user_id (int): ID of the user whose houses to retrieve.
 * - db (AsyncSession): Database session.
 * - current_user (users.models.User): Current authenticated user.
 */
export const getHousesOfUserUsersUserIdHousesGetOptions = (options: Options<GetHousesOfUserUsersUserIdHousesGetData>) => queryOptions<GetHousesOfUserUsersUserIdHousesGetResponse, AxiosError<GetHousesOfUserUsersUserIdHousesGetError>, GetHousesOfUserUsersUserIdHousesGetResponse, ReturnType<typeof getHousesOfUserUsersUserIdHousesGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await Users.getHousesOfUserUsersUserIdHousesGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getHousesOfUserUsersUserIdHousesGetQueryKey(options)
});

export const getMyPendingTransfersUsersMePendingTransfersGetQueryKey = (options?: Options<GetMyPendingTransfersUsersMePendingTransfersGetData>) => createQueryKey('getMyPendingTransfersUsersMePendingTransfersGet', options);

/**
 * Get My Pending Transfers
 *
 * Get all pending property transfers for the current user.
 *
 * Returns a list of properties that have been offered to the user
 * but haven't been claimed yet. Useful for:
 * - Dashboard notifications
 * - Onboarding flows
 * - Property invitation management
 */
export const getMyPendingTransfersUsersMePendingTransfersGetOptions = (options?: Options<GetMyPendingTransfersUsersMePendingTransfersGetData>) => queryOptions<GetMyPendingTransfersUsersMePendingTransfersGetResponse, AxiosError<DefaultError>, GetMyPendingTransfersUsersMePendingTransfersGetResponse, ReturnType<typeof getMyPendingTransfersUsersMePendingTransfersGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await Users.getMyPendingTransfersUsersMePendingTransfersGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getMyPendingTransfersUsersMePendingTransfersGetQueryKey(options)
});

export const getMyOutgoingTransfersUsersMeOutgoingTransfersGetQueryKey = (options?: Options<GetMyOutgoingTransfersUsersMeOutgoingTransfersGetData>) => createQueryKey('getMyOutgoingTransfersUsersMeOutgoingTransfersGet', options);

/**
 * Get My Outgoing Transfers
 *
 * Get all outstanding outgoing property transfers the current user has initiated.
 *
 * Aggregates what GET /houses/{house_id}/pending-transfer returns per property, across every
 * property the user owns, in one call. Outstanding = status in (pending, processing, failed) —
 * in-flight or failed-and-retryable; completed/cancelled/expired are excluded. Returns [] (200)
 * when there are none — never 404 — so the FE badge query stays clean.
 */
export const getMyOutgoingTransfersUsersMeOutgoingTransfersGetOptions = (options?: Options<GetMyOutgoingTransfersUsersMeOutgoingTransfersGetData>) => queryOptions<GetMyOutgoingTransfersUsersMeOutgoingTransfersGetResponse, AxiosError<DefaultError>, GetMyOutgoingTransfersUsersMeOutgoingTransfersGetResponse, ReturnType<typeof getMyOutgoingTransfersUsersMeOutgoingTransfersGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await Users.getMyOutgoingTransfersUsersMeOutgoingTransfersGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getMyOutgoingTransfersUsersMeOutgoingTransfersGetQueryKey(options)
});

/**
 * Create Pro Checkout
 *
 * Create a Stripe checkout session for the Pro subscription.
 *
 * Available to any authenticated user who does not already have an active subscription.
 * The frontend should redirect the user to the returned checkout_url to complete payment.
 */
export const createProCheckoutUsersMeProSubscriptionCheckoutPostMutation = (options?: Partial<Options<CreateProCheckoutUsersMeProSubscriptionCheckoutPostData>>): UseMutationOptions<CreateProCheckoutUsersMeProSubscriptionCheckoutPostResponse, AxiosError<DefaultError>, Options<CreateProCheckoutUsersMeProSubscriptionCheckoutPostData>> => {
    const mutationOptions: UseMutationOptions<CreateProCheckoutUsersMeProSubscriptionCheckoutPostResponse, AxiosError<DefaultError>, Options<CreateProCheckoutUsersMeProSubscriptionCheckoutPostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await Users.createProCheckoutUsersMeProSubscriptionCheckoutPost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Activate Pro Subscription Direct
 *
 * Activate a Pro subscription using the user's saved card.
 *
 * Skips the Stripe-hosted checkout redirect when a saved PaymentMethod is on file.
 * The frontend shows a confirmation modal first; this endpoint is called only after
 * explicit user confirmation.
 *
 * Returns status='active' when payment succeeds immediately.
 * Returns status='requires_action' with a redirect_url when the card requires 3DS;
 * after authentication Stripe activates the subscription via webhook.
 *
 * Returns HTTP 400 if no saved card is on file — the frontend should fall back to
 * POST /users/me/pro-subscription/checkout instead.
 */
export const activateProSubscriptionDirectUsersMeProSubscriptionActivatePostMutation = (options?: Partial<Options<ActivateProSubscriptionDirectUsersMeProSubscriptionActivatePostData>>): UseMutationOptions<ActivateProSubscriptionDirectUsersMeProSubscriptionActivatePostResponse, AxiosError<DefaultError>, Options<ActivateProSubscriptionDirectUsersMeProSubscriptionActivatePostData>> => {
    const mutationOptions: UseMutationOptions<ActivateProSubscriptionDirectUsersMeProSubscriptionActivatePostResponse, AxiosError<DefaultError>, Options<ActivateProSubscriptionDirectUsersMeProSubscriptionActivatePostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await Users.activateProSubscriptionDirectUsersMeProSubscriptionActivatePost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Update Tos Acceptance
 *
 * Update user's Terms of Service acceptance.
 *
 * This endpoint allows authenticated users to update their ToS acceptance status
 * with a specific version and timestamp. The version must match the currently
 * active legal version.
 *
 * Args:
 * request_data: Contains tos_version and optional tos_agreed_at
 * current_user: Currently authenticated user
 * db: Database session
 *
 * Returns:
 * Confirmation with updated tos_version and tos_agreed_at
 *
 * Raises:
 * HTTPException 400: If no active legal version exists or version doesn't match
 */
export const updateTosAcceptanceMeTosAcceptancePutMutation = (options?: Partial<Options<UpdateTosAcceptanceMeTosAcceptancePutData>>): UseMutationOptions<UpdateTosAcceptanceMeTosAcceptancePutResponse, AxiosError<UpdateTosAcceptanceMeTosAcceptancePutError>, Options<UpdateTosAcceptanceMeTosAcceptancePutData>> => {
    const mutationOptions: UseMutationOptions<UpdateTosAcceptanceMeTosAcceptancePutResponse, AxiosError<UpdateTosAcceptanceMeTosAcceptancePutError>, Options<UpdateTosAcceptanceMeTosAcceptancePutData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await Users.updateTosAcceptanceMeTosAcceptancePut({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Complete User Account
 *
 * Complete user account setup with TOS and marketing consent.
 *
 * This endpoint is specifically for Google users who have already authenticated
 * but need to accept terms and provide marketing consent. It's the equivalent
 * of the finalize_user flow but for already-authenticated Google users.
 *
 * Args:
 * request_data: Contains tos_version, marketing_consent and optional timestamps
 * current_user: Currently authenticated user
 * db: Database session
 *
 * Returns:
 * Confirmation with updated TOS, marketing consent, and user data
 *
 * Raises:
 * HTTPException 400: If user has already completed account setup or TOS validation fails
 */
export const completeUserAccountMeCompleteAccountPutMutation = (options?: Partial<Options<CompleteUserAccountMeCompleteAccountPutData>>): UseMutationOptions<CompleteUserAccountMeCompleteAccountPutResponse, AxiosError<CompleteUserAccountMeCompleteAccountPutError>, Options<CompleteUserAccountMeCompleteAccountPutData>> => {
    const mutationOptions: UseMutationOptions<CompleteUserAccountMeCompleteAccountPutResponse, AxiosError<CompleteUserAccountMeCompleteAccountPutError>, Options<CompleteUserAccountMeCompleteAccountPutData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await Users.completeUserAccountMeCompleteAccountPut({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getSavedPaymentMethodMePaymentMethodGetQueryKey = (options?: Options<GetSavedPaymentMethodMePaymentMethodGetData>) => createQueryKey('getSavedPaymentMethodMePaymentMethodGet', options);

/**
 * Get Saved Payment Method
 *
 * Return display info for the user's saved card (brand, last4, expiry).
 *
 * Used by the frontend to render a confirmation dialog before charging.
 * No sensitive card data is stored in our database — all info is fetched
 * live from Stripe via the stored PaymentMethod ID.
 *
 * Returns:
 * SavedPaymentMethodResponse with has_saved_card=False if no card is saved.
 * If has_saved_card=False, fall back to the standard Checkout redirect flow.
 */
export const getSavedPaymentMethodMePaymentMethodGetOptions = (options?: Options<GetSavedPaymentMethodMePaymentMethodGetData>) => queryOptions<GetSavedPaymentMethodMePaymentMethodGetResponse, AxiosError<DefaultError>, GetSavedPaymentMethodMePaymentMethodGetResponse, ReturnType<typeof getSavedPaymentMethodMePaymentMethodGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await Users.getSavedPaymentMethodMePaymentMethodGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getSavedPaymentMethodMePaymentMethodGetQueryKey(options)
});

/**
 * Create Billing Portal
 *
 * Create a Stripe Customer Portal session.
 *
 * Redirects the user to Stripe's hosted portal where they can update their
 * payment method, manage their subscription, and download invoices.
 * Returns 400 when the user has no Stripe customer record — this means they
 * have never completed a checkout and have nothing to manage.
 */
export const createBillingPortalMeBillingPortalPostMutation = (options?: Partial<Options<CreateBillingPortalMeBillingPortalPostData>>): UseMutationOptions<CreateBillingPortalMeBillingPortalPostResponse, AxiosError<DefaultError>, Options<CreateBillingPortalMeBillingPortalPostData>> => {
    const mutationOptions: UseMutationOptions<CreateBillingPortalMeBillingPortalPostResponse, AxiosError<DefaultError>, Options<CreateBillingPortalMeBillingPortalPostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await Users.createBillingPortalMeBillingPortalPost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Confirm One Off Payment
 *
 * Charge the user's saved card after explicit frontend confirmation.
 *
 * The frontend must call GET /me/payment-method first to display a
 * confirmation dialog showing the card details to the user. Only after
 * the user confirms should this endpoint be called.
 *
 * If the card requires 3DS/SCA authentication, status='requires_action'
 * is returned with a redirect_url the frontend must redirect the user to.
 * After authentication Stripe redirects back to payload.return_url.
 *
 * If no saved card is on file, returns HTTP 400 — the frontend should fall
 * back to the existing Checkout redirect flow.
 *
 * Returns:
 * OneOffPaymentResponse with status 'succeeded' or 'requires_action'.
 */
export const confirmOneOffPaymentMePaymentsPostMutation = (options?: Partial<Options<ConfirmOneOffPaymentMePaymentsPostData>>): UseMutationOptions<ConfirmOneOffPaymentMePaymentsPostResponse, AxiosError<ConfirmOneOffPaymentMePaymentsPostError>, Options<ConfirmOneOffPaymentMePaymentsPostData>> => {
    const mutationOptions: UseMutationOptions<ConfirmOneOffPaymentMePaymentsPostResponse, AxiosError<ConfirmOneOffPaymentMePaymentsPostError>, Options<ConfirmOneOffPaymentMePaymentsPostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await Users.confirmOneOffPaymentMePaymentsPost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Register Google User
 */
export const registerGoogleUserUsersGooglePostMutation = (options?: Partial<Options<RegisterGoogleUserUsersGooglePostData>>): UseMutationOptions<RegisterGoogleUserUsersGooglePostResponse, AxiosError<RegisterGoogleUserUsersGooglePostError>, Options<RegisterGoogleUserUsersGooglePostData>> => {
    const mutationOptions: UseMutationOptions<RegisterGoogleUserUsersGooglePostResponse, AxiosError<RegisterGoogleUserUsersGooglePostError>, Options<RegisterGoogleUserUsersGooglePostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await UserRegistration.registerGoogleUserUsersGooglePost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Finalize User
 */
export const finalizeUserFinalizeUserPostMutation = (options?: Partial<Options<FinalizeUserFinalizeUserPostData>>): UseMutationOptions<FinalizeUserFinalizeUserPostResponse, AxiosError<FinalizeUserFinalizeUserPostError>, Options<FinalizeUserFinalizeUserPostData>> => {
    const mutationOptions: UseMutationOptions<FinalizeUserFinalizeUserPostResponse, AxiosError<FinalizeUserFinalizeUserPostError>, Options<FinalizeUserFinalizeUserPostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await UserRegistration.finalizeUserFinalizeUserPost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Forgot Password
 *
 * Initiate password reset process by sending reset email.
 *
 * This endpoint:
 * - Validates email exists and is verified
 * - Generates secure reset token
 * - Sends password reset email
 * - Rate limits to prevent abuse
 *
 * Args:
 * request_data: Contains email address
 * request: FastAPI request object for IP/user agent
 *
 * Returns:
 * Success message (same response regardless of email validity for security)
 *
 * Raises:
 * UserNotFoundError: If user not found
 * UserNotVerifiedError: If user exists but is not verified
 */
export const forgotPasswordForgotPasswordPostMutation = (options?: Partial<Options<ForgotPasswordForgotPasswordPostData>>): UseMutationOptions<ForgotPasswordForgotPasswordPostResponse, AxiosError<ForgotPasswordForgotPasswordPostError>, Options<ForgotPasswordForgotPasswordPostData>> => {
    const mutationOptions: UseMutationOptions<ForgotPasswordForgotPasswordPostResponse, AxiosError<ForgotPasswordForgotPasswordPostError>, Options<ForgotPasswordForgotPasswordPostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await UserRegistration.forgotPasswordForgotPasswordPost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Reset Password
 *
 * Complete password reset using valid token.
 *
 * This endpoint:
 * - Verifies reset token is valid and not expired
 * - Updates user password with secure hash
 * - Marks token as used
 * - Invalidates all other tokens for the user
 *
 * Args:
 * request_data: Contains reset token and new password
 *
 * Returns:
 * Success confirmation with email
 *
 * Raises:
 * HTTPException: If token is invalid or expired
 */
export const resetPasswordResetPasswordPostMutation = (options?: Partial<Options<ResetPasswordResetPasswordPostData>>): UseMutationOptions<ResetPasswordResetPasswordPostResponse, AxiosError<ResetPasswordResetPasswordPostError>, Options<ResetPasswordResetPasswordPostData>> => {
    const mutationOptions: UseMutationOptions<ResetPasswordResetPasswordPostResponse, AxiosError<ResetPasswordResetPasswordPostError>, Options<ResetPasswordResetPasswordPostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await UserRegistration.resetPasswordResetPasswordPost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Create House V2
 *
 * Create a new house using the credit-based payment system (v2).
 *
 * This endpoint:
 * - Validates the user has available property credits
 * - Consumes one credit from the user's balance
 * - Creates the house with proper ownership tracking
 * - Sets up a property-level subscription
 * - Creates ownership history record
 *
 * Returns 402 Payment Required if user has insufficient credits.
 */
export const createHouseV2V2HousesPostMutation = (options?: Partial<Options<CreateHouseV2V2HousesPostData>>): UseMutationOptions<CreateHouseV2V2HousesPostResponse, AxiosError<CreateHouseV2V2HousesPostError>, Options<CreateHouseV2V2HousesPostData>> => {
    const mutationOptions: UseMutationOptions<CreateHouseV2V2HousesPostResponse, AxiosError<CreateHouseV2V2HousesPostError>, Options<CreateHouseV2V2HousesPostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await Properties.createHouseV2V2HousesPost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete House
 */
export const deleteHouseHousesHouseIdDeleteMutation = (options?: Partial<Options<DeleteHouseHousesHouseIdDeleteData>>): UseMutationOptions<unknown, AxiosError<DeleteHouseHousesHouseIdDeleteError>, Options<DeleteHouseHousesHouseIdDeleteData>> => {
    const mutationOptions: UseMutationOptions<unknown, AxiosError<DeleteHouseHousesHouseIdDeleteError>, Options<DeleteHouseHousesHouseIdDeleteData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await Properties.deleteHouseHousesHouseIdDelete({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const readHouseHousesHouseIdGetQueryKey = (options: Options<ReadHouseHousesHouseIdGetData>) => createQueryKey('readHouseHousesHouseIdGet', options);

/**
 * Read House
 */
export const readHouseHousesHouseIdGetOptions = (options: Options<ReadHouseHousesHouseIdGetData>) => queryOptions<ReadHouseHousesHouseIdGetResponse, AxiosError<ReadHouseHousesHouseIdGetError>, ReadHouseHousesHouseIdGetResponse, ReturnType<typeof readHouseHousesHouseIdGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await Properties.readHouseHousesHouseIdGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: readHouseHousesHouseIdGetQueryKey(options)
});

/**
 * Update House
 *
 * Update an existing house.
 */
export const updateHouseHousesHouseIdPutMutation = (options?: Partial<Options<UpdateHouseHousesHouseIdPutData>>): UseMutationOptions<UpdateHouseHousesHouseIdPutResponse, AxiosError<UpdateHouseHousesHouseIdPutError>, Options<UpdateHouseHousesHouseIdPutData>> => {
    const mutationOptions: UseMutationOptions<UpdateHouseHousesHouseIdPutResponse, AxiosError<UpdateHouseHousesHouseIdPutError>, Options<UpdateHouseHousesHouseIdPutData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await Properties.updateHouseHousesHouseIdPut({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const readHousesHousesGetQueryKey = (options?: Options<ReadHousesHousesGetData>) => createQueryKey('readHousesHousesGet', options);

/**
 * Read Houses
 *
 * Enhanced houses endpoint for all user roles.
 *
 * Returns:
 * - For admins: All houses
 * - For homeowners/builders: Houses via HouseUserAssociation
 * - For professionals: Houses where they are contacts + houses via association
 */
export const readHousesHousesGetOptions = (options?: Options<ReadHousesHousesGetData>) => queryOptions<ReadHousesHousesGetResponse, AxiosError<ReadHousesHousesGetError>, ReadHousesHousesGetResponse, ReturnType<typeof readHousesHousesGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await Properties.readHousesHousesGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: readHousesHousesGetQueryKey(options)
});

export const getUsersOfHouseHousesHouseIdUsersGetQueryKey = (options: Options<GetUsersOfHouseHousesHouseIdUsersGetData>) => createQueryKey('getUsersOfHouseHousesHouseIdUsersGet', options);

/**
 * Get Users Of House
 */
export const getUsersOfHouseHousesHouseIdUsersGetOptions = (options: Options<GetUsersOfHouseHousesHouseIdUsersGetData>) => queryOptions<GetUsersOfHouseHousesHouseIdUsersGetResponse, AxiosError<GetUsersOfHouseHousesHouseIdUsersGetError>, GetUsersOfHouseHousesHouseIdUsersGetResponse, ReturnType<typeof getUsersOfHouseHousesHouseIdUsersGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await Properties.getUsersOfHouseHousesHouseIdUsersGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getUsersOfHouseHousesHouseIdUsersGetQueryKey(options)
});

/**
 * Add User To House
 *
 * Add a user to a house.
 */
export const addUserToHouseHousesHouseIdUsersPostMutation = (options?: Partial<Options<AddUserToHouseHousesHouseIdUsersPostData>>): UseMutationOptions<AddUserToHouseHousesHouseIdUsersPostResponse, AxiosError<AddUserToHouseHousesHouseIdUsersPostError>, Options<AddUserToHouseHousesHouseIdUsersPostData>> => {
    const mutationOptions: UseMutationOptions<AddUserToHouseHousesHouseIdUsersPostResponse, AxiosError<AddUserToHouseHousesHouseIdUsersPostError>, Options<AddUserToHouseHousesHouseIdUsersPostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await Properties.addUserToHouseHousesHouseIdUsersPost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Remove User From House
 *
 * Remove a user from a house.
 */
export const removeUserFromHouseHousesHouseIdUsersUserIdDeleteMutation = (options?: Partial<Options<RemoveUserFromHouseHousesHouseIdUsersUserIdDeleteData>>): UseMutationOptions<RemoveUserFromHouseHousesHouseIdUsersUserIdDeleteResponse, AxiosError<RemoveUserFromHouseHousesHouseIdUsersUserIdDeleteError>, Options<RemoveUserFromHouseHousesHouseIdUsersUserIdDeleteData>> => {
    const mutationOptions: UseMutationOptions<RemoveUserFromHouseHousesHouseIdUsersUserIdDeleteResponse, AxiosError<RemoveUserFromHouseHousesHouseIdUsersUserIdDeleteError>, Options<RemoveUserFromHouseHousesHouseIdUsersUserIdDeleteData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await Properties.removeUserFromHouseHousesHouseIdUsersUserIdDelete({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getHouseEmailAliasesHousesHouseIdAliasesGetQueryKey = (options: Options<GetHouseEmailAliasesHousesHouseIdAliasesGetData>) => createQueryKey('getHouseEmailAliasesHousesHouseIdAliasesGet', options);

/**
 * Get House Email Aliases
 *
 * Get all email aliases for a house.
 *
 * Returns a list of email aliases associated with the property,
 * which can be used for inbound email routing (e.g., 60nikau@upload.mybundle.app).
 *
 * Args:
 * house_id: The ID of the house
 * db: Database session
 * current_user: The current authenticated user
 *
 * Returns:
 * List of HouseEmailAlias schemas
 *
 * Raises:
 * HTTPException: 404 if house not found, 403 if user lacks access
 */
export const getHouseEmailAliasesHousesHouseIdAliasesGetOptions = (options: Options<GetHouseEmailAliasesHousesHouseIdAliasesGetData>) => queryOptions<GetHouseEmailAliasesHousesHouseIdAliasesGetResponse, AxiosError<GetHouseEmailAliasesHousesHouseIdAliasesGetError>, GetHouseEmailAliasesHousesHouseIdAliasesGetResponse, ReturnType<typeof getHouseEmailAliasesHousesHouseIdAliasesGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await Properties.getHouseEmailAliasesHousesHouseIdAliasesGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getHouseEmailAliasesHousesHouseIdAliasesGetQueryKey(options)
});

export const getPropertyPaymentStatusHousesHouseIdPaymentStatusGetQueryKey = (options: Options<GetPropertyPaymentStatusHousesHouseIdPaymentStatusGetData>) => createQueryKey('getPropertyPaymentStatusHousesHouseIdPaymentStatusGet', options);

/**
 * Get Property Payment Status
 *
 * Get payment status information for a specific property.
 *
 * Returns detailed payment and subscription information including:
 * - Payment status (active, failed, exempted, etc.)
 * - Current payer information
 * - Subscription expiration and grace periods
 * - Payment mode (credit_based, grandfathered, etc.)
 */
export const getPropertyPaymentStatusHousesHouseIdPaymentStatusGetOptions = (options: Options<GetPropertyPaymentStatusHousesHouseIdPaymentStatusGetData>) => queryOptions<GetPropertyPaymentStatusHousesHouseIdPaymentStatusGetResponse, AxiosError<GetPropertyPaymentStatusHousesHouseIdPaymentStatusGetError>, GetPropertyPaymentStatusHousesHouseIdPaymentStatusGetResponse, ReturnType<typeof getPropertyPaymentStatusHousesHouseIdPaymentStatusGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await Properties.getPropertyPaymentStatusHousesHouseIdPaymentStatusGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getPropertyPaymentStatusHousesHouseIdPaymentStatusGetQueryKey(options)
});

export const getGuestQrCodeImageHousesHouseIdQrCodeGuestGetQueryKey = (options: Options<GetGuestQrCodeImageHousesHouseIdQrCodeGuestGetData>) => createQueryKey('getGuestQrCodeImageHousesHouseIdQrCodeGuestGet', options);

/**
 * Get Guest Qr Code Image
 *
 * Retrieve the QR code image for the guest access URL of a house.
 *
 * Args:
 * house_id (int): The ID of the house.
 * db (AsyncSession): The async database session.
 * current_user (User): The current authenticated user.
 *
 * Returns:
 * Response: The QR code image as a stream or a 404 error if not found.
 */
export const getGuestQrCodeImageHousesHouseIdQrCodeGuestGetOptions = (options: Options<GetGuestQrCodeImageHousesHouseIdQrCodeGuestGetData>) => queryOptions<unknown, AxiosError<GetGuestQrCodeImageHousesHouseIdQrCodeGuestGetError>, unknown, ReturnType<typeof getGuestQrCodeImageHousesHouseIdQrCodeGuestGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await Properties.getGuestQrCodeImageHousesHouseIdQrCodeGuestGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getGuestQrCodeImageHousesHouseIdQrCodeGuestGetQueryKey(options)
});

/**
 * Generate Qr Code Endpoint
 *
 * Endpoint to trigger QR code generation for a house.
 *
 * Args:
 * house_id (int): The ID of the house.
 * background_tasks (BackgroundTasks): Background task manager for async task execution.
 * db (AsyncSession): The database session dependency.
 * current_user (User): The current authenticated user.
 *
 * Returns:
 * dict: Success message or error details.
 */
export const generateQrCodeEndpointHousesHouseIdQrCodeGuestPostMutation = (options?: Partial<Options<GenerateQrCodeEndpointHousesHouseIdQrCodeGuestPostData>>): UseMutationOptions<unknown, AxiosError<GenerateQrCodeEndpointHousesHouseIdQrCodeGuestPostError>, Options<GenerateQrCodeEndpointHousesHouseIdQrCodeGuestPostData>> => {
    const mutationOptions: UseMutationOptions<unknown, AxiosError<GenerateQrCodeEndpointHousesHouseIdQrCodeGuestPostError>, Options<GenerateQrCodeEndpointHousesHouseIdQrCodeGuestPostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await Properties.generateQrCodeEndpointHousesHouseIdQrCodeGuestPost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getQrCodeSettingsEndpointHousesHouseIdQrCodeGuestSettingsGetQueryKey = (options: Options<GetQrCodeSettingsEndpointHousesHouseIdQrCodeGuestSettingsGetData>) => createQueryKey('getQrCodeSettingsEndpointHousesHouseIdQrCodeGuestSettingsGet', options);

/**
 * Get Qr Code Settings Endpoint
 */
export const getQrCodeSettingsEndpointHousesHouseIdQrCodeGuestSettingsGetOptions = (options: Options<GetQrCodeSettingsEndpointHousesHouseIdQrCodeGuestSettingsGetData>) => queryOptions<GetQrCodeSettingsEndpointHousesHouseIdQrCodeGuestSettingsGetResponse, AxiosError<GetQrCodeSettingsEndpointHousesHouseIdQrCodeGuestSettingsGetError>, GetQrCodeSettingsEndpointHousesHouseIdQrCodeGuestSettingsGetResponse, ReturnType<typeof getQrCodeSettingsEndpointHousesHouseIdQrCodeGuestSettingsGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await Properties.getQrCodeSettingsEndpointHousesHouseIdQrCodeGuestSettingsGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getQrCodeSettingsEndpointHousesHouseIdQrCodeGuestSettingsGetQueryKey(options)
});

/**
 * Update Qr Code Settings Endpoint
 */
export const updateQrCodeSettingsEndpointHousesHouseIdQrCodeGuestSettingsPatchMutation = (options?: Partial<Options<UpdateQrCodeSettingsEndpointHousesHouseIdQrCodeGuestSettingsPatchData>>): UseMutationOptions<UpdateQrCodeSettingsEndpointHousesHouseIdQrCodeGuestSettingsPatchResponse, AxiosError<UpdateQrCodeSettingsEndpointHousesHouseIdQrCodeGuestSettingsPatchError>, Options<UpdateQrCodeSettingsEndpointHousesHouseIdQrCodeGuestSettingsPatchData>> => {
    const mutationOptions: UseMutationOptions<UpdateQrCodeSettingsEndpointHousesHouseIdQrCodeGuestSettingsPatchResponse, AxiosError<UpdateQrCodeSettingsEndpointHousesHouseIdQrCodeGuestSettingsPatchError>, Options<UpdateQrCodeSettingsEndpointHousesHouseIdQrCodeGuestSettingsPatchData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await Properties.updateQrCodeSettingsEndpointHousesHouseIdQrCodeGuestSettingsPatch({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete Qr Codes Endpoint
 *
 * Endpoint to trigger deletion of all QR codes for a house.
 *
 * Args:
 * house_id (int): The ID of the house.
 * background_tasks (BackgroundTasks): Background task manager for async task execution.
 * db (AsyncSession): The database session dependency.
 * current_user (User): The current authenticated user.
 *
 * Returns:
 * dict: Success message or error details.
 */
export const deleteQrCodesEndpointHousesHouseIdQrCodesDeleteMutation = (options?: Partial<Options<DeleteQrCodesEndpointHousesHouseIdQrCodesDeleteData>>): UseMutationOptions<unknown, AxiosError<DeleteQrCodesEndpointHousesHouseIdQrCodesDeleteError>, Options<DeleteQrCodesEndpointHousesHouseIdQrCodesDeleteData>> => {
    const mutationOptions: UseMutationOptions<unknown, AxiosError<DeleteQrCodesEndpointHousesHouseIdQrCodesDeleteError>, Options<DeleteQrCodesEndpointHousesHouseIdQrCodesDeleteData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await Properties.deleteQrCodesEndpointHousesHouseIdQrCodesDelete({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Send Welcome Email Endpoint
 *
 * Send a welcome email to the property owner and mark the house as onboarded.
 *
 * This endpoint:
 * - Validates property access
 * - Sends welcome email to the current owner
 * - Updates the house onboarded status to True
 *
 * Args:
 * house_id: ID of the property
 *
 * Returns:
 * WelcomeEmailResponse: Confirmation with email details
 */
export const sendWelcomeEmailEndpointHousesHouseIdOnboardedPostMutation = (options?: Partial<Options<SendWelcomeEmailEndpointHousesHouseIdOnboardedPostData>>): UseMutationOptions<SendWelcomeEmailEndpointHousesHouseIdOnboardedPostResponse, AxiosError<SendWelcomeEmailEndpointHousesHouseIdOnboardedPostError>, Options<SendWelcomeEmailEndpointHousesHouseIdOnboardedPostData>> => {
    const mutationOptions: UseMutationOptions<SendWelcomeEmailEndpointHousesHouseIdOnboardedPostResponse, AxiosError<SendWelcomeEmailEndpointHousesHouseIdOnboardedPostError>, Options<SendWelcomeEmailEndpointHousesHouseIdOnboardedPostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await Properties.sendWelcomeEmailEndpointHousesHouseIdOnboardedPost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getAvailableBundlesPropertyBundlesGetQueryKey = (options?: Options<GetAvailableBundlesPropertyBundlesGetData>) => createQueryKey('getAvailableBundlesPropertyBundlesGet', options);

/**
 * Get Available Bundles
 *
 * Get all available property bundles for purchase.
 */
export const getAvailableBundlesPropertyBundlesGetOptions = (options?: Options<GetAvailableBundlesPropertyBundlesGetData>) => queryOptions<GetAvailableBundlesPropertyBundlesGetResponse, AxiosError<DefaultError>, GetAvailableBundlesPropertyBundlesGetResponse, ReturnType<typeof getAvailableBundlesPropertyBundlesGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await PropertyPayments.getAvailableBundlesPropertyBundlesGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getAvailableBundlesPropertyBundlesGetQueryKey(options)
});

export const getBundlePropertyBundlesBundleIdGetQueryKey = (options: Options<GetBundlePropertyBundlesBundleIdGetData>) => createQueryKey('getBundlePropertyBundlesBundleIdGet', options);

/**
 * Get Bundle
 *
 * Get a single property bundle by ID, including live price fetched from Stripe.
 *
 * Used by the frontend to display the price in the payment confirmation modal
 * without hardcoding amounts. The price is fetched live from Stripe so it
 * stays in sync with any pricing changes.
 */
export const getBundlePropertyBundlesBundleIdGetOptions = (options: Options<GetBundlePropertyBundlesBundleIdGetData>) => queryOptions<GetBundlePropertyBundlesBundleIdGetResponse, AxiosError<GetBundlePropertyBundlesBundleIdGetError>, GetBundlePropertyBundlesBundleIdGetResponse, ReturnType<typeof getBundlePropertyBundlesBundleIdGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await PropertyPayments.getBundlePropertyBundlesBundleIdGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getBundlePropertyBundlesBundleIdGetQueryKey(options)
});

export const getCreditBalanceCreditsBalanceGetQueryKey = (options?: Options<GetCreditBalanceCreditsBalanceGetData>) => createQueryKey('getCreditBalanceCreditsBalanceGet', options);

/**
 * Get Credit Balance
 *
 * Get current user's property credit balance.
 */
export const getCreditBalanceCreditsBalanceGetOptions = (options?: Options<GetCreditBalanceCreditsBalanceGetData>) => queryOptions<GetCreditBalanceCreditsBalanceGetResponse, AxiosError<DefaultError>, GetCreditBalanceCreditsBalanceGetResponse, ReturnType<typeof getCreditBalanceCreditsBalanceGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await PropertyPayments.getCreditBalanceCreditsBalanceGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getCreditBalanceCreditsBalanceGetQueryKey(options)
});

/**
 * Create Credit Checkout
 *
 * Create a Stripe checkout session for purchasing property credits.
 */
export const createCreditCheckoutCreditsCheckoutPostMutation = (options?: Partial<Options<CreateCreditCheckoutCreditsCheckoutPostData>>): UseMutationOptions<CreateCreditCheckoutCreditsCheckoutPostResponse, AxiosError<CreateCreditCheckoutCreditsCheckoutPostError>, Options<CreateCreditCheckoutCreditsCheckoutPostData>> => {
    const mutationOptions: UseMutationOptions<CreateCreditCheckoutCreditsCheckoutPostResponse, AxiosError<CreateCreditCheckoutCreditsCheckoutPostError>, Options<CreateCreditCheckoutCreditsCheckoutPostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await PropertyPayments.createCreditCheckoutCreditsCheckoutPost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Verify Credit Purchase
 *
 * Verify a completed credit purchase and add credits to user's balance.
 */
export const verifyCreditPurchaseCreditsVerifyPurchasePostMutation = (options?: Partial<Options<VerifyCreditPurchaseCreditsVerifyPurchasePostData>>): UseMutationOptions<unknown, AxiosError<VerifyCreditPurchaseCreditsVerifyPurchasePostError>, Options<VerifyCreditPurchaseCreditsVerifyPurchasePostData>> => {
    const mutationOptions: UseMutationOptions<unknown, AxiosError<VerifyCreditPurchaseCreditsVerifyPurchasePostError>, Options<VerifyCreditPurchaseCreditsVerifyPurchasePostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await PropertyPayments.verifyCreditPurchaseCreditsVerifyPurchasePost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Create Property Bundle
 *
 * Create a new property bundle (admin only).
 */
export const createPropertyBundleAdminPropertyBundlesPostMutation = (options?: Partial<Options<CreatePropertyBundleAdminPropertyBundlesPostData>>): UseMutationOptions<CreatePropertyBundleAdminPropertyBundlesPostResponse, AxiosError<CreatePropertyBundleAdminPropertyBundlesPostError>, Options<CreatePropertyBundleAdminPropertyBundlesPostData>> => {
    const mutationOptions: UseMutationOptions<CreatePropertyBundleAdminPropertyBundlesPostResponse, AxiosError<CreatePropertyBundleAdminPropertyBundlesPostError>, Options<CreatePropertyBundleAdminPropertyBundlesPostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await PropertyPayments.createPropertyBundleAdminPropertyBundlesPost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getUserCreditsAdminAdminUsersUserIdCreditsGetQueryKey = (options: Options<GetUserCreditsAdminAdminUsersUserIdCreditsGetData>) => createQueryKey('getUserCreditsAdminAdminUsersUserIdCreditsGet', options);

/**
 * Get User Credits Admin
 *
 * Get any user's credit balance (admin only).
 */
export const getUserCreditsAdminAdminUsersUserIdCreditsGetOptions = (options: Options<GetUserCreditsAdminAdminUsersUserIdCreditsGetData>) => queryOptions<GetUserCreditsAdminAdminUsersUserIdCreditsGetResponse, AxiosError<GetUserCreditsAdminAdminUsersUserIdCreditsGetError>, GetUserCreditsAdminAdminUsersUserIdCreditsGetResponse, ReturnType<typeof getUserCreditsAdminAdminUsersUserIdCreditsGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await PropertyPayments.getUserCreditsAdminAdminUsersUserIdCreditsGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getUserCreditsAdminAdminUsersUserIdCreditsGetQueryKey(options)
});

export const getPropertyOwnershipHistoryHousesHouseIdOwnershipHistoryGetQueryKey = (options: Options<GetPropertyOwnershipHistoryHousesHouseIdOwnershipHistoryGetData>) => createQueryKey('getPropertyOwnershipHistoryHousesHouseIdOwnershipHistoryGet', options);

/**
 * Get Property Ownership History
 *
 * Get the complete ownership history for a property.
 *
 * Returns all ownership transfers in chronological order with details
 * about previous owners, new owners, transfer reasons, and timestamps.
 *
 * Args:
 * house_id: ID of the property
 *
 * Returns:
 * List of ownership history records
 */
export const getPropertyOwnershipHistoryHousesHouseIdOwnershipHistoryGetOptions = (options: Options<GetPropertyOwnershipHistoryHousesHouseIdOwnershipHistoryGetData>) => queryOptions<GetPropertyOwnershipHistoryHousesHouseIdOwnershipHistoryGetResponse, AxiosError<GetPropertyOwnershipHistoryHousesHouseIdOwnershipHistoryGetError>, GetPropertyOwnershipHistoryHousesHouseIdOwnershipHistoryGetResponse, ReturnType<typeof getPropertyOwnershipHistoryHousesHouseIdOwnershipHistoryGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await PropertyOwnership.getPropertyOwnershipHistoryHousesHouseIdOwnershipHistoryGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getPropertyOwnershipHistoryHousesHouseIdOwnershipHistoryGetQueryKey(options)
});

/**
 * Cancel Pending Property Transfer
 *
 * Cancel a pending property transfer.
 *
 * Only the user who created the transfer or an admin can cancel it.
 *
 * Args:
 * house_id: ID of the property
 *
 * Returns:
 * Success message
 */
export const cancelPendingPropertyTransferHousesHouseIdPendingTransferDeleteMutation = (options?: Partial<Options<CancelPendingPropertyTransferHousesHouseIdPendingTransferDeleteData>>): UseMutationOptions<unknown, AxiosError<CancelPendingPropertyTransferHousesHouseIdPendingTransferDeleteError>, Options<CancelPendingPropertyTransferHousesHouseIdPendingTransferDeleteData>> => {
    const mutationOptions: UseMutationOptions<unknown, AxiosError<CancelPendingPropertyTransferHousesHouseIdPendingTransferDeleteError>, Options<CancelPendingPropertyTransferHousesHouseIdPendingTransferDeleteData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await PropertyOwnership.cancelPendingPropertyTransferHousesHouseIdPendingTransferDelete({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getPendingPropertyTransferHousesHouseIdPendingTransferGetQueryKey = (options: Options<GetPendingPropertyTransferHousesHouseIdPendingTransferGetData>) => createQueryKey('getPendingPropertyTransferHousesHouseIdPendingTransferGet', options);

/**
 * Get Pending Property Transfer
 *
 * Get the current pending transfer for a property.
 *
 * Returns details about any active transfer invitation for the property.
 *
 * Args:
 * house_id: ID of the property
 *
 * Returns:
 * PendingTransferStatusResponse: Current pending transfer details
 */
export const getPendingPropertyTransferHousesHouseIdPendingTransferGetOptions = (options: Options<GetPendingPropertyTransferHousesHouseIdPendingTransferGetData>) => queryOptions<GetPendingPropertyTransferHousesHouseIdPendingTransferGetResponse, AxiosError<GetPendingPropertyTransferHousesHouseIdPendingTransferGetError>, GetPendingPropertyTransferHousesHouseIdPendingTransferGetResponse, ReturnType<typeof getPendingPropertyTransferHousesHouseIdPendingTransferGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await PropertyOwnership.getPendingPropertyTransferHousesHouseIdPendingTransferGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getPendingPropertyTransferHousesHouseIdPendingTransferGetQueryKey(options)
});

/**
 * Create Pending Property Transfer
 *
 * Create a pending property transfer for a future user who doesn't exist yet.
 *
 * The system generates a secure token and sends an invitation email.
 * Only one pending transfer per property is allowed.
 *
 * Args:
 * house_id: ID of the property to transfer
 * transfer_request: Transfer details including recipient email
 *
 * Returns:
 * PendingPropertyTransferResponse: Transfer invitation details with secure token
 */
export const createPendingPropertyTransferHousesHouseIdPendingTransferPostMutation = (options?: Partial<Options<CreatePendingPropertyTransferHousesHouseIdPendingTransferPostData>>): UseMutationOptions<CreatePendingPropertyTransferHousesHouseIdPendingTransferPostResponse, AxiosError<CreatePendingPropertyTransferHousesHouseIdPendingTransferPostError>, Options<CreatePendingPropertyTransferHousesHouseIdPendingTransferPostData>> => {
    const mutationOptions: UseMutationOptions<CreatePendingPropertyTransferHousesHouseIdPendingTransferPostResponse, AxiosError<CreatePendingPropertyTransferHousesHouseIdPendingTransferPostError>, Options<CreatePendingPropertyTransferHousesHouseIdPendingTransferPostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await PropertyOwnership.createPendingPropertyTransferHousesHouseIdPendingTransferPost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Claim Pending Property Transfer
 *
 * Claim a pending property transfer using an invitation token.
 *
 * Ownership of the property moves to the claiming user. For a professional-to-owner
 * transfer the professional's archive is copied by a background task; an owner-to-owner
 * transfer completes synchronously.
 *
 * Args:
 * claim_request: Contains transfer token and user email for validation
 *
 * Returns:
 * PropertyOwnershipTransferResponse: Completed transfer details
 */
export const claimPendingPropertyTransferClaimPropertyTransferPostMutation = (options?: Partial<Options<ClaimPendingPropertyTransferClaimPropertyTransferPostData>>): UseMutationOptions<ClaimPendingPropertyTransferClaimPropertyTransferPostResponse, AxiosError<ClaimPendingPropertyTransferClaimPropertyTransferPostError>, Options<ClaimPendingPropertyTransferClaimPropertyTransferPostData>> => {
    const mutationOptions: UseMutationOptions<ClaimPendingPropertyTransferClaimPropertyTransferPostResponse, AxiosError<ClaimPendingPropertyTransferClaimPropertyTransferPostError>, Options<ClaimPendingPropertyTransferClaimPropertyTransferPostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await PropertyOwnership.claimPendingPropertyTransferClaimPropertyTransferPost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getPendingTransferDetailsPendingTransferTransferTokenGetQueryKey = (options: Options<GetPendingTransferDetailsPendingTransferTransferTokenGetData>) => createQueryKey('getPendingTransferDetailsPendingTransferTransferTokenGet', options);

/**
 * Get Pending Transfer Details
 *
 * Get pending transfer details by token (for signup page).
 *
 * This endpoint is public (no auth required) so the signup page can
 * display property details before user creates account.
 *
 * Args:
 * transfer_token: The secure invitation token
 *
 * Returns:
 * Basic transfer and property details for display
 */
export const getPendingTransferDetailsPendingTransferTransferTokenGetOptions = (options: Options<GetPendingTransferDetailsPendingTransferTransferTokenGetData>) => queryOptions<GetPendingTransferDetailsPendingTransferTransferTokenGetResponse, AxiosError<GetPendingTransferDetailsPendingTransferTransferTokenGetError>, GetPendingTransferDetailsPendingTransferTransferTokenGetResponse, ReturnType<typeof getPendingTransferDetailsPendingTransferTransferTokenGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await PropertyOwnership.getPendingTransferDetailsPendingTransferTransferTokenGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getPendingTransferDetailsPendingTransferTransferTokenGetQueryKey(options)
});

/**
 * Retry Transfer Finalization
 *
 * Retry finalization of a failed property transfer.
 *
 * This endpoint allows retrying the async document/task cloning
 * via Celery if the background job failed.
 *
 * Args:
 * transfer_id: ID of the pending transfer
 *
 * Returns:
 * TransferRetryResponse with cloned house ID and status
 */
export const retryTransferFinalizationPendingTransferTransferIdRetryPostMutation = (options?: Partial<Options<RetryTransferFinalizationPendingTransferTransferIdRetryPostData>>): UseMutationOptions<RetryTransferFinalizationPendingTransferTransferIdRetryPostResponse, AxiosError<RetryTransferFinalizationPendingTransferTransferIdRetryPostError>, Options<RetryTransferFinalizationPendingTransferTransferIdRetryPostData>> => {
    const mutationOptions: UseMutationOptions<RetryTransferFinalizationPendingTransferTransferIdRetryPostResponse, AxiosError<RetryTransferFinalizationPendingTransferTransferIdRetryPostError>, Options<RetryTransferFinalizationPendingTransferTransferIdRetryPostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await PropertyOwnership.retryTransferFinalizationPendingTransferTransferIdRetryPost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getHouseSharingHousesHouseIdSharingGetQueryKey = (options: Options<GetHouseSharingHousesHouseIdSharingGetData>) => createQueryKey('getHouseSharingHousesHouseIdSharingGet', options);

/**
 * List users this property is shared with
 */
export const getHouseSharingHousesHouseIdSharingGetOptions = (options: Options<GetHouseSharingHousesHouseIdSharingGetData>) => queryOptions<GetHouseSharingHousesHouseIdSharingGetResponse, AxiosError<GetHouseSharingHousesHouseIdSharingGetError>, GetHouseSharingHousesHouseIdSharingGetResponse, ReturnType<typeof getHouseSharingHousesHouseIdSharingGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await Sharing.getHouseSharingHousesHouseIdSharingGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getHouseSharingHousesHouseIdSharingGetQueryKey(options)
});

/**
 * Add a user to this property's sharing list
 */
export const addUserToSharingHousesHouseIdSharingUsersPostMutation = (options?: Partial<Options<AddUserToSharingHousesHouseIdSharingUsersPostData>>): UseMutationOptions<AddUserToSharingHousesHouseIdSharingUsersPostResponse, AxiosError<AddUserToSharingHousesHouseIdSharingUsersPostError>, Options<AddUserToSharingHousesHouseIdSharingUsersPostData>> => {
    const mutationOptions: UseMutationOptions<AddUserToSharingHousesHouseIdSharingUsersPostResponse, AxiosError<AddUserToSharingHousesHouseIdSharingUsersPostError>, Options<AddUserToSharingHousesHouseIdSharingUsersPostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await Sharing.addUserToSharingHousesHouseIdSharingUsersPost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Send an invitation email to an added user
 */
export const inviteSharingUserHousesHouseIdSharingUsersUserIdInvitePostMutation = (options?: Partial<Options<InviteSharingUserHousesHouseIdSharingUsersUserIdInvitePostData>>): UseMutationOptions<InviteSharingUserHousesHouseIdSharingUsersUserIdInvitePostResponse, AxiosError<InviteSharingUserHousesHouseIdSharingUsersUserIdInvitePostError>, Options<InviteSharingUserHousesHouseIdSharingUsersUserIdInvitePostData>> => {
    const mutationOptions: UseMutationOptions<InviteSharingUserHousesHouseIdSharingUsersUserIdInvitePostResponse, AxiosError<InviteSharingUserHousesHouseIdSharingUsersUserIdInvitePostError>, Options<InviteSharingUserHousesHouseIdSharingUsersUserIdInvitePostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await Sharing.inviteSharingUserHousesHouseIdSharingUsersUserIdInvitePost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Revoke a user's access (the row is kept in the sharing list as revoked)
 */
export const removeSharingUserHousesHouseIdSharingUsersUserIdDeleteMutation = (options?: Partial<Options<RemoveSharingUserHousesHouseIdSharingUsersUserIdDeleteData>>): UseMutationOptions<RemoveSharingUserHousesHouseIdSharingUsersUserIdDeleteResponse, AxiosError<RemoveSharingUserHousesHouseIdSharingUsersUserIdDeleteError>, Options<RemoveSharingUserHousesHouseIdSharingUsersUserIdDeleteData>> => {
    const mutationOptions: UseMutationOptions<RemoveSharingUserHousesHouseIdSharingUsersUserIdDeleteResponse, AxiosError<RemoveSharingUserHousesHouseIdSharingUsersUserIdDeleteError>, Options<RemoveSharingUserHousesHouseIdSharingUsersUserIdDeleteData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await Sharing.removeSharingUserHousesHouseIdSharingUsersUserIdDelete({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Update a shared user's role
 */
export const updateSharingUserRoleHousesHouseIdSharingUsersUserIdPatchMutation = (options?: Partial<Options<UpdateSharingUserRoleHousesHouseIdSharingUsersUserIdPatchData>>): UseMutationOptions<UpdateSharingUserRoleHousesHouseIdSharingUsersUserIdPatchResponse, AxiosError<UpdateSharingUserRoleHousesHouseIdSharingUsersUserIdPatchError>, Options<UpdateSharingUserRoleHousesHouseIdSharingUsersUserIdPatchData>> => {
    const mutationOptions: UseMutationOptions<UpdateSharingUserRoleHousesHouseIdSharingUsersUserIdPatchResponse, AxiosError<UpdateSharingUserRoleHousesHouseIdSharingUsersUserIdPatchError>, Options<UpdateSharingUserRoleHousesHouseIdSharingUsersUserIdPatchData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await Sharing.updateSharingUserRoleHousesHouseIdSharingUsersUserIdPatch({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Update a shared user's access expiry date
 */
export const updateSharingUserExpiryHousesHouseIdSharingUsersUserIdExpiryPatchMutation = (options?: Partial<Options<UpdateSharingUserExpiryHousesHouseIdSharingUsersUserIdExpiryPatchData>>): UseMutationOptions<UpdateSharingUserExpiryHousesHouseIdSharingUsersUserIdExpiryPatchResponse, AxiosError<UpdateSharingUserExpiryHousesHouseIdSharingUsersUserIdExpiryPatchError>, Options<UpdateSharingUserExpiryHousesHouseIdSharingUsersUserIdExpiryPatchData>> => {
    const mutationOptions: UseMutationOptions<UpdateSharingUserExpiryHousesHouseIdSharingUsersUserIdExpiryPatchResponse, AxiosError<UpdateSharingUserExpiryHousesHouseIdSharingUsersUserIdExpiryPatchError>, Options<UpdateSharingUserExpiryHousesHouseIdSharingUsersUserIdExpiryPatchData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await Sharing.updateSharingUserExpiryHousesHouseIdSharingUsersUserIdExpiryPatch({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Accept a sharing invitation for this property
 */
export const acceptSharingInvitationHousesHouseIdSharingAcceptPostMutation = (options?: Partial<Options<AcceptSharingInvitationHousesHouseIdSharingAcceptPostData>>): UseMutationOptions<AcceptSharingInvitationHousesHouseIdSharingAcceptPostResponse, AxiosError<AcceptSharingInvitationHousesHouseIdSharingAcceptPostError>, Options<AcceptSharingInvitationHousesHouseIdSharingAcceptPostData>> => {
    const mutationOptions: UseMutationOptions<AcceptSharingInvitationHousesHouseIdSharingAcceptPostResponse, AxiosError<AcceptSharingInvitationHousesHouseIdSharingAcceptPostError>, Options<AcceptSharingInvitationHousesHouseIdSharingAcceptPostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await Sharing.acceptSharingInvitationHousesHouseIdSharingAcceptPost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getSharingUserActivityHousesHouseIdSharingUsersUserIdActivityGetQueryKey = (options: Options<GetSharingUserActivityHousesHouseIdSharingUsersUserIdActivityGetData>) => createQueryKey('getSharingUserActivityHousesHouseIdSharingUsersUserIdActivityGet', options);

/**
 * Access-activity timeline for a shared user
 *
 * The access-activity timeline (oldest first) for one user on a property: requests,
 * approvals, invites, expiry and role changes, removals and expiries. Scoped to the current
 * owner's tenure — a previous owner's events stay in the log but are not shown — and to the
 * product-visible events (audit-only events like `login` are excluded; see TIMELINE_EVENTS).
 */
export const getSharingUserActivityHousesHouseIdSharingUsersUserIdActivityGetOptions = (options: Options<GetSharingUserActivityHousesHouseIdSharingUsersUserIdActivityGetData>) => queryOptions<GetSharingUserActivityHousesHouseIdSharingUsersUserIdActivityGetResponse, AxiosError<GetSharingUserActivityHousesHouseIdSharingUsersUserIdActivityGetError>, GetSharingUserActivityHousesHouseIdSharingUsersUserIdActivityGetResponse, ReturnType<typeof getSharingUserActivityHousesHouseIdSharingUsersUserIdActivityGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await Sharing.getSharingUserActivityHousesHouseIdSharingUsersUserIdActivityGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getSharingUserActivityHousesHouseIdSharingUsersUserIdActivityGetQueryKey(options)
});

/**
 * Upload Documents V2
 *
 * Upload one or more documents and trigger the v2 ingestion DAG (bnd_v2 → metadata_profiling → metadata_extraction → kbs).
 *
 * Two shapes, one endpoint:
 *
 * - **Single file** (legacy ``file`` part, no ``files``/``bundle_spec``) — unchanged contract:
 * creates one document (or a text-only note when ``file`` is omitted) and returns it in
 * ``document``.
 * - **Multi-file / bundle** (a ``files`` list and/or a ``bundle_spec`` JSON part) — creates each
 * file's document resiliently (one bad or already-present file does not sink the others) and,
 * when ``bundle_spec`` is present, groups the created documents into a ``DocumentBundle``. The
 * created documents come back in ``documents``, the group in ``bundle_id``, and anything
 * skipped/failed in ``skipped_filenames`` / ``failed_filenames``.
 *
 * Files are stored in GCS and each kicks off bnd_v2 via Celery; downstream pipelines
 * (metadata_profiling, metadata_extraction, kbs) advance automatically via document-level
 * reconciliation once each stage completes.
 */
export const uploadDocumentsV2V2HousesHouseIdDocumentsPostMutation = (options?: Partial<Options<UploadDocumentsV2V2HousesHouseIdDocumentsPostData>>): UseMutationOptions<UploadDocumentsV2V2HousesHouseIdDocumentsPostResponse, AxiosError<UploadDocumentsV2V2HousesHouseIdDocumentsPostError>, Options<UploadDocumentsV2V2HousesHouseIdDocumentsPostData>> => {
    const mutationOptions: UseMutationOptions<UploadDocumentsV2V2HousesHouseIdDocumentsPostResponse, AxiosError<UploadDocumentsV2V2HousesHouseIdDocumentsPostError>, Options<UploadDocumentsV2V2HousesHouseIdDocumentsPostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await Documents.uploadDocumentsV2V2HousesHouseIdDocumentsPost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete Document V2
 *
 * Soft delete a v2 document.
 *
 * Marks the document as deleted synchronously, then triggers a background
 * task that tombstones metadata (property-level provenance/facts) and
 * removes the document from the Vertex AI KBS index.
 */
export const deleteDocumentV2V2HousesHouseIdDocumentsDocumentIdDeleteMutation = (options?: Partial<Options<DeleteDocumentV2V2HousesHouseIdDocumentsDocumentIdDeleteData>>): UseMutationOptions<DeleteDocumentV2V2HousesHouseIdDocumentsDocumentIdDeleteResponse, AxiosError<DeleteDocumentV2V2HousesHouseIdDocumentsDocumentIdDeleteError>, Options<DeleteDocumentV2V2HousesHouseIdDocumentsDocumentIdDeleteData>> => {
    const mutationOptions: UseMutationOptions<DeleteDocumentV2V2HousesHouseIdDocumentsDocumentIdDeleteResponse, AxiosError<DeleteDocumentV2V2HousesHouseIdDocumentsDocumentIdDeleteError>, Options<DeleteDocumentV2V2HousesHouseIdDocumentsDocumentIdDeleteData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await Documents.deleteDocumentV2V2HousesHouseIdDocumentsDocumentIdDelete({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getDocumentHousesHouseIdDocumentsDocumentIdGetQueryKey = (options: Options<GetDocumentHousesHouseIdDocumentsDocumentIdGetData>) => createQueryKey('getDocumentHousesHouseIdDocumentsDocumentIdGet', options);

/**
 * Get Document
 *
 * Get a single document with its presigned download URL, tags, and current summary.
 *
 * Use this endpoint to load document detail on demand from the UI instead of
 * fetching the full house document list.
 */
export const getDocumentHousesHouseIdDocumentsDocumentIdGetOptions = (options: Options<GetDocumentHousesHouseIdDocumentsDocumentIdGetData>) => queryOptions<GetDocumentHousesHouseIdDocumentsDocumentIdGetResponse, AxiosError<GetDocumentHousesHouseIdDocumentsDocumentIdGetError>, GetDocumentHousesHouseIdDocumentsDocumentIdGetResponse, ReturnType<typeof getDocumentHousesHouseIdDocumentsDocumentIdGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await Documents.getDocumentHousesHouseIdDocumentsDocumentIdGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getDocumentHousesHouseIdDocumentsDocumentIdGetQueryKey(options)
});

/**
 * Update Document
 *
 * Update document by deleting old version and creating new one.
 *
 * V3 Architecture (Delete + Re-upload):
 * - Soft-deletes the old document (sets is_deleted=True)
 * - Creates a new document with previous_document_id reference
 * - Returns both old and new document IDs
 * - Triggers background task to upload and process new document
 */
export const updateDocumentHousesHouseIdDocumentsDocumentIdPutMutation = (options?: Partial<Options<UpdateDocumentHousesHouseIdDocumentsDocumentIdPutData>>): UseMutationOptions<UpdateDocumentHousesHouseIdDocumentsDocumentIdPutResponse, AxiosError<UpdateDocumentHousesHouseIdDocumentsDocumentIdPutError>, Options<UpdateDocumentHousesHouseIdDocumentsDocumentIdPutData>> => {
    const mutationOptions: UseMutationOptions<UpdateDocumentHousesHouseIdDocumentsDocumentIdPutResponse, AxiosError<UpdateDocumentHousesHouseIdDocumentsDocumentIdPutError>, Options<UpdateDocumentHousesHouseIdDocumentsDocumentIdPutData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await Documents.updateDocumentHousesHouseIdDocumentsDocumentIdPut({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listDocumentsHousesHouseIdDocumentsGetQueryKey = (options: Options<ListDocumentsHousesHouseIdDocumentsGetData>) => createQueryKey('listDocumentsHousesHouseIdDocumentsGet', options);

/**
 * List Documents
 *
 * Get documents with presigned download URLs.
 *
 * This endpoint provides documents with presigned download URLs by default,
 * eliminating the N+1 query problem by:
 * 1. Fetching all documents in one database query
 * 2. Generating all presigned URLs in one S3 session
 *
 * Performance: ~200-500ms vs 2-3 seconds for equivalent individual calls
 */
export const listDocumentsHousesHouseIdDocumentsGetOptions = (options: Options<ListDocumentsHousesHouseIdDocumentsGetData>) => queryOptions<ListDocumentsHousesHouseIdDocumentsGetResponse, AxiosError<ListDocumentsHousesHouseIdDocumentsGetError>, ListDocumentsHousesHouseIdDocumentsGetResponse, ReturnType<typeof listDocumentsHousesHouseIdDocumentsGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await Documents.listDocumentsHousesHouseIdDocumentsGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listDocumentsHousesHouseIdDocumentsGetQueryKey(options)
});

export const listHouseCorrectionsHousesHouseIdCorrectionsGetQueryKey = (options: Options<ListHouseCorrectionsHousesHouseIdCorrectionsGetData>) => createQueryKey('listHouseCorrectionsHousesHouseIdCorrectionsGet', options);

/**
 * List House Corrections
 *
 * Everything the owner has corrected about this property, newest first.
 *
 * The document list carries each document's own corrections, so this exists for the ones it
 * cannot: a property fact amends no document, and appears nowhere else.
 *
 * Active corrections only. Removal is a soft deactivate and the rows are kept for the audit
 * trail; showing them would present a correction that no longer applies as if it still did.
 */
export const listHouseCorrectionsHousesHouseIdCorrectionsGetOptions = (options: Options<ListHouseCorrectionsHousesHouseIdCorrectionsGetData>) => queryOptions<ListHouseCorrectionsHousesHouseIdCorrectionsGetResponse, AxiosError<ListHouseCorrectionsHousesHouseIdCorrectionsGetError>, ListHouseCorrectionsHousesHouseIdCorrectionsGetResponse, ReturnType<typeof listHouseCorrectionsHousesHouseIdCorrectionsGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await Documents.listHouseCorrectionsHousesHouseIdCorrectionsGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listHouseCorrectionsHousesHouseIdCorrectionsGetQueryKey(options)
});

export const getKeyDocumentTagsHousesHouseIdDocumentsKeyDocTagsGetQueryKey = (options: Options<GetKeyDocumentTagsHousesHouseIdDocumentsKeyDocTagsGetData>) => createQueryKey('getKeyDocumentTagsHousesHouseIdDocumentsKeyDocTagsGet', options);

/**
 * Get Key Document Tags
 */
export const getKeyDocumentTagsHousesHouseIdDocumentsKeyDocTagsGetOptions = (options: Options<GetKeyDocumentTagsHousesHouseIdDocumentsKeyDocTagsGetData>) => queryOptions<GetKeyDocumentTagsHousesHouseIdDocumentsKeyDocTagsGetResponse, AxiosError<GetKeyDocumentTagsHousesHouseIdDocumentsKeyDocTagsGetError>, GetKeyDocumentTagsHousesHouseIdDocumentsKeyDocTagsGetResponse, ReturnType<typeof getKeyDocumentTagsHousesHouseIdDocumentsKeyDocTagsGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await Documents.getKeyDocumentTagsHousesHouseIdDocumentsKeyDocTagsGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getKeyDocumentTagsHousesHouseIdDocumentsKeyDocTagsGetQueryKey(options)
});

export const getHouseCriticalInfoHousesHouseIdCriticalInfoGetQueryKey = (options: Options<GetHouseCriticalInfoHousesHouseIdCriticalInfoGetData>) => createQueryKey('getHouseCriticalInfoHousesHouseIdCriticalInfoGet', options);

/**
 * Get House Critical Info
 */
export const getHouseCriticalInfoHousesHouseIdCriticalInfoGetOptions = (options: Options<GetHouseCriticalInfoHousesHouseIdCriticalInfoGetData>) => queryOptions<unknown, AxiosError<GetHouseCriticalInfoHousesHouseIdCriticalInfoGetError>, unknown, ReturnType<typeof getHouseCriticalInfoHousesHouseIdCriticalInfoGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await Documents.getHouseCriticalInfoHousesHouseIdCriticalInfoGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getHouseCriticalInfoHousesHouseIdCriticalInfoGetQueryKey(options)
});

/**
 * Update House Critical Info
 *
 * Update critical info using versioned delete-and-create pattern.
 *
 * This follows the same pattern as update_document by reusing the
 * replace_document_with_new_version service function.
 */
export const updateHouseCriticalInfoHousesHouseIdCriticalInfoPutMutation = (options?: Partial<Options<UpdateHouseCriticalInfoHousesHouseIdCriticalInfoPutData>>): UseMutationOptions<UpdateHouseCriticalInfoHousesHouseIdCriticalInfoPutResponse, AxiosError<UpdateHouseCriticalInfoHousesHouseIdCriticalInfoPutError>, Options<UpdateHouseCriticalInfoHousesHouseIdCriticalInfoPutData>> => {
    const mutationOptions: UseMutationOptions<UpdateHouseCriticalInfoHousesHouseIdCriticalInfoPutResponse, AxiosError<UpdateHouseCriticalInfoHousesHouseIdCriticalInfoPutError>, Options<UpdateHouseCriticalInfoHousesHouseIdCriticalInfoPutData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await Documents.updateHouseCriticalInfoHousesHouseIdCriticalInfoPut({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Add Tag To Document
 *
 * Add a tag to a document.
 */
export const addTagToDocumentHousesHouseIdDocumentsTagsPostMutation = (options?: Partial<Options<AddTagToDocumentHousesHouseIdDocumentsTagsPostData>>): UseMutationOptions<AddTagToDocumentHousesHouseIdDocumentsTagsPostResponse, AxiosError<AddTagToDocumentHousesHouseIdDocumentsTagsPostError>, Options<AddTagToDocumentHousesHouseIdDocumentsTagsPostData>> => {
    const mutationOptions: UseMutationOptions<AddTagToDocumentHousesHouseIdDocumentsTagsPostResponse, AxiosError<AddTagToDocumentHousesHouseIdDocumentsTagsPostError>, Options<AddTagToDocumentHousesHouseIdDocumentsTagsPostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await Documents.addTagToDocumentHousesHouseIdDocumentsTagsPost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Replace Tag In Document
 *
 * Replace a tag in a document.
 */
export const replaceTagInDocumentHousesHouseIdDocumentsTagsPutMutation = (options?: Partial<Options<ReplaceTagInDocumentHousesHouseIdDocumentsTagsPutData>>): UseMutationOptions<ReplaceTagInDocumentHousesHouseIdDocumentsTagsPutResponse, AxiosError<ReplaceTagInDocumentHousesHouseIdDocumentsTagsPutError>, Options<ReplaceTagInDocumentHousesHouseIdDocumentsTagsPutData>> => {
    const mutationOptions: UseMutationOptions<ReplaceTagInDocumentHousesHouseIdDocumentsTagsPutResponse, AxiosError<ReplaceTagInDocumentHousesHouseIdDocumentsTagsPutError>, Options<ReplaceTagInDocumentHousesHouseIdDocumentsTagsPutData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await Documents.replaceTagInDocumentHousesHouseIdDocumentsTagsPut({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Remove Tag From Document
 *
 * Remove a tag from a document.
 */
export const removeTagFromDocumentDocumentsTagsDeleteMutation = (options?: Partial<Options<RemoveTagFromDocumentDocumentsTagsDeleteData>>): UseMutationOptions<RemoveTagFromDocumentDocumentsTagsDeleteResponse, AxiosError<RemoveTagFromDocumentDocumentsTagsDeleteError>, Options<RemoveTagFromDocumentDocumentsTagsDeleteData>> => {
    const mutationOptions: UseMutationOptions<RemoveTagFromDocumentDocumentsTagsDeleteResponse, AxiosError<RemoveTagFromDocumentDocumentsTagsDeleteError>, Options<RemoveTagFromDocumentDocumentsTagsDeleteData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await Documents.removeTagFromDocumentDocumentsTagsDelete({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getClassificationTagsTagsClassificationsGetQueryKey = (options?: Options<GetClassificationTagsTagsClassificationsGetData>) => createQueryKey('getClassificationTagsTagsClassificationsGet', options);

/**
 * Get Classification Tags
 *
 * Retrieve all classification tags for document categorization.
 *
 * These tags are surfaced to users for organizing documents into categories
 * like "Property & Site", "Services", "Plans & Drawings", etc.
 *
 * Parameters:
 * - active_only (bool): If True, only return active tags. Default: True
 *
 * Returns:
 * - List[Tag]: List of classification tags ordered by name
 */
export const getClassificationTagsTagsClassificationsGetOptions = (options?: Options<GetClassificationTagsTagsClassificationsGetData>) => queryOptions<GetClassificationTagsTagsClassificationsGetResponse, AxiosError<GetClassificationTagsTagsClassificationsGetError>, GetClassificationTagsTagsClassificationsGetResponse, ReturnType<typeof getClassificationTagsTagsClassificationsGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await Documents.getClassificationTagsTagsClassificationsGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getClassificationTagsTagsClassificationsGetQueryKey(options)
});

/**
 * Get Batch Download Urls
 *
 * Get presigned download URLs for specific documents in a single request.
 *
 * This eliminates the N+1 query problem for selective document downloads.
 * Use this when you only need URLs for specific documents.
 */
export const getBatchDownloadUrlsHousesHouseIdDocumentsBatchDownloadUrlsPostMutation = (options?: Partial<Options<GetBatchDownloadUrlsHousesHouseIdDocumentsBatchDownloadUrlsPostData>>): UseMutationOptions<GetBatchDownloadUrlsHousesHouseIdDocumentsBatchDownloadUrlsPostResponse, AxiosError<GetBatchDownloadUrlsHousesHouseIdDocumentsBatchDownloadUrlsPostError>, Options<GetBatchDownloadUrlsHousesHouseIdDocumentsBatchDownloadUrlsPostData>> => {
    const mutationOptions: UseMutationOptions<GetBatchDownloadUrlsHousesHouseIdDocumentsBatchDownloadUrlsPostResponse, AxiosError<GetBatchDownloadUrlsHousesHouseIdDocumentsBatchDownloadUrlsPostError>, Options<GetBatchDownloadUrlsHousesHouseIdDocumentsBatchDownloadUrlsPostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await Documents.getBatchDownloadUrlsHousesHouseIdDocumentsBatchDownloadUrlsPost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const downloadDocumentOptimizedHousesHouseIdDocumentsDocumentIdDownloadGetQueryKey = (options: Options<DownloadDocumentOptimizedHousesHouseIdDocumentsDocumentIdDownloadGetData>) => createQueryKey('downloadDocumentOptimizedHousesHouseIdDocumentsDocumentIdDownloadGet', options);

/**
 * Download Document Optimized
 *
 * Get presigned download URL for a single document.
 * Now uses the optimized batch function internally for consistency.
 */
export const downloadDocumentOptimizedHousesHouseIdDocumentsDocumentIdDownloadGetOptions = (options: Options<DownloadDocumentOptimizedHousesHouseIdDocumentsDocumentIdDownloadGetData>) => queryOptions<unknown, AxiosError<DownloadDocumentOptimizedHousesHouseIdDocumentsDocumentIdDownloadGetError>, unknown, ReturnType<typeof downloadDocumentOptimizedHousesHouseIdDocumentsDocumentIdDownloadGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await Documents.downloadDocumentOptimizedHousesHouseIdDocumentsDocumentIdDownloadGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: downloadDocumentOptimizedHousesHouseIdDocumentsDocumentIdDownloadGetQueryKey(options)
});

/**
 * Update document visibility (private/public)
 */
export const updateDocumentVisibilityHousesHouseIdDocumentsDocumentIdVisibilityPatchMutation = (options?: Partial<Options<UpdateDocumentVisibilityHousesHouseIdDocumentsDocumentIdVisibilityPatchData>>): UseMutationOptions<UpdateDocumentVisibilityHousesHouseIdDocumentsDocumentIdVisibilityPatchResponse, AxiosError<UpdateDocumentVisibilityHousesHouseIdDocumentsDocumentIdVisibilityPatchError>, Options<UpdateDocumentVisibilityHousesHouseIdDocumentsDocumentIdVisibilityPatchData>> => {
    const mutationOptions: UseMutationOptions<UpdateDocumentVisibilityHousesHouseIdDocumentsDocumentIdVisibilityPatchResponse, AxiosError<UpdateDocumentVisibilityHousesHouseIdDocumentsDocumentIdVisibilityPatchError>, Options<UpdateDocumentVisibilityHousesHouseIdDocumentsDocumentIdVisibilityPatchData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await Documents.updateDocumentVisibilityHousesHouseIdDocumentsDocumentIdVisibilityPatch({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Share Documents With Owner Endpoint
 *
 * Share/Sync multiple documents with the property owner.
 *
 * Executes synchronously: creates PendingDocumentShare records and dispatches
 * document.shared events for notifications. No background tasks are scheduled.
 *
 * - Authorization: Requires HOUSE_DOCUMENT_SHARE_PROPOSED permission for the house (Owner only).
 * - The user must have access to all documents being shared.
 * - Accepts a list of document_ids and an optional message in the body.
 * - Returns a list of created pending shares.
 */
export const shareDocumentsWithOwnerEndpointHousesHouseIdDocumentsSharePostMutation = (options?: Partial<Options<ShareDocumentsWithOwnerEndpointHousesHouseIdDocumentsSharePostData>>): UseMutationOptions<ShareDocumentsWithOwnerEndpointHousesHouseIdDocumentsSharePostResponse, AxiosError<ShareDocumentsWithOwnerEndpointHousesHouseIdDocumentsSharePostError>, Options<ShareDocumentsWithOwnerEndpointHousesHouseIdDocumentsSharePostData>> => {
    const mutationOptions: UseMutationOptions<ShareDocumentsWithOwnerEndpointHousesHouseIdDocumentsSharePostResponse, AxiosError<ShareDocumentsWithOwnerEndpointHousesHouseIdDocumentsSharePostError>, Options<ShareDocumentsWithOwnerEndpointHousesHouseIdDocumentsSharePostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await Documents.shareDocumentsWithOwnerEndpointHousesHouseIdDocumentsSharePost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getHousePipelineStatusV2HousesHouseIdPipelineV2StatusGetQueryKey = (options: Options<GetHousePipelineStatusV2HousesHouseIdPipelineV2StatusGetData>) => createQueryKey('getHousePipelineStatusV2HousesHouseIdPipelineV2StatusGet', options);

/**
 * Get House Pipeline Status V2
 *
 * Get aggregate pipeline status for all documents in a house — V2 pipelines.
 *
 * Returns counts for bnd_v2, metadata, kbs, and document_enrichment pipelines
 * across all non-deleted documents. A house is fully complete when all documents
 * have kbs == COMPLETED (terminal node of the V2 DAG).
 *
 * Never returns arrays — always a single aggregate object with counts.
 */
export const getHousePipelineStatusV2HousesHouseIdPipelineV2StatusGetOptions = (options: Options<GetHousePipelineStatusV2HousesHouseIdPipelineV2StatusGetData>) => queryOptions<GetHousePipelineStatusV2HousesHouseIdPipelineV2StatusGetResponse, AxiosError<GetHousePipelineStatusV2HousesHouseIdPipelineV2StatusGetError>, GetHousePipelineStatusV2HousesHouseIdPipelineV2StatusGetResponse, ReturnType<typeof getHousePipelineStatusV2HousesHouseIdPipelineV2StatusGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await Documents.getHousePipelineStatusV2HousesHouseIdPipelineV2StatusGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getHousePipelineStatusV2HousesHouseIdPipelineV2StatusGetQueryKey(options)
});

export const getHouseDocumentsStatusHousesHouseIdDocumentsStatusGetQueryKey = (options: Options<GetHouseDocumentsStatusHousesHouseIdDocumentsStatusGetData>) => createQueryKey('getHouseDocumentsStatusHousesHouseIdDocumentsStatusGet', options);

/**
 * Get House Documents Status
 *
 * [DEPRECATED] Get pipeline status for all documents in a house — V1 pipelines only.
 *
 * Returns an array with one entry per non-deleted document, including pipeline
 * status for bnd and kb_sync. Use /houses/{house_id}/documents/v2/status for V2 pipelines.
 *
 * Excludes soft-deleted documents.
 *
 * Supports HTTP caching via Last-Modified/If-Modified-Since headers.
 *
 * @deprecated
 */
export const getHouseDocumentsStatusHousesHouseIdDocumentsStatusGetOptions = (options: Options<GetHouseDocumentsStatusHousesHouseIdDocumentsStatusGetData>) => queryOptions<GetHouseDocumentsStatusHousesHouseIdDocumentsStatusGetResponse, AxiosError<GetHouseDocumentsStatusHousesHouseIdDocumentsStatusGetError>, GetHouseDocumentsStatusHousesHouseIdDocumentsStatusGetResponse, ReturnType<typeof getHouseDocumentsStatusHousesHouseIdDocumentsStatusGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await Documents.getHouseDocumentsStatusHousesHouseIdDocumentsStatusGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getHouseDocumentsStatusHousesHouseIdDocumentsStatusGetQueryKey(options)
});

export const getHouseDocumentsStatusV2HousesHouseIdDocumentsV2StatusGetQueryKey = (options: Options<GetHouseDocumentsStatusV2HousesHouseIdDocumentsV2StatusGetData>) => createQueryKey('getHouseDocumentsStatusV2HousesHouseIdDocumentsV2StatusGet', options);

/**
 * Get House Documents Status V2
 *
 * Get pipeline status for all documents in a house — V2 pipelines.
 *
 * Returns an array with one entry per non-deleted document, including pipeline
 * status for bnd_v2, metadata, kbs, and document_enrichment.
 *
 * Excludes soft-deleted documents.
 *
 * Supports HTTP caching via Last-Modified/If-Modified-Since headers.
 */
export const getHouseDocumentsStatusV2HousesHouseIdDocumentsV2StatusGetOptions = (options: Options<GetHouseDocumentsStatusV2HousesHouseIdDocumentsV2StatusGetData>) => queryOptions<GetHouseDocumentsStatusV2HousesHouseIdDocumentsV2StatusGetResponse, AxiosError<GetHouseDocumentsStatusV2HousesHouseIdDocumentsV2StatusGetError>, GetHouseDocumentsStatusV2HousesHouseIdDocumentsV2StatusGetResponse, ReturnType<typeof getHouseDocumentsStatusV2HousesHouseIdDocumentsV2StatusGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await Documents.getHouseDocumentsStatusV2HousesHouseIdDocumentsV2StatusGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getHouseDocumentsStatusV2HousesHouseIdDocumentsV2StatusGetQueryKey(options)
});

/**
 * Finalize House Setup
 *
 * Finalize house setup after all initial documents are uploaded.
 *
 * This endpoint:
 * 1. Sets house.onboarded = True flag (synchronously)
 * 2. Triggers email delivery (asynchronously via Celery)
 *
 * Maintenance schedule generation is triggered separately.
 *
 * Should be called by UI when user completes document upload step.
 *
 * Returns:
 * 200 OK with success message
 */
export const finalizeHouseSetupHousesHouseIdFinalizePostMutation = (options?: Partial<Options<FinalizeHouseSetupHousesHouseIdFinalizePostData>>): UseMutationOptions<FinalizeHouseSetupHousesHouseIdFinalizePostResponse, AxiosError<FinalizeHouseSetupHousesHouseIdFinalizePostError>, Options<FinalizeHouseSetupHousesHouseIdFinalizePostData>> => {
    const mutationOptions: UseMutationOptions<FinalizeHouseSetupHousesHouseIdFinalizePostResponse, AxiosError<FinalizeHouseSetupHousesHouseIdFinalizePostError>, Options<FinalizeHouseSetupHousesHouseIdFinalizePostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await Documents.finalizeHouseSetupHousesHouseIdFinalizePost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listReceivedPendingSharesHousesHouseIdDocumentsPendingReceivedGetQueryKey = (options: Options<ListReceivedPendingSharesHousesHouseIdDocumentsPendingReceivedGetData>) => createQueryKey('listReceivedPendingSharesHousesHouseIdDocumentsPendingReceivedGet', options);

/**
 * List Received Pending Shares
 *
 * List pending document shares targeting this house (house needs to accept).
 * Includes presigned download URLs for document preview.
 */
export const listReceivedPendingSharesHousesHouseIdDocumentsPendingReceivedGetOptions = (options: Options<ListReceivedPendingSharesHousesHouseIdDocumentsPendingReceivedGetData>) => queryOptions<ListReceivedPendingSharesHousesHouseIdDocumentsPendingReceivedGetResponse, AxiosError<ListReceivedPendingSharesHousesHouseIdDocumentsPendingReceivedGetError>, ListReceivedPendingSharesHousesHouseIdDocumentsPendingReceivedGetResponse, ReturnType<typeof listReceivedPendingSharesHousesHouseIdDocumentsPendingReceivedGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await Documents.listReceivedPendingSharesHousesHouseIdDocumentsPendingReceivedGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listReceivedPendingSharesHousesHouseIdDocumentsPendingReceivedGetQueryKey(options)
});

export const listSentPendingSharesHousesHouseIdDocumentsPendingSentGetQueryKey = (options: Options<ListSentPendingSharesHousesHouseIdDocumentsPendingSentGetData>) => createQueryKey('listSentPendingSharesHousesHouseIdDocumentsPendingSentGet', options);

/**
 * List Sent Pending Shares
 *
 * List pending document shares originating from this house (shared from documents of this house).
 */
export const listSentPendingSharesHousesHouseIdDocumentsPendingSentGetOptions = (options: Options<ListSentPendingSharesHousesHouseIdDocumentsPendingSentGetData>) => queryOptions<ListSentPendingSharesHousesHouseIdDocumentsPendingSentGetResponse, AxiosError<ListSentPendingSharesHousesHouseIdDocumentsPendingSentGetError>, ListSentPendingSharesHousesHouseIdDocumentsPendingSentGetResponse, ReturnType<typeof listSentPendingSharesHousesHouseIdDocumentsPendingSentGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await Documents.listSentPendingSharesHousesHouseIdDocumentsPendingSentGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listSentPendingSharesHousesHouseIdDocumentsPendingSentGetQueryKey(options)
});

export const getPendingShareHousesHouseIdDocumentsPendingShareIdGetQueryKey = (options: Options<GetPendingShareHousesHouseIdDocumentsPendingShareIdGetData>) => createQueryKey('getPendingShareHousesHouseIdDocumentsPendingShareIdGet', options);

/**
 * Get Pending Share
 *
 * Get a specific pending document share by ID.
 */
export const getPendingShareHousesHouseIdDocumentsPendingShareIdGetOptions = (options: Options<GetPendingShareHousesHouseIdDocumentsPendingShareIdGetData>) => queryOptions<GetPendingShareHousesHouseIdDocumentsPendingShareIdGetResponse, AxiosError<GetPendingShareHousesHouseIdDocumentsPendingShareIdGetError>, GetPendingShareHousesHouseIdDocumentsPendingShareIdGetResponse, ReturnType<typeof getPendingShareHousesHouseIdDocumentsPendingShareIdGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await Documents.getPendingShareHousesHouseIdDocumentsPendingShareIdGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getPendingShareHousesHouseIdDocumentsPendingShareIdGetQueryKey(options)
});

/**
 * Update Pending Share Status
 *
 * Accept or reject a pending document share.
 *
 * Only the share recipient (shared_to_user) can perform this action.
 * Updates the share status and marks the related notification as acted upon.
 *
 * Request body:
 * - status: "accepted" or "rejected"
 * - resolution_note: Optional note explaining rejection
 *
 * Returns:
 * - 200 with updated PendingDocumentShareResponse on success
 * - 400 if share is not pending or invalid status
 * - 403 if user is not the share recipient
 * - 404 if share not found
 */
export const updatePendingShareStatusHousesHouseIdDocumentsPendingShareIdStatusPutMutation = (options?: Partial<Options<UpdatePendingShareStatusHousesHouseIdDocumentsPendingShareIdStatusPutData>>): UseMutationOptions<UpdatePendingShareStatusHousesHouseIdDocumentsPendingShareIdStatusPutResponse, AxiosError<UpdatePendingShareStatusHousesHouseIdDocumentsPendingShareIdStatusPutError>, Options<UpdatePendingShareStatusHousesHouseIdDocumentsPendingShareIdStatusPutData>> => {
    const mutationOptions: UseMutationOptions<UpdatePendingShareStatusHousesHouseIdDocumentsPendingShareIdStatusPutResponse, AxiosError<UpdatePendingShareStatusHousesHouseIdDocumentsPendingShareIdStatusPutError>, Options<UpdatePendingShareStatusHousesHouseIdDocumentsPendingShareIdStatusPutData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await Documents.updatePendingShareStatusHousesHouseIdDocumentsPendingShareIdStatusPut({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getNotificationsHousesHouseIdNotificationsGetQueryKey = (options: Options<GetNotificationsHousesHouseIdNotificationsGetData>) => createQueryKey('getNotificationsHousesHouseIdNotificationsGet', options);

/**
 * Get Notifications
 *
 * Get notifications for the current user scoped to a specific house.
 *
 * Query parameters:
 * - status: Filter by status (pending, sent, read, acted_upon, expired)
 * - type: Filter by type (document_share_request, etc.)
 * - limit: Maximum number of notifications to return (default 50)
 */
export const getNotificationsHousesHouseIdNotificationsGetOptions = (options: Options<GetNotificationsHousesHouseIdNotificationsGetData>) => queryOptions<GetNotificationsHousesHouseIdNotificationsGetResponse, AxiosError<GetNotificationsHousesHouseIdNotificationsGetError>, GetNotificationsHousesHouseIdNotificationsGetResponse, ReturnType<typeof getNotificationsHousesHouseIdNotificationsGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await Notifications.getNotificationsHousesHouseIdNotificationsGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getNotificationsHousesHouseIdNotificationsGetQueryKey(options)
});

/**
 * Mark Notification As Read
 *
 * Mark a notification as read.
 */
export const markNotificationAsReadHousesHouseIdNotificationsNotificationIdReadPostMutation = (options?: Partial<Options<MarkNotificationAsReadHousesHouseIdNotificationsNotificationIdReadPostData>>): UseMutationOptions<unknown, AxiosError<MarkNotificationAsReadHousesHouseIdNotificationsNotificationIdReadPostError>, Options<MarkNotificationAsReadHousesHouseIdNotificationsNotificationIdReadPostData>> => {
    const mutationOptions: UseMutationOptions<unknown, AxiosError<MarkNotificationAsReadHousesHouseIdNotificationsNotificationIdReadPostError>, Options<MarkNotificationAsReadHousesHouseIdNotificationsNotificationIdReadPostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await Notifications.markNotificationAsReadHousesHouseIdNotificationsNotificationIdReadPost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getNotificationHousesHouseIdNotificationsNotificationIdGetQueryKey = (options: Options<GetNotificationHousesHouseIdNotificationsNotificationIdGetData>) => createQueryKey('getNotificationHousesHouseIdNotificationsNotificationIdGet', options);

/**
 * Get Notification
 *
 * Get a specific notification by ID scoped to a house.
 */
export const getNotificationHousesHouseIdNotificationsNotificationIdGetOptions = (options: Options<GetNotificationHousesHouseIdNotificationsNotificationIdGetData>) => queryOptions<GetNotificationHousesHouseIdNotificationsNotificationIdGetResponse, AxiosError<GetNotificationHousesHouseIdNotificationsNotificationIdGetError>, GetNotificationHousesHouseIdNotificationsNotificationIdGetResponse, ReturnType<typeof getNotificationHousesHouseIdNotificationsNotificationIdGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await Notifications.getNotificationHousesHouseIdNotificationsNotificationIdGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getNotificationHousesHouseIdNotificationsNotificationIdGetQueryKey(options)
});

/**
 * Post Plan Action
 *
 * Apply one plan action on a card the homeowner acts on by echoing its opaque ``resolve_token``.
 *
 * ONE endpoint, two transports (content-negotiated): a JSON body for a file-less action
 * (dismiss/keep/complete/snooze/skip/clear/note/reschedule/edit/…), or
 * ``multipart/form-data`` when the action carries a comment and/or file attachments — the latter
 * become a ``maintenance_resolution`` bundle anchored to the occurrence, mirrored onto the plan
 * card (comment + attachment references). Both flow through the same evidence core.
 *
 * The token decodes to the durable obligation anchor; the decision (and any bundle + members +
 * occasion anchor + write-through mirrors) is appended + projected in ONE transaction — the atomic
 * acceptance boundary — after which attachment ingestion is scheduled async and the plan cache is
 * asked to reconcile. A token this server did not mint is a 422, never a guess at an anchor.
 * Idempotent on an optional ``client_token``: a retry with the same token replays the stored
 * response without re-executing (so a double-submit never creates a duplicate bundle), and a token
 * reused for a different request is a 409. Custom-entry create has its own endpoint (it mints the
 * anchor).
 */
export const postPlanActionV2HousesHouseIdMaintenanceActionsPostMutation = (options?: Partial<Options<PostPlanActionV2HousesHouseIdMaintenanceActionsPostData>>): UseMutationOptions<PostPlanActionV2HousesHouseIdMaintenanceActionsPostResponse, AxiosError<PostPlanActionV2HousesHouseIdMaintenanceActionsPostError>, Options<PostPlanActionV2HousesHouseIdMaintenanceActionsPostData>> => {
    const mutationOptions: UseMutationOptions<PostPlanActionV2HousesHouseIdMaintenanceActionsPostResponse, AxiosError<PostPlanActionV2HousesHouseIdMaintenanceActionsPostError>, Options<PostPlanActionV2HousesHouseIdMaintenanceActionsPostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await MaintenanceV2.postPlanActionV2HousesHouseIdMaintenanceActionsPost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getMaintenancePlanV2HousesHouseIdMaintenancePlanGetQueryKey = (options: Options<GetMaintenancePlanV2HousesHouseIdMaintenancePlanGetData>) => createQueryKey('getMaintenancePlanV2HousesHouseIdMaintenancePlanGet', options);

/**
 * Get Maintenance Plan
 *
 * The property's unified maintenance plan — the read model the homeowner UI consumes.
 *
 * Read-only. Thin wrapper over ``get_property_maintenance_plan`` (the SAME function the local
 * plan-viewer QA tool renders, with ``emit_plan_nodes=True``), served through the durable
 * per-property view-cache: the unfiltered core is computed once and cached, and
 * filter/sort/paginate + the PlanNode projection run cheaply on egress. Facets are computed over
 * the UNFILTERED set (so the UI can show counts for unselected filters); grouping happens before
 * pagination, so a grouped card counts as one item and its children travel with it. The cache is
 * always-on and fail-open, so a read never fails on a cache error — it degrades to a live compute.
 *
 * Calendar view: pass ``occurrences_from`` + ``occurrences_to`` to have each recurring card carry
 * its dated ``occurrences[]`` in that window (materialized instances, not rule re-expansion), so
 * the FE can render a calendar that shows recurrence across years. Occurrences beyond the
 * materialized horizon are not returned — see the horizon note in the service. ``occurrence_status``
 * then filters those nested occurrences by their OWN state (``completed,skipped,snoozed`` for a
 * History view that skips the untouched upcoming dates) — it narrows the nested list, never the
 * cards, so a card with no matching date simply carries an empty ``occurrences[]``.
 */
export const getMaintenancePlanV2HousesHouseIdMaintenancePlanGetOptions = (options: Options<GetMaintenancePlanV2HousesHouseIdMaintenancePlanGetData>) => queryOptions<GetMaintenancePlanV2HousesHouseIdMaintenancePlanGetResponse, AxiosError<GetMaintenancePlanV2HousesHouseIdMaintenancePlanGetError>, GetMaintenancePlanV2HousesHouseIdMaintenancePlanGetResponse, ReturnType<typeof getMaintenancePlanV2HousesHouseIdMaintenancePlanGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await MaintenanceV2.getMaintenancePlanV2HousesHouseIdMaintenancePlanGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getMaintenancePlanV2HousesHouseIdMaintenancePlanGetQueryKey(options)
});

export const getMaintenancePlanV2HousesHouseIdMaintenancePlanGetInfiniteQueryKey = (options: Options<GetMaintenancePlanV2HousesHouseIdMaintenancePlanGetData>): QueryKey<Options<GetMaintenancePlanV2HousesHouseIdMaintenancePlanGetData>> => createQueryKey('getMaintenancePlanV2HousesHouseIdMaintenancePlanGet', options, true);

/**
 * Get Maintenance Plan
 *
 * The property's unified maintenance plan — the read model the homeowner UI consumes.
 *
 * Read-only. Thin wrapper over ``get_property_maintenance_plan`` (the SAME function the local
 * plan-viewer QA tool renders, with ``emit_plan_nodes=True``), served through the durable
 * per-property view-cache: the unfiltered core is computed once and cached, and
 * filter/sort/paginate + the PlanNode projection run cheaply on egress. Facets are computed over
 * the UNFILTERED set (so the UI can show counts for unselected filters); grouping happens before
 * pagination, so a grouped card counts as one item and its children travel with it. The cache is
 * always-on and fail-open, so a read never fails on a cache error — it degrades to a live compute.
 *
 * Calendar view: pass ``occurrences_from`` + ``occurrences_to`` to have each recurring card carry
 * its dated ``occurrences[]`` in that window (materialized instances, not rule re-expansion), so
 * the FE can render a calendar that shows recurrence across years. Occurrences beyond the
 * materialized horizon are not returned — see the horizon note in the service. ``occurrence_status``
 * then filters those nested occurrences by their OWN state (``completed,skipped,snoozed`` for a
 * History view that skips the untouched upcoming dates) — it narrows the nested list, never the
 * cards, so a card with no matching date simply carries an empty ``occurrences[]``.
 */
export const getMaintenancePlanV2HousesHouseIdMaintenancePlanGetInfiniteOptions = (options: Options<GetMaintenancePlanV2HousesHouseIdMaintenancePlanGetData>) => infiniteQueryOptions<GetMaintenancePlanV2HousesHouseIdMaintenancePlanGetResponse, AxiosError<GetMaintenancePlanV2HousesHouseIdMaintenancePlanGetError>, InfiniteData<GetMaintenancePlanV2HousesHouseIdMaintenancePlanGetResponse>, QueryKey<Options<GetMaintenancePlanV2HousesHouseIdMaintenancePlanGetData>>, number | Pick<QueryKey<Options<GetMaintenancePlanV2HousesHouseIdMaintenancePlanGetData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<GetMaintenancePlanV2HousesHouseIdMaintenancePlanGetData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                offset: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await MaintenanceV2.getMaintenancePlanV2HousesHouseIdMaintenancePlanGet({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getMaintenancePlanV2HousesHouseIdMaintenancePlanGetInfiniteQueryKey(options)
});

export const getCardTimelineV2HousesHouseIdMaintenanceTimelineGetQueryKey = (options: Options<GetCardTimelineV2HousesHouseIdMaintenanceTimelineGetData>) => createQueryKey('getCardTimelineV2HousesHouseIdMaintenanceTimelineGet', options);

/**
 * Get Card Timeline
 *
 * What has happened to one card — every verdict, edit, deferral and completion, newest first.
 *
 * Read-only, and deliberately separate from the plan: the plan says what is true of a card now,
 * this says what the household decided and when. Rows are folded into the actions that produced
 * them, so a completion carrying a comment and a photo reads as one entry rather than three (see
 * `TimelineActionOut`). Decisions recorded before actions were correlated are reported as actions
 * of one rather than guessed into groups.
 */
export const getCardTimelineV2HousesHouseIdMaintenanceTimelineGetOptions = (options: Options<GetCardTimelineV2HousesHouseIdMaintenanceTimelineGetData>) => queryOptions<GetCardTimelineV2HousesHouseIdMaintenanceTimelineGetResponse, AxiosError<GetCardTimelineV2HousesHouseIdMaintenanceTimelineGetError>, GetCardTimelineV2HousesHouseIdMaintenanceTimelineGetResponse, ReturnType<typeof getCardTimelineV2HousesHouseIdMaintenanceTimelineGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await MaintenanceV2.getCardTimelineV2HousesHouseIdMaintenanceTimelineGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getCardTimelineV2HousesHouseIdMaintenanceTimelineGetQueryKey(options)
});

export const getCardTimelineV2HousesHouseIdMaintenanceTimelineGetInfiniteQueryKey = (options: Options<GetCardTimelineV2HousesHouseIdMaintenanceTimelineGetData>): QueryKey<Options<GetCardTimelineV2HousesHouseIdMaintenanceTimelineGetData>> => createQueryKey('getCardTimelineV2HousesHouseIdMaintenanceTimelineGet', options, true);

/**
 * Get Card Timeline
 *
 * What has happened to one card — every verdict, edit, deferral and completion, newest first.
 *
 * Read-only, and deliberately separate from the plan: the plan says what is true of a card now,
 * this says what the household decided and when. Rows are folded into the actions that produced
 * them, so a completion carrying a comment and a photo reads as one entry rather than three (see
 * `TimelineActionOut`). Decisions recorded before actions were correlated are reported as actions
 * of one rather than guessed into groups.
 */
export const getCardTimelineV2HousesHouseIdMaintenanceTimelineGetInfiniteOptions = (options: Options<GetCardTimelineV2HousesHouseIdMaintenanceTimelineGetData>) => infiniteQueryOptions<GetCardTimelineV2HousesHouseIdMaintenanceTimelineGetResponse, AxiosError<GetCardTimelineV2HousesHouseIdMaintenanceTimelineGetError>, InfiniteData<GetCardTimelineV2HousesHouseIdMaintenanceTimelineGetResponse>, QueryKey<Options<GetCardTimelineV2HousesHouseIdMaintenanceTimelineGetData>>, number | Pick<QueryKey<Options<GetCardTimelineV2HousesHouseIdMaintenanceTimelineGetData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<GetCardTimelineV2HousesHouseIdMaintenanceTimelineGetData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                offset: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await MaintenanceV2.getCardTimelineV2HousesHouseIdMaintenanceTimelineGet({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getCardTimelineV2HousesHouseIdMaintenanceTimelineGetInfiniteQueryKey(options)
});

export const getDiscardedCardsV2HousesHouseIdMaintenanceDiscardedGetQueryKey = (options: Options<GetDiscardedCardsV2HousesHouseIdMaintenanceDiscardedGetData>) => createQueryKey('getDiscardedCardsV2HousesHouseIdMaintenanceDiscardedGet', options);

/**
 * Get Discarded Cards
 *
 * The cards the homeowner has discarded — History's restore list.
 *
 * Read-only, and deliberately separate from the plan read: the active plan, its cache and its
 * counts are untouched, so opening this can never move a plan number. Every card comes back as a
 * normal PlanNode carrying `review.status = "removed"` and `restore` in `allowed_actions` (pruned to
 * what THIS reader may do), so it renders with the same components as any other card and is put back
 * through the same action endpoint — echo the card's `resolve_token` with `action="restore"`.
 */
export const getDiscardedCardsV2HousesHouseIdMaintenanceDiscardedGetOptions = (options: Options<GetDiscardedCardsV2HousesHouseIdMaintenanceDiscardedGetData>) => queryOptions<GetDiscardedCardsV2HousesHouseIdMaintenanceDiscardedGetResponse, AxiosError<GetDiscardedCardsV2HousesHouseIdMaintenanceDiscardedGetError>, GetDiscardedCardsV2HousesHouseIdMaintenanceDiscardedGetResponse, ReturnType<typeof getDiscardedCardsV2HousesHouseIdMaintenanceDiscardedGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await MaintenanceV2.getDiscardedCardsV2HousesHouseIdMaintenanceDiscardedGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getDiscardedCardsV2HousesHouseIdMaintenanceDiscardedGetQueryKey(options)
});

export const getDiscardedCardsV2HousesHouseIdMaintenanceDiscardedGetInfiniteQueryKey = (options: Options<GetDiscardedCardsV2HousesHouseIdMaintenanceDiscardedGetData>): QueryKey<Options<GetDiscardedCardsV2HousesHouseIdMaintenanceDiscardedGetData>> => createQueryKey('getDiscardedCardsV2HousesHouseIdMaintenanceDiscardedGet', options, true);

/**
 * Get Discarded Cards
 *
 * The cards the homeowner has discarded — History's restore list.
 *
 * Read-only, and deliberately separate from the plan read: the active plan, its cache and its
 * counts are untouched, so opening this can never move a plan number. Every card comes back as a
 * normal PlanNode carrying `review.status = "removed"` and `restore` in `allowed_actions` (pruned to
 * what THIS reader may do), so it renders with the same components as any other card and is put back
 * through the same action endpoint — echo the card's `resolve_token` with `action="restore"`.
 */
export const getDiscardedCardsV2HousesHouseIdMaintenanceDiscardedGetInfiniteOptions = (options: Options<GetDiscardedCardsV2HousesHouseIdMaintenanceDiscardedGetData>) => infiniteQueryOptions<GetDiscardedCardsV2HousesHouseIdMaintenanceDiscardedGetResponse, AxiosError<GetDiscardedCardsV2HousesHouseIdMaintenanceDiscardedGetError>, InfiniteData<GetDiscardedCardsV2HousesHouseIdMaintenanceDiscardedGetResponse>, QueryKey<Options<GetDiscardedCardsV2HousesHouseIdMaintenanceDiscardedGetData>>, number | Pick<QueryKey<Options<GetDiscardedCardsV2HousesHouseIdMaintenanceDiscardedGetData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<GetDiscardedCardsV2HousesHouseIdMaintenanceDiscardedGetData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                offset: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await MaintenanceV2.getDiscardedCardsV2HousesHouseIdMaintenanceDiscardedGet({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getDiscardedCardsV2HousesHouseIdMaintenanceDiscardedGetInfiniteQueryKey(options)
});

/**
 * Create Custom Entry
 *
 * Add a task of the homeowner's own to this property's plan.
 *
 * Returns the stored entry, NOT a plan card. The entry's FIRST occurrence is materialised in this
 * same transaction, so the card is actionable on the very next plan read (re-read the plan to get
 * it); the async reconcile then fills in the rest of a recurring series' horizon. Re-read rather
 * than constructing the card from this response.
 *
 * Create is the only endpoint these entries need. The resulting card carries a ``resolve_token``
 * like any other, so completing, snoozing or annotating it goes through the ordinary
 * occurrence-resolve path.
 */
export const createCustomEntryV2HousesHouseIdMaintenanceCustomEntriesPostMutation = (options?: Partial<Options<CreateCustomEntryV2HousesHouseIdMaintenanceCustomEntriesPostData>>): UseMutationOptions<CreateCustomEntryV2HousesHouseIdMaintenanceCustomEntriesPostResponse, AxiosError<CreateCustomEntryV2HousesHouseIdMaintenanceCustomEntriesPostError>, Options<CreateCustomEntryV2HousesHouseIdMaintenanceCustomEntriesPostData>> => {
    const mutationOptions: UseMutationOptions<CreateCustomEntryV2HousesHouseIdMaintenanceCustomEntriesPostResponse, AxiosError<CreateCustomEntryV2HousesHouseIdMaintenanceCustomEntriesPostError>, Options<CreateCustomEntryV2HousesHouseIdMaintenanceCustomEntriesPostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await MaintenanceV2.createCustomEntryV2HousesHouseIdMaintenanceCustomEntriesPost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Google Login
 */
export const googleLoginGoogleTokenPostMutation = (options?: Partial<Options<GoogleLoginGoogleTokenPostData>>): UseMutationOptions<GoogleLoginGoogleTokenPostResponse, AxiosError<GoogleLoginGoogleTokenPostError>, Options<GoogleLoginGoogleTokenPostData>> => {
    const mutationOptions: UseMutationOptions<GoogleLoginGoogleTokenPostResponse, AxiosError<GoogleLoginGoogleTokenPostError>, Options<GoogleLoginGoogleTokenPostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await Authentication.googleLoginGoogleTokenPost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Login For Access Token
 *
 * Login for access token using DRY factory functions
 */
export const loginForAccessTokenTokenPostMutation = (options?: Partial<Options<LoginForAccessTokenTokenPostData>>): UseMutationOptions<LoginForAccessTokenTokenPostResponse, AxiosError<LoginForAccessTokenTokenPostError>, Options<LoginForAccessTokenTokenPostData>> => {
    const mutationOptions: UseMutationOptions<LoginForAccessTokenTokenPostResponse, AxiosError<LoginForAccessTokenTokenPostError>, Options<LoginForAccessTokenTokenPostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await Authentication.loginForAccessTokenTokenPost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Refresh Access Token
 *
 * Refresh access token using DRY factory functions
 */
export const refreshAccessTokenTokenRefreshPostMutation = (options?: Partial<Options<RefreshAccessTokenTokenRefreshPostData>>): UseMutationOptions<RefreshAccessTokenTokenRefreshPostResponse, AxiosError<RefreshAccessTokenTokenRefreshPostError>, Options<RefreshAccessTokenTokenRefreshPostData>> => {
    const mutationOptions: UseMutationOptions<RefreshAccessTokenTokenRefreshPostResponse, AxiosError<RefreshAccessTokenTokenRefreshPostError>, Options<RefreshAccessTokenTokenRefreshPostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await Authentication.refreshAccessTokenTokenRefreshPost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Request Guest Access
 */
export const requestGuestAccessHousesHouseIdAccessRequestPostMutation = (options?: Partial<Options<RequestGuestAccessHousesHouseIdAccessRequestPostData>>): UseMutationOptions<RequestGuestAccessHousesHouseIdAccessRequestPostResponse, AxiosError<RequestGuestAccessHousesHouseIdAccessRequestPostError>, Options<RequestGuestAccessHousesHouseIdAccessRequestPostData>> => {
    const mutationOptions: UseMutationOptions<RequestGuestAccessHousesHouseIdAccessRequestPostResponse, AxiosError<RequestGuestAccessHousesHouseIdAccessRequestPostError>, Options<RequestGuestAccessHousesHouseIdAccessRequestPostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await Authentication.requestGuestAccessHousesHouseIdAccessRequestPost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getGuestAccessStatusAccessStatusRequestIdGetQueryKey = (options: Options<GetGuestAccessStatusAccessStatusRequestIdGetData>) => createQueryKey('getGuestAccessStatusAccessStatusRequestIdGet', options);

/**
 * Get Guest Access Status
 */
export const getGuestAccessStatusAccessStatusRequestIdGetOptions = (options: Options<GetGuestAccessStatusAccessStatusRequestIdGetData>) => queryOptions<GetGuestAccessStatusAccessStatusRequestIdGetResponse, AxiosError<GetGuestAccessStatusAccessStatusRequestIdGetError>, GetGuestAccessStatusAccessStatusRequestIdGetResponse, ReturnType<typeof getGuestAccessStatusAccessStatusRequestIdGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await Authentication.getGuestAccessStatusAccessStatusRequestIdGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getGuestAccessStatusAccessStatusRequestIdGetQueryKey(options)
});

export const checkResourceStateResourcesResourceIdStateGetQueryKey = (options: Options<CheckResourceStateResourcesResourceIdStateGetData>) => createQueryKey('checkResourceStateResourcesResourceIdStateGet', options);

/**
 * Check Resource State
 *
 * Check the current state of a resource.
 *
 * Returns:
 * - A dictionary indicating the resource state.
 */
export const checkResourceStateResourcesResourceIdStateGetOptions = (options: Options<CheckResourceStateResourcesResourceIdStateGetData>) => queryOptions<CheckResourceStateResourcesResourceIdStateGetResponse, AxiosError<CheckResourceStateResourcesResourceIdStateGetError>, CheckResourceStateResourcesResourceIdStateGetResponse, ReturnType<typeof checkResourceStateResourcesResourceIdStateGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await Tasks.checkResourceStateResourcesResourceIdStateGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: checkResourceStateResourcesResourceIdStateGetQueryKey(options)
});

export const getTaskStatusPaginatedTasksStatusGetQueryKey = (options?: Options<GetTaskStatusPaginatedTasksStatusGetData>) => createQueryKey('getTaskStatusPaginatedTasksStatusGet', options);

/**
 * Get Task Status Paginated
 *
 * Retrieve a paginated summary of tasks in the system.
 *
 * Query Parameters:
 * - limit: Number of tasks to retrieve.
 * - offset: Number of tasks to skip.
 *
 * Returns:
 * - A dictionary mapping task IDs to their status and progress.
 */
export const getTaskStatusPaginatedTasksStatusGetOptions = (options?: Options<GetTaskStatusPaginatedTasksStatusGetData>) => queryOptions<GetTaskStatusPaginatedTasksStatusGetResponse, AxiosError<GetTaskStatusPaginatedTasksStatusGetError>, GetTaskStatusPaginatedTasksStatusGetResponse, ReturnType<typeof getTaskStatusPaginatedTasksStatusGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await Tasks.getTaskStatusPaginatedTasksStatusGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getTaskStatusPaginatedTasksStatusGetQueryKey(options)
});

export const getTaskStatusPaginatedTasksStatusGetInfiniteQueryKey = (options?: Options<GetTaskStatusPaginatedTasksStatusGetData>): QueryKey<Options<GetTaskStatusPaginatedTasksStatusGetData>> => createQueryKey('getTaskStatusPaginatedTasksStatusGet', options, true);

/**
 * Get Task Status Paginated
 *
 * Retrieve a paginated summary of tasks in the system.
 *
 * Query Parameters:
 * - limit: Number of tasks to retrieve.
 * - offset: Number of tasks to skip.
 *
 * Returns:
 * - A dictionary mapping task IDs to their status and progress.
 */
export const getTaskStatusPaginatedTasksStatusGetInfiniteOptions = (options?: Options<GetTaskStatusPaginatedTasksStatusGetData>) => infiniteQueryOptions<GetTaskStatusPaginatedTasksStatusGetResponse, AxiosError<GetTaskStatusPaginatedTasksStatusGetError>, InfiniteData<GetTaskStatusPaginatedTasksStatusGetResponse>, QueryKey<Options<GetTaskStatusPaginatedTasksStatusGetData>>, number | Pick<QueryKey<Options<GetTaskStatusPaginatedTasksStatusGetData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<GetTaskStatusPaginatedTasksStatusGetData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                offset: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await Tasks.getTaskStatusPaginatedTasksStatusGet({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getTaskStatusPaginatedTasksStatusGetInfiniteQueryKey(options)
});

export const getResourceTasksResourcesResourceIdTasksGetQueryKey = (options: Options<GetResourceTasksResourcesResourceIdTasksGetData>) => createQueryKey('getResourceTasksResourcesResourceIdTasksGet', options);

/**
 * Get Resource Tasks
 *
 * Endpoint to retrieve tasks associated with a resource.
 */
export const getResourceTasksResourcesResourceIdTasksGetOptions = (options: Options<GetResourceTasksResourcesResourceIdTasksGetData>) => queryOptions<GetResourceTasksResourcesResourceIdTasksGetResponse, AxiosError<GetResourceTasksResourcesResourceIdTasksGetError>, GetResourceTasksResourcesResourceIdTasksGetResponse, ReturnType<typeof getResourceTasksResourcesResourceIdTasksGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await Tasks.getResourceTasksResourcesResourceIdTasksGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getResourceTasksResourcesResourceIdTasksGetQueryKey(options)
});

export const checkTaskCompletedTasksTaskIdStatusGetQueryKey = (options: Options<CheckTaskCompletedTasksTaskIdStatusGetData>) => createQueryKey('checkTaskCompletedTasksTaskIdStatusGet', options);

/**
 * Check Task Completed
 *
 * Check if a task has been completed.
 *
 * Parameters:
 * - task_id (str): The ID of the task.
 *
 * Returns:
 * - A dictionary indicating the task status and progress.
 */
export const checkTaskCompletedTasksTaskIdStatusGetOptions = (options: Options<CheckTaskCompletedTasksTaskIdStatusGetData>) => queryOptions<CheckTaskCompletedTasksTaskIdStatusGetResponse, AxiosError<CheckTaskCompletedTasksTaskIdStatusGetError>, CheckTaskCompletedTasksTaskIdStatusGetResponse, ReturnType<typeof checkTaskCompletedTasksTaskIdStatusGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await Tasks.checkTaskCompletedTasksTaskIdStatusGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: checkTaskCompletedTasksTaskIdStatusGetQueryKey(options)
});

export const getHouseTasksHousesHouseIdTasksGetQueryKey = (options: Options<GetHouseTasksHousesHouseIdTasksGetData>) => createQueryKey('getHouseTasksHousesHouseIdTasksGet', options);

/**
 * Get House Tasks
 *
 * Retrieve all tasks associated with a specific house.
 *
 * Parameters:
 * - house_id (int): The ID of the house.
 *
 * Returns:
 * - A list of tasks associated with the house, including their status, progress, and metadata.
 */
export const getHouseTasksHousesHouseIdTasksGetOptions = (options: Options<GetHouseTasksHousesHouseIdTasksGetData>) => queryOptions<GetHouseTasksHousesHouseIdTasksGetResponse, AxiosError<GetHouseTasksHousesHouseIdTasksGetError>, GetHouseTasksHousesHouseIdTasksGetResponse, ReturnType<typeof getHouseTasksHousesHouseIdTasksGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await Tasks.getHouseTasksHousesHouseIdTasksGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getHouseTasksHousesHouseIdTasksGetQueryKey(options)
});

export const searchPlacesMapsAutocompleteGetQueryKey = (options: Options<SearchPlacesMapsAutocompleteGetData>) => createQueryKey('searchPlacesMapsAutocompleteGet', options);

/**
 * Search Places
 *
 * Search for places using Google Places Autocomplete API.
 *
 * This endpoint provides autocomplete suggestions for location searches.
 * Requires authentication to prevent abuse and track usage.
 *
 * Args:
 * query: The search query string (1-100 characters)
 * country: Optional ISO 3166-1 alpha-2 country code to restrict results
 * types: Optional place types filter (address, establishment, etc.)
 * current_user: Authenticated user (injected by dependency)
 *
 * Returns:
 * AutocompleteResponse with list of place predictions
 *
 * Raises:
 * HTTPException: 400 for invalid requests, 503 for API service errors
 *
 * Example:
 * GET /maps/autocomplete?query=123%20Main%20St&country=us&types=address
 */
export const searchPlacesMapsAutocompleteGetOptions = (options: Options<SearchPlacesMapsAutocompleteGetData>) => queryOptions<SearchPlacesMapsAutocompleteGetResponse, AxiosError<SearchPlacesMapsAutocompleteGetError>, SearchPlacesMapsAutocompleteGetResponse, ReturnType<typeof searchPlacesMapsAutocompleteGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await GoogleMaps.searchPlacesMapsAutocompleteGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: searchPlacesMapsAutocompleteGetQueryKey(options)
});

export const getPlaceInfoMapsPlacePlaceIdGetQueryKey = (options: Options<GetPlaceInfoMapsPlacePlaceIdGetData>) => createQueryKey('getPlaceInfoMapsPlacePlaceIdGet', options);

/**
 * Get Place Info
 *
 * Get detailed information about a specific place.
 *
 * This endpoint retrieves comprehensive details about a place using its Google Places ID.
 * Requires authentication to prevent abuse and track usage.
 *
 * Args:
 * place_id: Google Places ID obtained from autocomplete results
 * fields: Comma-separated list of fields to return from the API
 * current_user: Authenticated user (injected by dependency)
 *
 * Returns:
 * PlaceDetailsResponse with detailed place information
 *
 * Raises:
 * HTTPException: 400 for invalid place_id, 503 for API service errors
 *
 * Example:
 * GET /maps/place/ChIJN1t_tDeuEmsRUsoyG83frY4?fields=name,formatted_address,geometry
 */
export const getPlaceInfoMapsPlacePlaceIdGetOptions = (options: Options<GetPlaceInfoMapsPlacePlaceIdGetData>) => queryOptions<GetPlaceInfoMapsPlacePlaceIdGetResponse, AxiosError<GetPlaceInfoMapsPlacePlaceIdGetError>, GetPlaceInfoMapsPlacePlaceIdGetResponse, ReturnType<typeof getPlaceInfoMapsPlacePlaceIdGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await GoogleMaps.getPlaceInfoMapsPlacePlaceIdGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getPlaceInfoMapsPlacePlaceIdGetQueryKey(options)
});

export const qrLandingPageQrPropertyPublicIdGetQueryKey = (options: Options<QrLandingPageQrPropertyPublicIdGetData>) => createQueryKey('qrLandingPageQrPropertyPublicIdGet', options);

/**
 * Qr Landing Page
 *
 * QR code landing page endpoint.
 *
 * Accepts the property public ID (string) that is embedded in the QR code URL.
 * Generates a request ticket, sets it as an HttpOnly cookie, and returns
 * house information for the frontend to display the access request form.
 *
 * Rate limit: 5 per minute, 20 per hour per IP
 */
export const qrLandingPageQrPropertyPublicIdGetOptions = (options: Options<QrLandingPageQrPropertyPublicIdGetData>) => queryOptions<QrLandingPageQrPropertyPublicIdGetResponse, AxiosError<QrLandingPageQrPropertyPublicIdGetError>, QrLandingPageQrPropertyPublicIdGetResponse, ReturnType<typeof qrLandingPageQrPropertyPublicIdGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await GuestAccess.qrLandingPageQrPropertyPublicIdGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: qrLandingPageQrPropertyPublicIdGetQueryKey(options)
});

/**
 * Submit Access Request
 *
 * Submit a guest access request.
 *
 * Validates the request ticket from cookie, creates a pending grant,
 * and sends notification emails to both owner and requester.
 *
 * Rate limit: 3 per hour per IP per house
 */
export const submitAccessRequestHousesHouseIdGuestAccessRequestsPostMutation = (options?: Partial<Options<SubmitAccessRequestHousesHouseIdGuestAccessRequestsPostData>>): UseMutationOptions<SubmitAccessRequestHousesHouseIdGuestAccessRequestsPostResponse, AxiosError<SubmitAccessRequestHousesHouseIdGuestAccessRequestsPostError>, Options<SubmitAccessRequestHousesHouseIdGuestAccessRequestsPostData>> => {
    const mutationOptions: UseMutationOptions<SubmitAccessRequestHousesHouseIdGuestAccessRequestsPostResponse, AxiosError<SubmitAccessRequestHousesHouseIdGuestAccessRequestsPostError>, Options<SubmitAccessRequestHousesHouseIdGuestAccessRequestsPostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await GuestAccess.submitAccessRequestHousesHouseIdGuestAccessRequestsPost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Approve Access Grant
 *
 * Approve a guest access grant (authenticated owner).
 *
 * Validates owner permissions, approves the grant, generates a magic token,
 * and sends notification emails to both owner and requester.
 *
 * Rate limit: 10 per minute per user
 */
export const approveAccessGrantGuestAccessGrantIdApprovePostMutation = (options?: Partial<Options<ApproveAccessGrantGuestAccessGrantIdApprovePostData>>): UseMutationOptions<ApproveAccessGrantGuestAccessGrantIdApprovePostResponse, AxiosError<ApproveAccessGrantGuestAccessGrantIdApprovePostError>, Options<ApproveAccessGrantGuestAccessGrantIdApprovePostData>> => {
    const mutationOptions: UseMutationOptions<ApproveAccessGrantGuestAccessGrantIdApprovePostResponse, AxiosError<ApproveAccessGrantGuestAccessGrantIdApprovePostError>, Options<ApproveAccessGrantGuestAccessGrantIdApprovePostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await GuestAccess.approveAccessGrantGuestAccessGrantIdApprovePost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Deny Access Grant
 *
 * Deny a guest access grant (authenticated owner).
 *
 * Validates owner permissions, denies the grant, and sends notification
 * email to the requester.
 *
 * Rate limit: 10 per minute per user
 */
export const denyAccessGrantGuestAccessGrantIdDenyPostMutation = (options?: Partial<Options<DenyAccessGrantGuestAccessGrantIdDenyPostData>>): UseMutationOptions<DenyAccessGrantGuestAccessGrantIdDenyPostResponse, AxiosError<DenyAccessGrantGuestAccessGrantIdDenyPostError>, Options<DenyAccessGrantGuestAccessGrantIdDenyPostData>> => {
    const mutationOptions: UseMutationOptions<DenyAccessGrantGuestAccessGrantIdDenyPostResponse, AxiosError<DenyAccessGrantGuestAccessGrantIdDenyPostError>, Options<DenyAccessGrantGuestAccessGrantIdDenyPostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await GuestAccess.denyAccessGrantGuestAccessGrantIdDenyPost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Create Guest Invitation
 *
 * Create and approve a guest access invitation.
 *
 * Creates a grant directly in approved status, generates magic token,
 * and sends invitation email.
 * Combines request and approval in one step.
 *
 * TODO: The logic is very to the approval endpoint.
 * The code is duplicated as in the approval, but is kept this way for now as it might change in the future.
 */
export const createGuestInvitationHousesHouseIdGuestAccessInvitePostMutation = (options?: Partial<Options<CreateGuestInvitationHousesHouseIdGuestAccessInvitePostData>>): UseMutationOptions<CreateGuestInvitationHousesHouseIdGuestAccessInvitePostResponse, AxiosError<CreateGuestInvitationHousesHouseIdGuestAccessInvitePostError>, Options<CreateGuestInvitationHousesHouseIdGuestAccessInvitePostData>> => {
    const mutationOptions: UseMutationOptions<CreateGuestInvitationHousesHouseIdGuestAccessInvitePostResponse, AxiosError<CreateGuestInvitationHousesHouseIdGuestAccessInvitePostError>, Options<CreateGuestInvitationHousesHouseIdGuestAccessInvitePostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await GuestAccess.createGuestInvitationHousesHouseIdGuestAccessInvitePost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Verify Guest Code
 *
 * Verify the 6-digit code for guest access.
 */
export const verifyGuestCodeGuestAccessMagicVerifyPostMutation = (options?: Partial<Options<VerifyGuestCodeGuestAccessMagicVerifyPostData>>): UseMutationOptions<VerifyGuestCodeGuestAccessMagicVerifyPostResponse, AxiosError<VerifyGuestCodeGuestAccessMagicVerifyPostError>, Options<VerifyGuestCodeGuestAccessMagicVerifyPostData>> => {
    const mutationOptions: UseMutationOptions<VerifyGuestCodeGuestAccessMagicVerifyPostResponse, AxiosError<VerifyGuestCodeGuestAccessMagicVerifyPostError>, Options<VerifyGuestCodeGuestAccessMagicVerifyPostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await GuestAccess.verifyGuestCodeGuestAccessMagicVerifyPost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Request Guest Code
 *
 * Request/Resend the 6-digit verification code to the guest's email.
 */
export const requestGuestCodeGuestAccessMagicCodePostMutation = (options?: Partial<Options<RequestGuestCodeGuestAccessMagicCodePostData>>): UseMutationOptions<RequestGuestCodeGuestAccessMagicCodePostResponse, AxiosError<RequestGuestCodeGuestAccessMagicCodePostError>, Options<RequestGuestCodeGuestAccessMagicCodePostData>> => {
    const mutationOptions: UseMutationOptions<RequestGuestCodeGuestAccessMagicCodePostResponse, AxiosError<RequestGuestCodeGuestAccessMagicCodePostError>, Options<RequestGuestCodeGuestAccessMagicCodePostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await GuestAccess.requestGuestCodeGuestAccessMagicCodePost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Redeem Magic Token
 *
 * Redeem a magic token for guest access.
 *
 * Validates the magic token, checks grant status, creates guest JWT,
 * and logs the login event.
 *
 * Rate limit: 20 per minute per token
 */
export const redeemMagicTokenGuestAccessMagicRedeemPostMutation = (options?: Partial<Options<RedeemMagicTokenGuestAccessMagicRedeemPostData>>): UseMutationOptions<RedeemMagicTokenGuestAccessMagicRedeemPostResponse, AxiosError<RedeemMagicTokenGuestAccessMagicRedeemPostError>, Options<RedeemMagicTokenGuestAccessMagicRedeemPostData>> => {
    const mutationOptions: UseMutationOptions<RedeemMagicTokenGuestAccessMagicRedeemPostResponse, AxiosError<RedeemMagicTokenGuestAccessMagicRedeemPostError>, Options<RedeemMagicTokenGuestAccessMagicRedeemPostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await GuestAccess.redeemMagicTokenGuestAccessMagicRedeemPost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Manage Guest Access
 *
 * Extend, reduce, or revoke guest access for an active grant.
 *
 * This endpoint allows property owners to modify active guest access:
 * - extend: Set expires_at to a future date beyond current expiration
 * - reduce: Set expires_at to an earlier date
 * - revoke: Set expires_at to current time (immediate revocation)
 *
 * The endpoint handles both grant and house association synchronization.
 */
export const manageGuestAccessHousesHouseIdGuestAccessGrantIdAccessPutMutation = (options?: Partial<Options<ManageGuestAccessHousesHouseIdGuestAccessGrantIdAccessPutData>>): UseMutationOptions<ManageGuestAccessHousesHouseIdGuestAccessGrantIdAccessPutResponse, AxiosError<ManageGuestAccessHousesHouseIdGuestAccessGrantIdAccessPutError>, Options<ManageGuestAccessHousesHouseIdGuestAccessGrantIdAccessPutData>> => {
    const mutationOptions: UseMutationOptions<ManageGuestAccessHousesHouseIdGuestAccessGrantIdAccessPutResponse, AxiosError<ManageGuestAccessHousesHouseIdGuestAccessGrantIdAccessPutError>, Options<ManageGuestAccessHousesHouseIdGuestAccessGrantIdAccessPutData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await GuestAccess.manageGuestAccessHousesHouseIdGuestAccessGrantIdAccessPut({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getHouseGrantsHousesHouseIdGuestAccessGrantsGetQueryKey = (options: Options<GetHouseGrantsHousesHouseIdGuestAccessGrantsGetData>) => createQueryKey('getHouseGrantsHousesHouseIdGuestAccessGrantsGet', options);

/**
 * Get House Grants
 *
 * Get all guest access grants for a property.
 *
 * Returns a list of all grants for the specified house. Only property owners
 * or users with guest access management permissions can access this endpoint.
 *
 * Query Parameters:
 * - active_only: Only return active (approved and not expired) grants
 * - status: Filter by grant status (pending, approved, denied, revoked, expired)
 */
export const getHouseGrantsHousesHouseIdGuestAccessGrantsGetOptions = (options: Options<GetHouseGrantsHousesHouseIdGuestAccessGrantsGetData>) => queryOptions<GetHouseGrantsHousesHouseIdGuestAccessGrantsGetResponse, AxiosError<GetHouseGrantsHousesHouseIdGuestAccessGrantsGetError>, GetHouseGrantsHousesHouseIdGuestAccessGrantsGetResponse, ReturnType<typeof getHouseGrantsHousesHouseIdGuestAccessGrantsGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await GuestAccess.getHouseGrantsHousesHouseIdGuestAccessGrantsGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getHouseGrantsHousesHouseIdGuestAccessGrantsGetQueryKey(options)
});

/**
 * Approve Via Magic Token
 *
 * Approve a guest access grant using magic token from email.
 *
 * This endpoint allows property owners to approve grants directly from
 * email links without requiring full authentication. The magic token
 * provides temporary, scoped authorization for this specific action.
 */
export const approveViaMagicTokenGuestAccessManageApproveViaTokenPostMutation = (options?: Partial<Options<ApproveViaMagicTokenGuestAccessManageApproveViaTokenPostData>>): UseMutationOptions<ApproveViaMagicTokenGuestAccessManageApproveViaTokenPostResponse, AxiosError<ApproveViaMagicTokenGuestAccessManageApproveViaTokenPostError>, Options<ApproveViaMagicTokenGuestAccessManageApproveViaTokenPostData>> => {
    const mutationOptions: UseMutationOptions<ApproveViaMagicTokenGuestAccessManageApproveViaTokenPostResponse, AxiosError<ApproveViaMagicTokenGuestAccessManageApproveViaTokenPostError>, Options<ApproveViaMagicTokenGuestAccessManageApproveViaTokenPostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await GuestAccess.approveViaMagicTokenGuestAccessManageApproveViaTokenPost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Deny Via Magic Token
 *
 * Deny a guest access grant using magic token from email.
 */
export const denyViaMagicTokenGuestAccessManageDenyViaTokenPostMutation = (options?: Partial<Options<DenyViaMagicTokenGuestAccessManageDenyViaTokenPostData>>): UseMutationOptions<DenyViaMagicTokenGuestAccessManageDenyViaTokenPostResponse, AxiosError<DenyViaMagicTokenGuestAccessManageDenyViaTokenPostError>, Options<DenyViaMagicTokenGuestAccessManageDenyViaTokenPostData>> => {
    const mutationOptions: UseMutationOptions<DenyViaMagicTokenGuestAccessManageDenyViaTokenPostResponse, AxiosError<DenyViaMagicTokenGuestAccessManageDenyViaTokenPostError>, Options<DenyViaMagicTokenGuestAccessManageDenyViaTokenPostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await GuestAccess.denyViaMagicTokenGuestAccessManageDenyViaTokenPost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getMagicTokenInfoGuestAccessMagicInfoGetQueryKey = (options: Options<GetMagicTokenInfoGuestAccessMagicInfoGetData>) => createQueryKey('getMagicTokenInfoGuestAccessMagicInfoGet', options);

/**
 * Get Magic Token Info
 *
 * Return status info for a magic token.
 *
 * Unauthenticated callers receive status + property_address only.
 * Authenticated callers also receive email_matches and has_property_access booleans.
 * The raw invite email is never returned to prevent enumeration.
 */
export const getMagicTokenInfoGuestAccessMagicInfoGetOptions = (options: Options<GetMagicTokenInfoGuestAccessMagicInfoGetData>) => queryOptions<GetMagicTokenInfoGuestAccessMagicInfoGetResponse, AxiosError<GetMagicTokenInfoGuestAccessMagicInfoGetError>, GetMagicTokenInfoGuestAccessMagicInfoGetResponse, ReturnType<typeof getMagicTokenInfoGuestAccessMagicInfoGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await GuestAccess.getMagicTokenInfoGuestAccessMagicInfoGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getMagicTokenInfoGuestAccessMagicInfoGetQueryKey(options)
});

/**
 * Authenticated Qr Access Request
 *
 * Submit a QR code access request for an authenticated user.
 *
 * No email or identity verification needed — the system already knows who they are.
 * Creates a pending grant and notifies all house owners/admins.
 * Returns 409 if a pending or approved grant already exists for this user.
 */
export const authenticatedQrAccessRequestHousesHouseIdQrAccessRequestPostMutation = (options?: Partial<Options<AuthenticatedQrAccessRequestHousesHouseIdQrAccessRequestPostData>>): UseMutationOptions<AuthenticatedQrAccessRequestHousesHouseIdQrAccessRequestPostResponse, AxiosError<AuthenticatedQrAccessRequestHousesHouseIdQrAccessRequestPostError>, Options<AuthenticatedQrAccessRequestHousesHouseIdQrAccessRequestPostData>> => {
    const mutationOptions: UseMutationOptions<AuthenticatedQrAccessRequestHousesHouseIdQrAccessRequestPostResponse, AxiosError<AuthenticatedQrAccessRequestHousesHouseIdQrAccessRequestPostError>, Options<AuthenticatedQrAccessRequestHousesHouseIdQrAccessRequestPostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await GuestAccess.authenticatedQrAccessRequestHousesHouseIdQrAccessRequestPost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getGrantInfoGuestAccessManageInfoGetQueryKey = (options: Options<GetGrantInfoGuestAccessManageInfoGetData>) => createQueryKey('getGrantInfoGuestAccessManageInfoGet', options);

/**
 * Get Grant Info
 *
 * Return grant info for the owner approval page.
 *
 * Called when the owner loads the magic-link approval page from their notification email.
 * Returns pending details or resolved state (for when a second admin arrives after the
 * first has already handled the request).
 */
export const getGrantInfoGuestAccessManageInfoGetOptions = (options: Options<GetGrantInfoGuestAccessManageInfoGetData>) => queryOptions<GetGrantInfoGuestAccessManageInfoGetResponse, AxiosError<GetGrantInfoGuestAccessManageInfoGetError>, GetGrantInfoGuestAccessManageInfoGetResponse, ReturnType<typeof getGrantInfoGuestAccessManageInfoGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await GuestAccess.getGrantInfoGuestAccessManageInfoGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getGrantInfoGuestAccessManageInfoGetQueryKey(options)
});

export const getCurrentLegalVersionLegalCurrentVersionGetQueryKey = (options?: Options<GetCurrentLegalVersionLegalCurrentVersionGetData>) => createQueryKey('getCurrentLegalVersionLegalCurrentVersionGet', options);

/**
 * Get Current Legal Version
 *
 * Get current active legal version
 */
export const getCurrentLegalVersionLegalCurrentVersionGetOptions = (options?: Options<GetCurrentLegalVersionLegalCurrentVersionGetData>) => queryOptions<GetCurrentLegalVersionLegalCurrentVersionGetResponse, AxiosError<DefaultError>, GetCurrentLegalVersionLegalCurrentVersionGetResponse, ReturnType<typeof getCurrentLegalVersionLegalCurrentVersionGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await Legal.getCurrentLegalVersionLegalCurrentVersionGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getCurrentLegalVersionLegalCurrentVersionGetQueryKey(options)
});

export const listServiceCategoriesServiceCategoriesGetQueryKey = (options?: Options<ListServiceCategoriesServiceCategoriesGetData>) => createQueryKey('listServiceCategoriesServiceCategoriesGet', options);

/**
 * List Service Categories
 *
 * List all service categories (core, suggested, and custom).
 *
 * Returns categories sorted alphabetically.
 */
export const listServiceCategoriesServiceCategoriesGetOptions = (options?: Options<ListServiceCategoriesServiceCategoriesGetData>) => queryOptions<ListServiceCategoriesServiceCategoriesGetResponse, AxiosError<DefaultError>, ListServiceCategoriesServiceCategoriesGetResponse, ReturnType<typeof listServiceCategoriesServiceCategoriesGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await ProfessionalContacts.listServiceCategoriesServiceCategoriesGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listServiceCategoriesServiceCategoriesGetQueryKey(options)
});

/**
 * Create Custom Category
 *
 * Create a custom service category.
 *
 * Only property owners can create custom categories.
 * Category code must be unique.
 */
export const createCustomCategoryServiceCategoriesPostMutation = (options?: Partial<Options<CreateCustomCategoryServiceCategoriesPostData>>): UseMutationOptions<CreateCustomCategoryServiceCategoriesPostResponse, AxiosError<CreateCustomCategoryServiceCategoriesPostError>, Options<CreateCustomCategoryServiceCategoriesPostData>> => {
    const mutationOptions: UseMutationOptions<CreateCustomCategoryServiceCategoriesPostResponse, AxiosError<CreateCustomCategoryServiceCategoriesPostError>, Options<CreateCustomCategoryServiceCategoriesPostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await ProfessionalContacts.createCustomCategoryServiceCategoriesPost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listPropertyContactsHousesHouseIdContactsGetQueryKey = (options: Options<ListPropertyContactsHousesHouseIdContactsGetData>) => createQueryKey('listPropertyContactsHousesHouseIdContactsGet', options);

/**
 * List Property Contacts
 *
 * List all contacts for a property, grouped by category.
 *
 * Returns summary with:
 * - Total contacts count
 * - Core categories filled count
 * - Trusted contacts count
 * - Contacts grouped by category
 */
export const listPropertyContactsHousesHouseIdContactsGetOptions = (options: Options<ListPropertyContactsHousesHouseIdContactsGetData>) => queryOptions<ListPropertyContactsHousesHouseIdContactsGetResponse, AxiosError<ListPropertyContactsHousesHouseIdContactsGetError>, ListPropertyContactsHousesHouseIdContactsGetResponse, ReturnType<typeof listPropertyContactsHousesHouseIdContactsGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await ProfessionalContacts.listPropertyContactsHousesHouseIdContactsGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listPropertyContactsHousesHouseIdContactsGetQueryKey(options)
});

/**
 * Add Contact To Property
 *
 * Add a new contact to a property.
 *
 * This endpoint:
 * - Creates or finds the professional contact
 * - Creates an organization if needed
 * - Creates the property contact association
 * - Handles deduplication by email/phone
 */
export const addContactToPropertyHousesHouseIdContactsPostMutation = (options?: Partial<Options<AddContactToPropertyHousesHouseIdContactsPostData>>): UseMutationOptions<AddContactToPropertyHousesHouseIdContactsPostResponse, AxiosError<AddContactToPropertyHousesHouseIdContactsPostError>, Options<AddContactToPropertyHousesHouseIdContactsPostData>> => {
    const mutationOptions: UseMutationOptions<AddContactToPropertyHousesHouseIdContactsPostResponse, AxiosError<AddContactToPropertyHousesHouseIdContactsPostError>, Options<AddContactToPropertyHousesHouseIdContactsPostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await ProfessionalContacts.addContactToPropertyHousesHouseIdContactsPost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Remove Contact From Property
 *
 * Archive a contact at this property — a soft delete the owner can undo.
 *
 * The row stays with status "removed", keeping the owner's `override_*` corrections. It is
 * listed by `GET /houses/{house_id}/contacts/archived` and put back by
 * `POST /houses/{house_id}/contacts/{property_contact_id}/restore`.
 *
 * 409 when the contact is connected to the property. This used to revoke that access on the
 * way through, which took a real person's access as a side effect of tidying a list —
 * disconnect them first with `DELETE .../{property_contact_id}/trust`.
 */
export const removeContactFromPropertyHousesHouseIdContactsPropertyContactIdDeleteMutation = (options?: Partial<Options<RemoveContactFromPropertyHousesHouseIdContactsPropertyContactIdDeleteData>>): UseMutationOptions<unknown, AxiosError<RemoveContactFromPropertyHousesHouseIdContactsPropertyContactIdDeleteError>, Options<RemoveContactFromPropertyHousesHouseIdContactsPropertyContactIdDeleteData>> => {
    const mutationOptions: UseMutationOptions<unknown, AxiosError<RemoveContactFromPropertyHousesHouseIdContactsPropertyContactIdDeleteError>, Options<RemoveContactFromPropertyHousesHouseIdContactsPropertyContactIdDeleteData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await ProfessionalContacts.removeContactFromPropertyHousesHouseIdContactsPropertyContactIdDelete({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Update Property Contact
 *
 * Update property contact details.
 *
 * Can update:
 * - Service category
 * - Property-specific notes
 * - Trust status
 * - Party type (person / company)
 * - The owner's corrections to name, company, phone and email
 *
 * Partial: only the fields sent are written, and an explicit null clears an override.
 */
export const updatePropertyContactHousesHouseIdContactsPropertyContactIdPutMutation = (options?: Partial<Options<UpdatePropertyContactHousesHouseIdContactsPropertyContactIdPutData>>): UseMutationOptions<UpdatePropertyContactHousesHouseIdContactsPropertyContactIdPutResponse, AxiosError<UpdatePropertyContactHousesHouseIdContactsPropertyContactIdPutError>, Options<UpdatePropertyContactHousesHouseIdContactsPropertyContactIdPutData>> => {
    const mutationOptions: UseMutationOptions<UpdatePropertyContactHousesHouseIdContactsPropertyContactIdPutResponse, AxiosError<UpdatePropertyContactHousesHouseIdContactsPropertyContactIdPutError>, Options<UpdatePropertyContactHousesHouseIdContactsPropertyContactIdPutData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await ProfessionalContacts.updatePropertyContactHousesHouseIdContactsPropertyContactIdPut({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listArchivedPropertyContactsHousesHouseIdContactsArchivedGetQueryKey = (options: Options<ListArchivedPropertyContactsHousesHouseIdContactsArchivedGetData>) => createQueryKey('listArchivedPropertyContactsHousesHouseIdContactsArchivedGet', options);

/**
 * List Archived Property Contacts
 *
 * The contacts archived at this property, most recently archived first.
 *
 * Archiving is `DELETE /houses/{house_id}/contacts/{property_contact_id}` — a soft delete
 * that keeps the row and the owner's corrections. Put one back with
 * `POST /houses/{house_id}/contacts/{property_contact_id}/restore`.
 *
 * Gated on HOUSE_NETWORK_MANAGE for the same reason the discarded-candidates list is: the
 * only thing to do here is restore, and restore is MANAGE.
 *
 * Entries are the same `PropertyContactWithDetails` the active list returns, so one
 * component renders both. `status` is "removed" and `is_connected` is false, because archiving
 * refuses a connected contact.
 */
export const listArchivedPropertyContactsHousesHouseIdContactsArchivedGetOptions = (options: Options<ListArchivedPropertyContactsHousesHouseIdContactsArchivedGetData>) => queryOptions<ListArchivedPropertyContactsHousesHouseIdContactsArchivedGetResponse, AxiosError<ListArchivedPropertyContactsHousesHouseIdContactsArchivedGetError>, ListArchivedPropertyContactsHousesHouseIdContactsArchivedGetResponse, ReturnType<typeof listArchivedPropertyContactsHousesHouseIdContactsArchivedGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await ProfessionalContacts.listArchivedPropertyContactsHousesHouseIdContactsArchivedGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listArchivedPropertyContactsHousesHouseIdContactsArchivedGetQueryKey(options)
});

/**
 * Restore Contact To Property
 *
 * Bring an archived contact back to the property's list.
 *
 * It comes back **disconnected**: restore never grants house access, because access is a
 * deliberate act. Connect the contact again if that is still wanted. The owner's
 * `override_*` corrections come back with it — archiving never cleared them.
 *
 * 409 when the contact is not archived.
 */
export const restoreContactToPropertyHousesHouseIdContactsPropertyContactIdRestorePostMutation = (options?: Partial<Options<RestoreContactToPropertyHousesHouseIdContactsPropertyContactIdRestorePostData>>): UseMutationOptions<RestoreContactToPropertyHousesHouseIdContactsPropertyContactIdRestorePostResponse, AxiosError<RestoreContactToPropertyHousesHouseIdContactsPropertyContactIdRestorePostError>, Options<RestoreContactToPropertyHousesHouseIdContactsPropertyContactIdRestorePostData>> => {
    const mutationOptions: UseMutationOptions<RestoreContactToPropertyHousesHouseIdContactsPropertyContactIdRestorePostResponse, AxiosError<RestoreContactToPropertyHousesHouseIdContactsPropertyContactIdRestorePostError>, Options<RestoreContactToPropertyHousesHouseIdContactsPropertyContactIdRestorePostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await ProfessionalContacts.restoreContactToPropertyHousesHouseIdContactsPropertyContactIdRestorePost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Accept Extracted Contact
 *
 * Accept an extracted contact and convert it to a confirmed contact.
 *
 * This endpoint:
 * - Creates a ProfessionalContact (or matches existing)
 * - Creates a PropertyContact association
 * - Marks the ExtractedContact as processed
 */
export const acceptExtractedContactHousesHouseIdContactsFromExtractionExtractedContactIdPostMutation = (options?: Partial<Options<AcceptExtractedContactHousesHouseIdContactsFromExtractionExtractedContactIdPostData>>): UseMutationOptions<AcceptExtractedContactHousesHouseIdContactsFromExtractionExtractedContactIdPostResponse, AxiosError<AcceptExtractedContactHousesHouseIdContactsFromExtractionExtractedContactIdPostError>, Options<AcceptExtractedContactHousesHouseIdContactsFromExtractionExtractedContactIdPostData>> => {
    const mutationOptions: UseMutationOptions<AcceptExtractedContactHousesHouseIdContactsFromExtractionExtractedContactIdPostResponse, AxiosError<AcceptExtractedContactHousesHouseIdContactsFromExtractionExtractedContactIdPostError>, Options<AcceptExtractedContactHousesHouseIdContactsFromExtractionExtractedContactIdPostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await ProfessionalContacts.acceptExtractedContactHousesHouseIdContactsFromExtractionExtractedContactIdPost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listContactCandidatesHousesHouseIdContactsCandidatesGetQueryKey = (options: Options<ListContactCandidatesHousesHouseIdContactsCandidatesGetData>) => createQueryKey('listContactCandidatesHousesHouseIdContactsCandidatesGet', options);

/**
 * List Contact Candidates
 *
 * The reconciler's pending candidates for this house, grouped Primary/Secondary, for
 * the review UI. Excluded (scope-filtered) and already-decided candidates are omitted.
 */
export const listContactCandidatesHousesHouseIdContactsCandidatesGetOptions = (options: Options<ListContactCandidatesHousesHouseIdContactsCandidatesGetData>) => queryOptions<ListContactCandidatesHousesHouseIdContactsCandidatesGetResponse, AxiosError<ListContactCandidatesHousesHouseIdContactsCandidatesGetError>, ListContactCandidatesHousesHouseIdContactsCandidatesGetResponse, ReturnType<typeof listContactCandidatesHousesHouseIdContactsCandidatesGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await ProfessionalContacts.listContactCandidatesHousesHouseIdContactsCandidatesGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listContactCandidatesHousesHouseIdContactsCandidatesGetQueryKey(options)
});

export const listContactTaxonomyHousesHouseIdContactsTaxonomyGetQueryKey = (options: Options<ListContactTaxonomyHousesHouseIdContactsTaxonomyGetData>) => createQueryKey('listContactTaxonomyHousesHouseIdContactsTaxonomyGet', options);

/**
 * List Contact Taxonomy
 *
 * The Category/Role taxonomy visible to this house — the 5 seeded groups plus this house's
 * own customs, each with its roles, ordered by hierarchy rank (§10). Feeds the FE's directory
 * filter and the "assign a role" picker.
 */
export const listContactTaxonomyHousesHouseIdContactsTaxonomyGetOptions = (options: Options<ListContactTaxonomyHousesHouseIdContactsTaxonomyGetData>) => queryOptions<ListContactTaxonomyHousesHouseIdContactsTaxonomyGetResponse, AxiosError<ListContactTaxonomyHousesHouseIdContactsTaxonomyGetError>, ListContactTaxonomyHousesHouseIdContactsTaxonomyGetResponse, ReturnType<typeof listContactTaxonomyHousesHouseIdContactsTaxonomyGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await ProfessionalContacts.listContactTaxonomyHousesHouseIdContactsTaxonomyGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listContactTaxonomyHousesHouseIdContactsTaxonomyGetQueryKey(options)
});

/**
 * Create Custom Contact Category
 *
 * Author a house-scoped custom Category (the PM's "Category"). It joins this house's taxonomy
 * only, ranks after the seeded groups, and — being user-authored — the reconciler never touches
 * or auto-assigns it (§10).
 */
export const createCustomContactCategoryHousesHouseIdContactsCategoriesPostMutation = (options?: Partial<Options<CreateCustomContactCategoryHousesHouseIdContactsCategoriesPostData>>): UseMutationOptions<CreateCustomContactCategoryHousesHouseIdContactsCategoriesPostResponse, AxiosError<CreateCustomContactCategoryHousesHouseIdContactsCategoriesPostError>, Options<CreateCustomContactCategoryHousesHouseIdContactsCategoriesPostData>> => {
    const mutationOptions: UseMutationOptions<CreateCustomContactCategoryHousesHouseIdContactsCategoriesPostResponse, AxiosError<CreateCustomContactCategoryHousesHouseIdContactsCategoriesPostError>, Options<CreateCustomContactCategoryHousesHouseIdContactsCategoriesPostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await ProfessionalContacts.createCustomContactCategoryHousesHouseIdContactsCategoriesPost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Create Custom Contact Role
 *
 * Author a house-scoped custom Role under a Category the house can see (seeded or its own
 * custom). User-authored, so it always wins on a contact and the reconciler never emits it.
 */
export const createCustomContactRoleHousesHouseIdContactsRolesPostMutation = (options?: Partial<Options<CreateCustomContactRoleHousesHouseIdContactsRolesPostData>>): UseMutationOptions<CreateCustomContactRoleHousesHouseIdContactsRolesPostResponse, AxiosError<CreateCustomContactRoleHousesHouseIdContactsRolesPostError>, Options<CreateCustomContactRoleHousesHouseIdContactsRolesPostData>> => {
    const mutationOptions: UseMutationOptions<CreateCustomContactRoleHousesHouseIdContactsRolesPostResponse, AxiosError<CreateCustomContactRoleHousesHouseIdContactsRolesPostError>, Options<CreateCustomContactRoleHousesHouseIdContactsRolesPostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await ProfessionalContacts.createCustomContactRoleHousesHouseIdContactsRolesPost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listDiscardedContactCandidatesHousesHouseIdContactsCandidatesDiscardedGetQueryKey = (options: Options<ListDiscardedContactCandidatesHousesHouseIdContactsCandidatesDiscardedGetData>) => createQueryKey('listDiscardedContactCandidatesHousesHouseIdContactsCandidatesDiscardedGet', options);

/**
 * List Discarded Contact Candidates
 *
 * The candidates this owner has rejected, so the discard can be reviewed and undone.
 *
 * Read-only and deliberately separate from the review list: opening this cannot move
 * anything the review queue shows. Every entry is a full `ContactCandidateOut`, the same
 * shape a pending candidate has, so it renders with the same component; put one back with
 * `POST /houses/{house_id}/contacts/candidates/{extracted_contact_id}/undo`, which returns
 * it to pending and to the review list.
 *
 * Only the owner's own rejections. A candidate the reconciler filtered out is not here: it
 * carries `excluded` with a reason, nobody decided it, and there is no endpoint that could
 * put it back — the reconciler owns that column and re-derives it on every run.
 *
 * Gated on HOUSE_NETWORK_MANAGE, not the HOUSE_NETWORK_VIEW its sibling review list uses.
 * The only thing to do with this list is restore from it, and restore is MANAGE — so a
 * contributor, who holds VIEW but not MANAGE, would be shown a page of people they can do
 * nothing about. A saved contact is reference a contributor may need; a contact the owner
 * threw away is not, and it is a named third party the owner made a negative decision about.
 *
 * Unpaginated, like the review list it sits beside. A house's candidates number in the tens.
 */
export const listDiscardedContactCandidatesHousesHouseIdContactsCandidatesDiscardedGetOptions = (options: Options<ListDiscardedContactCandidatesHousesHouseIdContactsCandidatesDiscardedGetData>) => queryOptions<ListDiscardedContactCandidatesHousesHouseIdContactsCandidatesDiscardedGetResponse, AxiosError<ListDiscardedContactCandidatesHousesHouseIdContactsCandidatesDiscardedGetError>, ListDiscardedContactCandidatesHousesHouseIdContactsCandidatesDiscardedGetResponse, ReturnType<typeof listDiscardedContactCandidatesHousesHouseIdContactsCandidatesDiscardedGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await ProfessionalContacts.listDiscardedContactCandidatesHousesHouseIdContactsCandidatesDiscardedGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listDiscardedContactCandidatesHousesHouseIdContactsCandidatesDiscardedGetQueryKey(options)
});

/**
 * Edit Contact Candidate
 *
 * Correct a candidate before promoting it (7b). Only the fields sent are changed; the
 * candidate stays pending, and the edit survives reconciler re-runs and undo.
 */
export const editContactCandidateHousesHouseIdContactsCandidatesExtractedContactIdPatchMutation = (options?: Partial<Options<EditContactCandidateHousesHouseIdContactsCandidatesExtractedContactIdPatchData>>): UseMutationOptions<EditContactCandidateHousesHouseIdContactsCandidatesExtractedContactIdPatchResponse, AxiosError<EditContactCandidateHousesHouseIdContactsCandidatesExtractedContactIdPatchError>, Options<EditContactCandidateHousesHouseIdContactsCandidatesExtractedContactIdPatchData>> => {
    const mutationOptions: UseMutationOptions<EditContactCandidateHousesHouseIdContactsCandidatesExtractedContactIdPatchResponse, AxiosError<EditContactCandidateHousesHouseIdContactsCandidatesExtractedContactIdPatchError>, Options<EditContactCandidateHousesHouseIdContactsCandidatesExtractedContactIdPatchData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await ProfessionalContacts.editContactCandidateHousesHouseIdContactsCandidatesExtractedContactIdPatch({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Undo Contact Decision
 *
 * Undo an accept or reject on a candidate, returning it to pending (it reappears in
 * the review list and on plan cards). Returns the reset candidate.
 */
export const undoContactDecisionHousesHouseIdContactsCandidatesExtractedContactIdUndoPostMutation = (options?: Partial<Options<UndoContactDecisionHousesHouseIdContactsCandidatesExtractedContactIdUndoPostData>>): UseMutationOptions<UndoContactDecisionHousesHouseIdContactsCandidatesExtractedContactIdUndoPostResponse, AxiosError<UndoContactDecisionHousesHouseIdContactsCandidatesExtractedContactIdUndoPostError>, Options<UndoContactDecisionHousesHouseIdContactsCandidatesExtractedContactIdUndoPostData>> => {
    const mutationOptions: UseMutationOptions<UndoContactDecisionHousesHouseIdContactsCandidatesExtractedContactIdUndoPostResponse, AxiosError<UndoContactDecisionHousesHouseIdContactsCandidatesExtractedContactIdUndoPostError>, Options<UndoContactDecisionHousesHouseIdContactsCandidatesExtractedContactIdUndoPostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await ProfessionalContacts.undoContactDecisionHousesHouseIdContactsCandidatesExtractedContactIdUndoPost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Reject Extracted Contact
 *
 * Discard a candidate — it is marked rejected, never deleted.
 *
 * The body optionally says why, and is stored on the decision rather than on the candidate.
 * Both of its fields are optional, so discarding without a reason stays one call.
 *
 * A POST beside `/undo`, replacing `DELETE .../contacts/extracted/{id}`: a reason sent on a
 * DELETE body is dropped by clients that cannot send one — `axios.delete(url, data)` passes
 * it as config, and generators routinely omit a DELETE request body — and the loss is
 * silent, because an absent body and a stripped one are the same request.
 */
export const rejectExtractedContactHousesHouseIdContactsCandidatesExtractedContactIdDiscardPostMutation = (options?: Partial<Options<RejectExtractedContactHousesHouseIdContactsCandidatesExtractedContactIdDiscardPostData>>): UseMutationOptions<unknown, AxiosError<RejectExtractedContactHousesHouseIdContactsCandidatesExtractedContactIdDiscardPostError>, Options<RejectExtractedContactHousesHouseIdContactsCandidatesExtractedContactIdDiscardPostData>> => {
    const mutationOptions: UseMutationOptions<unknown, AxiosError<RejectExtractedContactHousesHouseIdContactsCandidatesExtractedContactIdDiscardPostError>, Options<RejectExtractedContactHousesHouseIdContactsCandidatesExtractedContactIdDiscardPostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await ProfessionalContacts.rejectExtractedContactHousesHouseIdContactsCandidatesExtractedContactIdDiscardPost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getUserActivityHousesHouseIdUsersUserIdActivityGetQueryKey = (options: Options<GetUserActivityHousesHouseIdUsersUserIdActivityGetData>) => createQueryKey('getUserActivityHousesHouseIdUsersUserIdActivityGet', options);

/**
 * Get User Activity
 *
 * What one user did on this property, newest first: documents they uploaded, tasks they
 * created, and the work they recorded on tasks — completions, skips, notes and attachments.
 *
 * Scoped to the current owner's tenure. Gated on HOUSE_ACCESS_MANAGEMENT_MANAGE, as the sharing
 * activity timeline is: it shows what other people did here, including the names of private
 * documents, which only an owner or a house admin may see.
 *
 * A user with no activity here, or no account at all, returns an empty page rather than a 404.
 */
export const getUserActivityHousesHouseIdUsersUserIdActivityGetOptions = (options: Options<GetUserActivityHousesHouseIdUsersUserIdActivityGetData>) => queryOptions<GetUserActivityHousesHouseIdUsersUserIdActivityGetResponse, AxiosError<GetUserActivityHousesHouseIdUsersUserIdActivityGetError>, GetUserActivityHousesHouseIdUsersUserIdActivityGetResponse, ReturnType<typeof getUserActivityHousesHouseIdUsersUserIdActivityGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await UserActivity.getUserActivityHousesHouseIdUsersUserIdActivityGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getUserActivityHousesHouseIdUsersUserIdActivityGetQueryKey(options)
});

export const getUserActivityHousesHouseIdUsersUserIdActivityGetInfiniteQueryKey = (options: Options<GetUserActivityHousesHouseIdUsersUserIdActivityGetData>): QueryKey<Options<GetUserActivityHousesHouseIdUsersUserIdActivityGetData>> => createQueryKey('getUserActivityHousesHouseIdUsersUserIdActivityGet', options, true);

/**
 * Get User Activity
 *
 * What one user did on this property, newest first: documents they uploaded, tasks they
 * created, and the work they recorded on tasks — completions, skips, notes and attachments.
 *
 * Scoped to the current owner's tenure. Gated on HOUSE_ACCESS_MANAGEMENT_MANAGE, as the sharing
 * activity timeline is: it shows what other people did here, including the names of private
 * documents, which only an owner or a house admin may see.
 *
 * A user with no activity here, or no account at all, returns an empty page rather than a 404.
 */
export const getUserActivityHousesHouseIdUsersUserIdActivityGetInfiniteOptions = (options: Options<GetUserActivityHousesHouseIdUsersUserIdActivityGetData>) => infiniteQueryOptions<GetUserActivityHousesHouseIdUsersUserIdActivityGetResponse, AxiosError<GetUserActivityHousesHouseIdUsersUserIdActivityGetError>, InfiniteData<GetUserActivityHousesHouseIdUsersUserIdActivityGetResponse>, QueryKey<Options<GetUserActivityHousesHouseIdUsersUserIdActivityGetData>>, number | Pick<QueryKey<Options<GetUserActivityHousesHouseIdUsersUserIdActivityGetData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<GetUserActivityHousesHouseIdUsersUserIdActivityGetData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                offset: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await UserActivity.getUserActivityHousesHouseIdUsersUserIdActivityGet({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getUserActivityHousesHouseIdUsersUserIdActivityGetInfiniteQueryKey(options)
});

/**
 * Stripe Webhook
 *
 * Main webhook endpoint for receiving Stripe events.
 *
 * Stripe sends webhook events when subscription-related actions occur:
 * - checkout.session.completed: User completed payment (critical - creates pool entries)
 * - customer.subscription.created: Subscription created (validation/logging)
 * - invoice.paid: Subscription renewed successfully (updates PropertySubscription)
 * - customer.subscription.updated: Subscription status changed (tracks failures, pauses)
 * - customer.subscription.deleted: Subscription canceled (marks properties as pending)
 *
 * All events are verified using Stripe's signature to prevent tampering.
 */
export const stripeWebhookStripeWebhookPostMutation = (options?: Partial<Options<StripeWebhookStripeWebhookPostData>>): UseMutationOptions<unknown, AxiosError<DefaultError>, Options<StripeWebhookStripeWebhookPostData>> => {
    const mutationOptions: UseMutationOptions<unknown, AxiosError<DefaultError>, Options<StripeWebhookStripeWebhookPostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await StripeWebhooks.stripeWebhookStripeWebhookPost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Inbound Email
 *
 * Handle Postmark inbound email webhook.
 *
 * This endpoint:
 * 1. Authenticates the webhook request (HTTP Basic Auth)
 * 2. Logs sender-authentication evidence (DKIM/SPF headers) for the email
 * 3. Requires Postmark's SPF verdict to be an aligned pass for the sender
 * 4. Extracts the {alias}@INBOUND_EMAIL_DOMAIN recipient and resolves the house
 * 5. Validates the sender may upload to that house
 * 6. Enqueues a Celery task to process attachments
 *
 * Emails that fail resolution or validation get the uniform
 * REJECTED_RESPONSE with HTTP 200; the reason is only logged.
 *
 * Returns:
 * {"status": "ok", ...} when accepted, REJECTED_RESPONSE otherwise
 */
export const inboundEmailHooksPostmarkInboundPostMutation = (options?: Partial<Options<InboundEmailHooksPostmarkInboundPostData>>): UseMutationOptions<unknown, AxiosError<InboundEmailHooksPostmarkInboundPostError>, Options<InboundEmailHooksPostmarkInboundPostData>> => {
    const mutationOptions: UseMutationOptions<unknown, AxiosError<InboundEmailHooksPostmarkInboundPostError>, Options<InboundEmailHooksPostmarkInboundPostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await DocumentWebhooks.inboundEmailHooksPostmarkInboundPost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listGrantableScopesUsersMeApiKeysScopesGetQueryKey = (options?: Options<ListGrantableScopesUsersMeApiKeysScopesGetData>) => createQueryKey('listGrantableScopesUsersMeApiKeysScopesGet', options);

/**
 * List Grantable Scopes
 *
 * What a key may be allowed to do, with a line of explanation for each.
 *
 * Declared before the route that takes a public id so the literal path wins the match
 * without depending on how a uuid converter treats the word "scopes".
 */
export const listGrantableScopesUsersMeApiKeysScopesGetOptions = (options?: Options<ListGrantableScopesUsersMeApiKeysScopesGetData>) => queryOptions<ListGrantableScopesUsersMeApiKeysScopesGetResponse, AxiosError<ListGrantableScopesUsersMeApiKeysScopesGetError>, ListGrantableScopesUsersMeApiKeysScopesGetResponse, ReturnType<typeof listGrantableScopesUsersMeApiKeysScopesGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await ApiKeys.listGrantableScopesUsersMeApiKeysScopesGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listGrantableScopesUsersMeApiKeysScopesGetQueryKey(options)
});

export const listKeysUsersMeApiKeysGetQueryKey = (options?: Options<ListKeysUsersMeApiKeysGetData>) => createQueryKey('listKeysUsersMeApiKeysGet', options);

/**
 * List Keys
 *
 * Every key the caller has made, newest first.
 *
 * Revoked and expired ones are included with their status and timestamps: the list is
 * the owner's record of what they issued, not only of what still works, and "this key
 * stopped working on Tuesday" is exactly what someone comes here to find out.
 */
export const listKeysUsersMeApiKeysGetOptions = (options?: Options<ListKeysUsersMeApiKeysGetData>) => queryOptions<ListKeysUsersMeApiKeysGetResponse, AxiosError<ListKeysUsersMeApiKeysGetError>, ListKeysUsersMeApiKeysGetResponse, ReturnType<typeof listKeysUsersMeApiKeysGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await ApiKeys.listKeysUsersMeApiKeysGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listKeysUsersMeApiKeysGetQueryKey(options)
});

/**
 * Create Key
 *
 * Create a key and show its secret, once.
 *
 * The order matters. Everything that can refuse the request runs before anything is
 * written, and the response carrying the secret is built after the commit — so there is
 * no path where a person is shown a secret for a key that was rolled back.
 */
export const createKeyUsersMeApiKeysPostMutation = (options?: Partial<Options<CreateKeyUsersMeApiKeysPostData>>): UseMutationOptions<CreateKeyUsersMeApiKeysPostResponse, AxiosError<CreateKeyUsersMeApiKeysPostError>, Options<CreateKeyUsersMeApiKeysPostData>> => {
    const mutationOptions: UseMutationOptions<CreateKeyUsersMeApiKeysPostResponse, AxiosError<CreateKeyUsersMeApiKeysPostError>, Options<CreateKeyUsersMeApiKeysPostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await ApiKeys.createKeyUsersMeApiKeysPost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Revoke Key
 *
 * Stop a key working. Idempotent, and the row is kept.
 *
 * Revoking twice returns the same 204 and keeps the first timestamp, which is the moment
 * the key actually stopped working. A caller retrying after a dropped connection should
 * not be told they are wrong, and should not be able to move the record of when it
 * happened.
 */
export const revokeKeyUsersMeApiKeysPublicIdDeleteMutation = (options?: Partial<Options<RevokeKeyUsersMeApiKeysPublicIdDeleteData>>): UseMutationOptions<RevokeKeyUsersMeApiKeysPublicIdDeleteResponse, AxiosError<RevokeKeyUsersMeApiKeysPublicIdDeleteError>, Options<RevokeKeyUsersMeApiKeysPublicIdDeleteData>> => {
    const mutationOptions: UseMutationOptions<RevokeKeyUsersMeApiKeysPublicIdDeleteResponse, AxiosError<RevokeKeyUsersMeApiKeysPublicIdDeleteError>, Options<RevokeKeyUsersMeApiKeysPublicIdDeleteData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await ApiKeys.revokeKeyUsersMeApiKeysPublicIdDelete({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getKeyUsersMeApiKeysPublicIdGetQueryKey = (options: Options<GetKeyUsersMeApiKeysPublicIdGetData>) => createQueryKey('getKeyUsersMeApiKeysPublicIdGet', options);

/**
 * Get Key
 */
export const getKeyUsersMeApiKeysPublicIdGetOptions = (options: Options<GetKeyUsersMeApiKeysPublicIdGetData>) => queryOptions<GetKeyUsersMeApiKeysPublicIdGetResponse, AxiosError<GetKeyUsersMeApiKeysPublicIdGetError>, GetKeyUsersMeApiKeysPublicIdGetResponse, ReturnType<typeof getKeyUsersMeApiKeysPublicIdGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await ApiKeys.getKeyUsersMeApiKeysPublicIdGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getKeyUsersMeApiKeysPublicIdGetQueryKey(options)
});

export const authorizationServerMetadataWellKnownOauthAuthorizationServerGetQueryKey = (options?: Options<AuthorizationServerMetadataWellKnownOauthAuthorizationServerGetData>) => createQueryKey('authorizationServerMetadataWellKnownOauthAuthorizationServerGet', options);

/**
 * Authorization Server Metadata
 *
 * How to ask this server for access (RFC 8414).
 *
 * Metered on the same per-address class as the token endpoint rather than a class of its
 * own: both are answered to a program before anybody is signed in, both are cheap, and one
 * ceiling over the pair is one thing to reason about during an incident. A client reads
 * this once and caches it, so the allowance is spent by probing rather than by use.
 */
export const authorizationServerMetadataWellKnownOauthAuthorizationServerGetOptions = (options?: Options<AuthorizationServerMetadataWellKnownOauthAuthorizationServerGetData>) => queryOptions<unknown, AxiosError<AuthorizationServerMetadataWellKnownOauthAuthorizationServerGetError>, unknown, ReturnType<typeof authorizationServerMetadataWellKnownOauthAuthorizationServerGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await OAuth.authorizationServerMetadataWellKnownOauthAuthorizationServerGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: authorizationServerMetadataWellKnownOauthAuthorizationServerGetQueryKey(options)
});

/**
 * Register
 *
 * Register a client (RFC 7591). Open, and grants nothing.
 *
 * Open because a client that installs itself on somebody's machine has nobody to ask for
 * credentials, and closed registration would mean no such client could ever connect. A
 * registration reaches nothing at all on its own: it is a name and a list of addresses,
 * and every key it ever holds was approved by a person who read that name. The ceiling on
 * this route is what keeps the table from being somewhere to write rows for free.
 */
export const registerOauthRegisterPostMutation = (options?: Partial<Options<RegisterOauthRegisterPostData>>): UseMutationOptions<RegisterOauthRegisterPostResponse, AxiosError<RegisterOauthRegisterPostError>, Options<RegisterOauthRegisterPostData>> => {
    const mutationOptions: UseMutationOptions<RegisterOauthRegisterPostResponse, AxiosError<RegisterOauthRegisterPostError>, Options<RegisterOauthRegisterPostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await OAuth.registerOauthRegisterPost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Remove Registration
 *
 * The client removes itself (RFC 7592 section 2.3), and its keys go with it.
 *
 * Answers 204 and nothing else, as the specification requires. A second call is 401 like any
 * other call with a token that no longer names a live registration, which is also the answer
 * somebody guessing at ids gets, so the two cannot be told apart.
 *
 * **The keys it obtained are revoked.** An app announcing it is gone while the credentials it
 * was approved for keep working is the one outcome nobody would expect from "the app removed
 * its registration", so each one is revoked with an audit row saying why — the key page and
 * the trail both explain the change instead of showing a key that stopped for no reason.
 */
export const removeRegistrationOauthRegisterClientIdDeleteMutation = (options?: Partial<Options<RemoveRegistrationOauthRegisterClientIdDeleteData>>): UseMutationOptions<RemoveRegistrationOauthRegisterClientIdDeleteResponse, AxiosError<RemoveRegistrationOauthRegisterClientIdDeleteError>, Options<RemoveRegistrationOauthRegisterClientIdDeleteData>> => {
    const mutationOptions: UseMutationOptions<RemoveRegistrationOauthRegisterClientIdDeleteResponse, AxiosError<RemoveRegistrationOauthRegisterClientIdDeleteError>, Options<RemoveRegistrationOauthRegisterClientIdDeleteData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await OAuth.removeRegistrationOauthRegisterClientIdDelete({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const readRegistrationOauthRegisterClientIdGetQueryKey = (options: Options<ReadRegistrationOauthRegisterClientIdGetData>) => createQueryKey('readRegistrationOauthRegisterClientIdGet', options);

/**
 * Read Registration
 *
 * What this client is registered as (RFC 7592 section 2.2).
 *
 * The registration access token is the authorization, and it is the only thing that is:
 * possession of it is what RFC 7592 intends for a client that has nobody to prove itself
 * to, and it is the same reasoning the revocation endpoint runs on.
 *
 * The answer does not echo the token back. A client presenting it already has it, and
 * repeating a live credential in the body of a plain GET would write it into every log and
 * proxy on the way.
 *
 * Metered on the registration class, like the route that creates one: these three routes are
 * one endpoint as far as a caller is concerned, and the tight allowance is what keeps
 * guessing at ids from being free.
 */
export const readRegistrationOauthRegisterClientIdGetOptions = (options: Options<ReadRegistrationOauthRegisterClientIdGetData>) => queryOptions<ReadRegistrationOauthRegisterClientIdGetResponse, AxiosError<ReadRegistrationOauthRegisterClientIdGetError>, ReadRegistrationOauthRegisterClientIdGetResponse, ReturnType<typeof readRegistrationOauthRegisterClientIdGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await OAuth.readRegistrationOauthRegisterClientIdGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: readRegistrationOauthRegisterClientIdGetQueryKey(options)
});

/**
 * Registration Is Not Editable
 *
 * Not implemented, and said in a sentence (RFC 7592 allows a server to refuse it).
 *
 * Declared as a route rather than left to the router, so a client library that tries to
 * update itself is told why and what to do instead, rather than getting the 405 a typo
 * would earn. It reads no token: there is nothing here to authorize, and looking one up
 * would make an unimplemented verb a way to test whether a token is good.
 */
export const registrationIsNotEditableOauthRegisterClientIdPutMutation = (options?: Partial<Options<RegistrationIsNotEditableOauthRegisterClientIdPutData>>): UseMutationOptions<unknown, AxiosError<RegistrationIsNotEditableOauthRegisterClientIdPutError>, Options<RegistrationIsNotEditableOauthRegisterClientIdPutData>> => {
    const mutationOptions: UseMutationOptions<unknown, AxiosError<RegistrationIsNotEditableOauthRegisterClientIdPutError>, Options<RegistrationIsNotEditableOauthRegisterClientIdPutData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await OAuth.registrationIsNotEditableOauthRegisterClientIdPut({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const authorizationIsNotHereOauthAuthorizeGetQueryKey = (options?: Options<AuthorizationIsNotHereOauthAuthorizeGetData>) => createQueryKey('authorizationIsNotHereOauthAuthorizeGet', options);

/**
 * Authorization Is Not Here
 *
 * Nothing arrives here any more. The authorization endpoint is the app's page.
 *
 * Kept as a route, rather than left to the router's own 404, so that a client holding
 * metadata from before the endpoint moved is told where to go instead of getting the same
 * blank answer it would get for a typo.
 */
export const authorizationIsNotHereOauthAuthorizeGetOptions = (options?: Options<AuthorizationIsNotHereOauthAuthorizeGetData>) => queryOptions<unknown, AxiosError<AuthorizationIsNotHereOauthAuthorizeGetError>, unknown, ReturnType<typeof authorizationIsNotHereOauthAuthorizeGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await OAuth.authorizationIsNotHereOauthAuthorizeGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: authorizationIsNotHereOauthAuthorizeGetQueryKey(options)
});

/**
 * Start Authorization
 *
 * Begin a request from the consent page, and answer what the page should show.
 *
 * The page is the authorization endpoint. It receives the client's parameters on its own
 * query string, and posts them here unread: this route validates every one of them, exactly
 * as the route a browser used to navigate to did, so the parameters are checked by this
 * service and never by a page. A page that validated them itself would be a second
 * implementation of the rules that decide where a code may be sent.
 *
 * Metered on the token class, as the navigated route was, because it is the same step of
 * the same flow; the session is what identifies the person, so there is nothing here for an
 * unauthenticated caller to spend.
 *
 * One round trip. The answer is the consent description itself rather than a request id to
 * fetch, because the page needs all of it before it can render anything, and a redirect for
 * a browser to follow is exactly what this route exists to stop being necessary.
 *
 * **No refusal is ever redirected.** The caller is a page of ours with a person looking at
 * it, so an error is JSON it shows verbatim; the client's address is not somewhere this
 * route sends anybody, whether or not the address validated.
 */
export const startAuthorizationOauthAuthorizePostMutation = (options?: Partial<Options<StartAuthorizationOauthAuthorizePostData>>): UseMutationOptions<StartAuthorizationOauthAuthorizePostResponse, AxiosError<StartAuthorizationOauthAuthorizePostError>, Options<StartAuthorizationOauthAuthorizePostData>> => {
    const mutationOptions: UseMutationOptions<StartAuthorizationOauthAuthorizePostResponse, AxiosError<StartAuthorizationOauthAuthorizePostError>, Options<StartAuthorizationOauthAuthorizePostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await OAuth.startAuthorizationOauthAuthorizePost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const describeRequestOauthAuthorizeRequestIdGetQueryKey = (options: Options<DescribeRequestOauthAuthorizeRequestIdGetData>) => createQueryKey('describeRequestOauthAuthorizeRequestIdGet', options);

/**
 * Describe Request
 *
 * What the consent page shows: who is asking, and what this person may grant.
 *
 * Session-authenticated, and the request must be this person's own — a request id names
 * the person it was created for and is not a capability for anybody else who learns it.
 *
 * The answer is shaped like the decision. ``scopes`` is the list once, because a consent is
 * one scope set applied to every property chosen, and ``properties`` says which of those
 * each property's role refuses, so the page can disable a box and name the property. There
 * is nothing to combine: what the person ticks is what the key carries.
 *
 * ``requested_scopes`` is kept separate from both. It is what the client asked for, and the
 * page ticks those of them this person's role allows, labelled as requested, with the rest
 * shown disabled and named. No property is chosen until the person chooses one, and the
 * duration opens on the shortest choice. Consent is the Approve button and not a tick box:
 * nothing is granted until it is pressed.
 */
export const describeRequestOauthAuthorizeRequestIdGetOptions = (options: Options<DescribeRequestOauthAuthorizeRequestIdGetData>) => queryOptions<DescribeRequestOauthAuthorizeRequestIdGetResponse, AxiosError<DescribeRequestOauthAuthorizeRequestIdGetError>, DescribeRequestOauthAuthorizeRequestIdGetResponse, ReturnType<typeof describeRequestOauthAuthorizeRequestIdGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await OAuth.describeRequestOauthAuthorizeRequestIdGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: describeRequestOauthAuthorizeRequestIdGetQueryKey(options)
});

/**
 * Approve
 *
 * Grant what the person chose: mint the key, and answer where to send the browser.
 *
 * Metered on the class that guards making a key from the key page, because that is what
 * this does. The secret is not in the answer and is not shown to the person at all: the
 * client collects it at the token endpoint in exchange for the code and its verifier, so
 * the one place it is ever seen is the one place it is needed.
 *
 * One scope list for every property named. An approval whose scopes the role on one of
 * those properties does not allow is refused, naming that property, rather than granted as
 * something narrower or wider than what was ticked.
 */
export const approveOauthAuthorizeRequestIdApprovePostMutation = (options?: Partial<Options<ApproveOauthAuthorizeRequestIdApprovePostData>>): UseMutationOptions<ApproveOauthAuthorizeRequestIdApprovePostResponse, AxiosError<ApproveOauthAuthorizeRequestIdApprovePostError>, Options<ApproveOauthAuthorizeRequestIdApprovePostData>> => {
    const mutationOptions: UseMutationOptions<ApproveOauthAuthorizeRequestIdApprovePostResponse, AxiosError<ApproveOauthAuthorizeRequestIdApprovePostError>, Options<ApproveOauthAuthorizeRequestIdApprovePostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await OAuth.approveOauthAuthorizeRequestIdApprovePost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Refuse
 *
 * Say no, and tell the client so.
 *
 * The refusal goes back through the client's own address, so the app that asked can say
 * "you declined" instead of waiting on a window that never answers.
 */
export const refuseOauthAuthorizeRequestIdRefusePostMutation = (options?: Partial<Options<RefuseOauthAuthorizeRequestIdRefusePostData>>): UseMutationOptions<RefuseOauthAuthorizeRequestIdRefusePostResponse, AxiosError<RefuseOauthAuthorizeRequestIdRefusePostError>, Options<RefuseOauthAuthorizeRequestIdRefusePostData>> => {
    const mutationOptions: UseMutationOptions<RefuseOauthAuthorizeRequestIdRefusePostResponse, AxiosError<RefuseOauthAuthorizeRequestIdRefusePostError>, Options<RefuseOauthAuthorizeRequestIdRefusePostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await OAuth.refuseOauthAuthorizeRequestIdRefusePost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Token
 *
 * Trade a code, or a refresh token, for an access token and the next refresh token.
 *
 * Form-encoded, because that is what RFC 6749 specifies and what every client library
 * sends. ``no-store`` on every answer, including the refusals: a response carrying a
 * credential must not be written to a cache on the way past.
 *
 * The writes are committed before the answer is built, so there is no path where a client
 * is handed a secret for a rotation that was rolled back. The audit rows go the same way:
 * after the commit, and only for writes that survived it, so the trail never claims a
 * revocation that was rolled back.
 */
export const tokenOauthTokenPostMutation = (options?: Partial<Options<TokenOauthTokenPostData>>): UseMutationOptions<unknown, AxiosError<TokenOauthTokenPostError>, Options<TokenOauthTokenPostData>> => {
    const mutationOptions: UseMutationOptions<unknown, AxiosError<TokenOauthTokenPostError>, Options<TokenOauthTokenPostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await OAuth.tokenOauthTokenPost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Revoke
 *
 * Revoke the key behind a token (RFC 7009).
 *
 * Answers 200 whether or not the token existed, which the specification requires and which
 * is also the only answer that does not turn this route into a way of finding out which
 * tokens are real. The hint is accepted and ignored: the token's own prefix says which kind
 * it is, and a hint that disagreed with the token would be a second opinion worth nothing.
 *
 * Possession of the token is the authorization. That is what the specification intends for
 * a public client, and the alternative — asking a client to prove itself — would leave a
 * person unable to disconnect an app whose registration has been pruned.
 */
export const revokeOauthRevokePostMutation = (options?: Partial<Options<RevokeOauthRevokePostData>>): UseMutationOptions<unknown, AxiosError<RevokeOauthRevokePostError>, Options<RevokeOauthRevokePostData>> => {
    const mutationOptions: UseMutationOptions<unknown, AxiosError<RevokeOauthRevokePostError>, Options<RevokeOauthRevokePostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await OAuth.revokeOauthRevokePost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listStagedDocumentsHousesHouseIdStagedDocumentsGetQueryKey = (options: Options<ListStagedDocumentsHousesHouseIdStagedDocumentsGetData>) => createQueryKey('listStagedDocumentsHousesHouseIdStagedDocumentsGet', options);

/**
 * List Staged Documents
 *
 * What is waiting on this property, newest first.
 *
 * Defaults to ``ready`` because that is the only state a person can do anything about;
 * the others are there for the question "what happened to the file my agent sent", which
 * is asked deliberately and rarely.
 */
export const listStagedDocumentsHousesHouseIdStagedDocumentsGetOptions = (options: Options<ListStagedDocumentsHousesHouseIdStagedDocumentsGetData>) => queryOptions<ListStagedDocumentsHousesHouseIdStagedDocumentsGetResponse, AxiosError<ListStagedDocumentsHousesHouseIdStagedDocumentsGetError>, ListStagedDocumentsHousesHouseIdStagedDocumentsGetResponse, ReturnType<typeof listStagedDocumentsHousesHouseIdStagedDocumentsGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await StagedDocuments.listStagedDocumentsHousesHouseIdStagedDocumentsGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listStagedDocumentsHousesHouseIdStagedDocumentsGetQueryKey(options)
});

export const listBundleProposalsHousesHouseIdStagedDocumentsProposalsGetQueryKey = (options: Options<ListBundleProposalsHousesHouseIdStagedDocumentsProposalsGetData>) => createQueryKey('listBundleProposalsHousesHouseIdStagedDocumentsProposalsGet', options);

/**
 * List Bundle Proposals
 *
 * Groupings contributors have asked for on this property, with what is in each.
 *
 * The advisory occasion is shown as proposed and flagged as advisory, because approving
 * it is a separate act from approving the grouping.
 */
export const listBundleProposalsHousesHouseIdStagedDocumentsProposalsGetOptions = (options: Options<ListBundleProposalsHousesHouseIdStagedDocumentsProposalsGetData>) => queryOptions<ListBundleProposalsHousesHouseIdStagedDocumentsProposalsGetResponse, AxiosError<ListBundleProposalsHousesHouseIdStagedDocumentsProposalsGetError>, ListBundleProposalsHousesHouseIdStagedDocumentsProposalsGetResponse, ReturnType<typeof listBundleProposalsHousesHouseIdStagedDocumentsProposalsGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await StagedDocuments.listBundleProposalsHousesHouseIdStagedDocumentsProposalsGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listBundleProposalsHousesHouseIdStagedDocumentsProposalsGetQueryKey(options)
});

/**
 * Approve Bundle Proposal
 *
 * Accept the grouping. Every file still waiting for review goes in, as one bundle.
 */
export const approveBundleProposalHousesHouseIdStagedDocumentsProposalsPublicIdApprovePostMutation = (options?: Partial<Options<ApproveBundleProposalHousesHouseIdStagedDocumentsProposalsPublicIdApprovePostData>>): UseMutationOptions<ApproveBundleProposalHousesHouseIdStagedDocumentsProposalsPublicIdApprovePostResponse, AxiosError<ApproveBundleProposalHousesHouseIdStagedDocumentsProposalsPublicIdApprovePostError>, Options<ApproveBundleProposalHousesHouseIdStagedDocumentsProposalsPublicIdApprovePostData>> => {
    const mutationOptions: UseMutationOptions<ApproveBundleProposalHousesHouseIdStagedDocumentsProposalsPublicIdApprovePostResponse, AxiosError<ApproveBundleProposalHousesHouseIdStagedDocumentsProposalsPublicIdApprovePostError>, Options<ApproveBundleProposalHousesHouseIdStagedDocumentsProposalsPublicIdApprovePostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await StagedDocuments.approveBundleProposalHousesHouseIdStagedDocumentsProposalsPublicIdApprovePost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Refuse Bundle Proposal
 *
 * Say no to the grouping. The files stay exactly where they were.
 */
export const refuseBundleProposalHousesHouseIdStagedDocumentsProposalsPublicIdRefusePostMutation = (options?: Partial<Options<RefuseBundleProposalHousesHouseIdStagedDocumentsProposalsPublicIdRefusePostData>>): UseMutationOptions<RefuseBundleProposalHousesHouseIdStagedDocumentsProposalsPublicIdRefusePostResponse, AxiosError<RefuseBundleProposalHousesHouseIdStagedDocumentsProposalsPublicIdRefusePostError>, Options<RefuseBundleProposalHousesHouseIdStagedDocumentsProposalsPublicIdRefusePostData>> => {
    const mutationOptions: UseMutationOptions<RefuseBundleProposalHousesHouseIdStagedDocumentsProposalsPublicIdRefusePostResponse, AxiosError<RefuseBundleProposalHousesHouseIdStagedDocumentsProposalsPublicIdRefusePostError>, Options<RefuseBundleProposalHousesHouseIdStagedDocumentsProposalsPublicIdRefusePostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await StagedDocuments.refuseBundleProposalHousesHouseIdStagedDocumentsProposalsPublicIdRefusePost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getStagedDocumentHousesHouseIdStagedDocumentsPublicIdGetQueryKey = (options: Options<GetStagedDocumentHousesHouseIdStagedDocumentsPublicIdGetData>) => createQueryKey('getStagedDocumentHousesHouseIdStagedDocumentsPublicIdGet', options);

/**
 * Get Staged Document
 */
export const getStagedDocumentHousesHouseIdStagedDocumentsPublicIdGetOptions = (options: Options<GetStagedDocumentHousesHouseIdStagedDocumentsPublicIdGetData>) => queryOptions<GetStagedDocumentHousesHouseIdStagedDocumentsPublicIdGetResponse, AxiosError<GetStagedDocumentHousesHouseIdStagedDocumentsPublicIdGetError>, GetStagedDocumentHousesHouseIdStagedDocumentsPublicIdGetResponse, ReturnType<typeof getStagedDocumentHousesHouseIdStagedDocumentsPublicIdGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await StagedDocuments.getStagedDocumentHousesHouseIdStagedDocumentsPublicIdGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getStagedDocumentHousesHouseIdStagedDocumentsPublicIdGetQueryKey(options)
});

/**
 * Promote Staged Document
 *
 * Accept one staged file into the property.
 */
export const promoteStagedDocumentHousesHouseIdStagedDocumentsPublicIdPromotePostMutation = (options?: Partial<Options<PromoteStagedDocumentHousesHouseIdStagedDocumentsPublicIdPromotePostData>>): UseMutationOptions<PromoteStagedDocumentHousesHouseIdStagedDocumentsPublicIdPromotePostResponse, AxiosError<PromoteStagedDocumentHousesHouseIdStagedDocumentsPublicIdPromotePostError>, Options<PromoteStagedDocumentHousesHouseIdStagedDocumentsPublicIdPromotePostData>> => {
    const mutationOptions: UseMutationOptions<PromoteStagedDocumentHousesHouseIdStagedDocumentsPublicIdPromotePostResponse, AxiosError<PromoteStagedDocumentHousesHouseIdStagedDocumentsPublicIdPromotePostError>, Options<PromoteStagedDocumentHousesHouseIdStagedDocumentsPublicIdPromotePostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await StagedDocuments.promoteStagedDocumentHousesHouseIdStagedDocumentsPublicIdPromotePost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Promote Staged Documents
 *
 * Accept several staged files at once, as one bundle when a spec is given.
 */
export const promoteStagedDocumentsHousesHouseIdStagedDocumentsPromotePostMutation = (options?: Partial<Options<PromoteStagedDocumentsHousesHouseIdStagedDocumentsPromotePostData>>): UseMutationOptions<PromoteStagedDocumentsHousesHouseIdStagedDocumentsPromotePostResponse, AxiosError<PromoteStagedDocumentsHousesHouseIdStagedDocumentsPromotePostError>, Options<PromoteStagedDocumentsHousesHouseIdStagedDocumentsPromotePostData>> => {
    const mutationOptions: UseMutationOptions<PromoteStagedDocumentsHousesHouseIdStagedDocumentsPromotePostResponse, AxiosError<PromoteStagedDocumentsHousesHouseIdStagedDocumentsPromotePostError>, Options<PromoteStagedDocumentsHousesHouseIdStagedDocumentsPromotePostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await StagedDocuments.promoteStagedDocumentsHousesHouseIdStagedDocumentsPromotePost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Reject Staged Document
 *
 * Turn one staged file down. Its bytes are deleted.
 */
export const rejectStagedDocumentHousesHouseIdStagedDocumentsPublicIdRejectPostMutation = (options?: Partial<Options<RejectStagedDocumentHousesHouseIdStagedDocumentsPublicIdRejectPostData>>): UseMutationOptions<RejectStagedDocumentHousesHouseIdStagedDocumentsPublicIdRejectPostResponse, AxiosError<RejectStagedDocumentHousesHouseIdStagedDocumentsPublicIdRejectPostError>, Options<RejectStagedDocumentHousesHouseIdStagedDocumentsPublicIdRejectPostData>> => {
    const mutationOptions: UseMutationOptions<RejectStagedDocumentHousesHouseIdStagedDocumentsPublicIdRejectPostResponse, AxiosError<RejectStagedDocumentHousesHouseIdStagedDocumentsPublicIdRejectPostError>, Options<RejectStagedDocumentHousesHouseIdStagedDocumentsPublicIdRejectPostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await StagedDocuments.rejectStagedDocumentHousesHouseIdStagedDocumentsPublicIdRejectPost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Reject Staged Documents
 *
 * Turn several staged files down at once.
 */
export const rejectStagedDocumentsHousesHouseIdStagedDocumentsRejectPostMutation = (options?: Partial<Options<RejectStagedDocumentsHousesHouseIdStagedDocumentsRejectPostData>>): UseMutationOptions<RejectStagedDocumentsHousesHouseIdStagedDocumentsRejectPostResponse, AxiosError<RejectStagedDocumentsHousesHouseIdStagedDocumentsRejectPostError>, Options<RejectStagedDocumentsHousesHouseIdStagedDocumentsRejectPostData>> => {
    const mutationOptions: UseMutationOptions<RejectStagedDocumentsHousesHouseIdStagedDocumentsRejectPostResponse, AxiosError<RejectStagedDocumentsHousesHouseIdStagedDocumentsRejectPostError>, Options<RejectStagedDocumentsHousesHouseIdStagedDocumentsRejectPostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await StagedDocuments.rejectStagedDocumentsHousesHouseIdStagedDocumentsRejectPost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getPoolStatsDiagnosticsDbPoolStatsGetQueryKey = (options?: Options<GetPoolStatsDiagnosticsDbPoolStatsGetData>) => createQueryKey('getPoolStatsDiagnosticsDbPoolStatsGet', options);

/**
 * Get Pool Stats
 *
 * Get current connection pool statistics
 */
export const getPoolStatsDiagnosticsDbPoolStatsGetOptions = (options?: Options<GetPoolStatsDiagnosticsDbPoolStatsGetData>) => queryOptions<GetPoolStatsDiagnosticsDbPoolStatsGetResponse, AxiosError<DefaultError>, GetPoolStatsDiagnosticsDbPoolStatsGetResponse, ReturnType<typeof getPoolStatsDiagnosticsDbPoolStatsGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await Diagnostics.getPoolStatsDiagnosticsDbPoolStatsGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getPoolStatsDiagnosticsDbPoolStatsGetQueryKey(options)
});

export const getDatabaseConnectionsDiagnosticsDbConnectionsGetQueryKey = (options?: Options<GetDatabaseConnectionsDiagnosticsDbConnectionsGetData>) => createQueryKey('getDatabaseConnectionsDiagnosticsDbConnectionsGet', options);

/**
 * Get Database Connections
 *
 * Get active database connections from PostgreSQL
 */
export const getDatabaseConnectionsDiagnosticsDbConnectionsGetOptions = (options?: Options<GetDatabaseConnectionsDiagnosticsDbConnectionsGetData>) => queryOptions<GetDatabaseConnectionsDiagnosticsDbConnectionsGetResponse, AxiosError<DefaultError>, GetDatabaseConnectionsDiagnosticsDbConnectionsGetResponse, ReturnType<typeof getDatabaseConnectionsDiagnosticsDbConnectionsGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await Diagnostics.getDatabaseConnectionsDiagnosticsDbConnectionsGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getDatabaseConnectionsDiagnosticsDbConnectionsGetQueryKey(options)
});

export const getLongRunningConnectionsDiagnosticsDbLongRunningGetQueryKey = (options?: Options<GetLongRunningConnectionsDiagnosticsDbLongRunningGetData>) => createQueryKey('getLongRunningConnectionsDiagnosticsDbLongRunningGet', options);

/**
 * Get Long Running Connections
 *
 * Get potentially leaked long-running connections
 */
export const getLongRunningConnectionsDiagnosticsDbLongRunningGetOptions = (options?: Options<GetLongRunningConnectionsDiagnosticsDbLongRunningGetData>) => queryOptions<GetLongRunningConnectionsDiagnosticsDbLongRunningGetResponse, AxiosError<DefaultError>, GetLongRunningConnectionsDiagnosticsDbLongRunningGetResponse, ReturnType<typeof getLongRunningConnectionsDiagnosticsDbLongRunningGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await Diagnostics.getLongRunningConnectionsDiagnosticsDbLongRunningGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getLongRunningConnectionsDiagnosticsDbLongRunningGetQueryKey(options)
});

export const getFullDiagnosticsDiagnosticsDbFullReportGetQueryKey = (options?: Options<GetFullDiagnosticsDiagnosticsDbFullReportGetData>) => createQueryKey('getFullDiagnosticsDiagnosticsDbFullReportGet', options);

/**
 * Get Full Diagnostics
 *
 * Run complete database diagnostics
 */
export const getFullDiagnosticsDiagnosticsDbFullReportGetOptions = (options?: Options<GetFullDiagnosticsDiagnosticsDbFullReportGetData>) => queryOptions<GetFullDiagnosticsDiagnosticsDbFullReportGetResponse, AxiosError<DefaultError>, GetFullDiagnosticsDiagnosticsDbFullReportGetResponse, ReturnType<typeof getFullDiagnosticsDiagnosticsDbFullReportGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await Diagnostics.getFullDiagnosticsDiagnosticsDbFullReportGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getFullDiagnosticsDiagnosticsDbFullReportGetQueryKey(options)
});

/**
 * Run Stress Test
 *
 * Run connection pool stress test
 */
export const runStressTestDiagnosticsDbStressTestPostMutation = (options?: Partial<Options<RunStressTestDiagnosticsDbStressTestPostData>>): UseMutationOptions<RunStressTestDiagnosticsDbStressTestPostResponse, AxiosError<RunStressTestDiagnosticsDbStressTestPostError>, Options<RunStressTestDiagnosticsDbStressTestPostData>> => {
    const mutationOptions: UseMutationOptions<RunStressTestDiagnosticsDbStressTestPostResponse, AxiosError<RunStressTestDiagnosticsDbStressTestPostError>, Options<RunStressTestDiagnosticsDbStressTestPostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await Diagnostics.runStressTestDiagnosticsDbStressTestPost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getSystemResourcesDiagnosticsSystemResourcesGetQueryKey = (options?: Options<GetSystemResourcesDiagnosticsSystemResourcesGetData>) => createQueryKey('getSystemResourcesDiagnosticsSystemResourcesGet', options);

/**
 * Get System Resources
 *
 * Get system resource usage
 */
export const getSystemResourcesDiagnosticsSystemResourcesGetOptions = (options?: Options<GetSystemResourcesDiagnosticsSystemResourcesGetData>) => queryOptions<GetSystemResourcesDiagnosticsSystemResourcesGetResponse, AxiosError<DefaultError>, GetSystemResourcesDiagnosticsSystemResourcesGetResponse, ReturnType<typeof getSystemResourcesDiagnosticsSystemResourcesGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await Diagnostics.getSystemResourcesDiagnosticsSystemResourcesGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getSystemResourcesDiagnosticsSystemResourcesGetQueryKey(options)
});

/**
 * Drain Rekicks Endpoint
 *
 * Drain eligible re-kicks IN THIS ENVIRONMENT (broker + Slack resolve here).
 *
 * `confirm=False` previews the eligible rows without dispatching or changing state;
 * `confirm=True` dispatches them and, with `resolve_incidents`, closes each linked
 * incident (audited to the admin's email). Returns per-row outcomes.
 */
export const drainRekicksEndpointObservabilityRekicksDrainPostMutation = (options?: Partial<Options<DrainRekicksEndpointObservabilityRekicksDrainPostData>>): UseMutationOptions<DrainRekicksEndpointObservabilityRekicksDrainPostResponse, AxiosError<DrainRekicksEndpointObservabilityRekicksDrainPostError>, Options<DrainRekicksEndpointObservabilityRekicksDrainPostData>> => {
    const mutationOptions: UseMutationOptions<DrainRekicksEndpointObservabilityRekicksDrainPostResponse, AxiosError<DrainRekicksEndpointObservabilityRekicksDrainPostError>, Options<DrainRekicksEndpointObservabilityRekicksDrainPostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await Observability.drainRekicksEndpointObservabilityRekicksDrainPost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listRolloutsEndpointObservabilityRolloutsGetQueryKey = (options?: Options<ListRolloutsEndpointObservabilityRolloutsGetData>) => createQueryKey('listRolloutsEndpointObservabilityRolloutsGet', options);

/**
 * List Rollouts Endpoint
 */
export const listRolloutsEndpointObservabilityRolloutsGetOptions = (options?: Options<ListRolloutsEndpointObservabilityRolloutsGetData>) => queryOptions<unknown, AxiosError<DefaultError>, unknown, ReturnType<typeof listRolloutsEndpointObservabilityRolloutsGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await Observability.listRolloutsEndpointObservabilityRolloutsGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listRolloutsEndpointObservabilityRolloutsGetQueryKey(options)
});

/**
 * Create Rollout Endpoint
 *
 * Create a draft rollout (nothing materialised until it is locked).
 */
export const createRolloutEndpointObservabilityRolloutsPostMutation = (options?: Partial<Options<CreateRolloutEndpointObservabilityRolloutsPostData>>): UseMutationOptions<unknown, AxiosError<CreateRolloutEndpointObservabilityRolloutsPostError>, Options<CreateRolloutEndpointObservabilityRolloutsPostData>> => {
    const mutationOptions: UseMutationOptions<unknown, AxiosError<CreateRolloutEndpointObservabilityRolloutsPostError>, Options<CreateRolloutEndpointObservabilityRolloutsPostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await Observability.createRolloutEndpointObservabilityRolloutsPost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getRolloutEndpointObservabilityRolloutsRolloutIdGetQueryKey = (options: Options<GetRolloutEndpointObservabilityRolloutsRolloutIdGetData>) => createQueryKey('getRolloutEndpointObservabilityRolloutsRolloutIdGet', options);

/**
 * Get Rollout Endpoint
 */
export const getRolloutEndpointObservabilityRolloutsRolloutIdGetOptions = (options: Options<GetRolloutEndpointObservabilityRolloutsRolloutIdGetData>) => queryOptions<unknown, AxiosError<GetRolloutEndpointObservabilityRolloutsRolloutIdGetError>, unknown, ReturnType<typeof getRolloutEndpointObservabilityRolloutsRolloutIdGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await Observability.getRolloutEndpointObservabilityRolloutsRolloutIdGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getRolloutEndpointObservabilityRolloutsRolloutIdGetQueryKey(options)
});

/**
 * Preview Rollout Endpoint
 *
 * The worklist this rollout would materialise — counts + waves — without writing.
 */
export const previewRolloutEndpointObservabilityRolloutsRolloutIdPreviewPostMutation = (options?: Partial<Options<PreviewRolloutEndpointObservabilityRolloutsRolloutIdPreviewPostData>>): UseMutationOptions<unknown, AxiosError<PreviewRolloutEndpointObservabilityRolloutsRolloutIdPreviewPostError>, Options<PreviewRolloutEndpointObservabilityRolloutsRolloutIdPreviewPostData>> => {
    const mutationOptions: UseMutationOptions<unknown, AxiosError<PreviewRolloutEndpointObservabilityRolloutsRolloutIdPreviewPostError>, Options<PreviewRolloutEndpointObservabilityRolloutsRolloutIdPreviewPostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await Observability.previewRolloutEndpointObservabilityRolloutsRolloutIdPreviewPost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Lock Rollout Endpoint
 *
 * Freeze the draft: materialise its held worklist and flip it to locked.
 */
export const lockRolloutEndpointObservabilityRolloutsRolloutIdLockPostMutation = (options?: Partial<Options<LockRolloutEndpointObservabilityRolloutsRolloutIdLockPostData>>): UseMutationOptions<unknown, AxiosError<LockRolloutEndpointObservabilityRolloutsRolloutIdLockPostError>, Options<LockRolloutEndpointObservabilityRolloutsRolloutIdLockPostData>> => {
    const mutationOptions: UseMutationOptions<unknown, AxiosError<LockRolloutEndpointObservabilityRolloutsRolloutIdLockPostError>, Options<LockRolloutEndpointObservabilityRolloutsRolloutIdLockPostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await Observability.lockRolloutEndpointObservabilityRolloutsRolloutIdLockPost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Release Rollout Endpoint
 *
 * Operator-pump: advance this rollout by one wave now (optionally approving a
 * checkpoint wave first). The gate still applies — a closed gate reports why.
 */
export const releaseRolloutEndpointObservabilityRolloutsRolloutIdReleasePostMutation = (options?: Partial<Options<ReleaseRolloutEndpointObservabilityRolloutsRolloutIdReleasePostData>>): UseMutationOptions<unknown, AxiosError<ReleaseRolloutEndpointObservabilityRolloutsRolloutIdReleasePostError>, Options<ReleaseRolloutEndpointObservabilityRolloutsRolloutIdReleasePostData>> => {
    const mutationOptions: UseMutationOptions<unknown, AxiosError<ReleaseRolloutEndpointObservabilityRolloutsRolloutIdReleasePostError>, Options<ReleaseRolloutEndpointObservabilityRolloutsRolloutIdReleasePostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await Observability.releaseRolloutEndpointObservabilityRolloutsRolloutIdReleasePost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Pause Rollout Endpoint
 */
export const pauseRolloutEndpointObservabilityRolloutsRolloutIdPausePostMutation = (options?: Partial<Options<PauseRolloutEndpointObservabilityRolloutsRolloutIdPausePostData>>): UseMutationOptions<unknown, AxiosError<PauseRolloutEndpointObservabilityRolloutsRolloutIdPausePostError>, Options<PauseRolloutEndpointObservabilityRolloutsRolloutIdPausePostData>> => {
    const mutationOptions: UseMutationOptions<unknown, AxiosError<PauseRolloutEndpointObservabilityRolloutsRolloutIdPausePostError>, Options<PauseRolloutEndpointObservabilityRolloutsRolloutIdPausePostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await Observability.pauseRolloutEndpointObservabilityRolloutsRolloutIdPausePost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Resume Rollout Endpoint
 */
export const resumeRolloutEndpointObservabilityRolloutsRolloutIdResumePostMutation = (options?: Partial<Options<ResumeRolloutEndpointObservabilityRolloutsRolloutIdResumePostData>>): UseMutationOptions<unknown, AxiosError<ResumeRolloutEndpointObservabilityRolloutsRolloutIdResumePostError>, Options<ResumeRolloutEndpointObservabilityRolloutsRolloutIdResumePostData>> => {
    const mutationOptions: UseMutationOptions<unknown, AxiosError<ResumeRolloutEndpointObservabilityRolloutsRolloutIdResumePostError>, Options<ResumeRolloutEndpointObservabilityRolloutsRolloutIdResumePostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await Observability.resumeRolloutEndpointObservabilityRolloutsRolloutIdResumePost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Abort Rollout Endpoint
 */
export const abortRolloutEndpointObservabilityRolloutsRolloutIdAbortPostMutation = (options?: Partial<Options<AbortRolloutEndpointObservabilityRolloutsRolloutIdAbortPostData>>): UseMutationOptions<unknown, AxiosError<AbortRolloutEndpointObservabilityRolloutsRolloutIdAbortPostError>, Options<AbortRolloutEndpointObservabilityRolloutsRolloutIdAbortPostData>> => {
    const mutationOptions: UseMutationOptions<unknown, AxiosError<AbortRolloutEndpointObservabilityRolloutsRolloutIdAbortPostError>, Options<AbortRolloutEndpointObservabilityRolloutsRolloutIdAbortPostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await Observability.abortRolloutEndpointObservabilityRolloutsRolloutIdAbortPost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Slash Command
 *
 * `/incident` — for a report with no conversation behind it.
 *
 * A custom slash command cannot be invoked inside a thread at all (Slack reserves that
 * for its own built-ins) and its payload carries no thread reference, so this path
 * never has conversation context to capture. Anything discussed in a thread is filed
 * with the message shortcut instead.
 */
export const slashCommandObservabilitySlackCommandPostMutation = (options?: Partial<Options<SlashCommandObservabilitySlackCommandPostData>>): UseMutationOptions<unknown, AxiosError<DefaultError>, Options<SlashCommandObservabilitySlackCommandPostData>> => {
    const mutationOptions: UseMutationOptions<unknown, AxiosError<DefaultError>, Options<SlashCommandObservabilitySlackCommandPostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await SlackIntake.slashCommandObservabilitySlackCommandPost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Interactivity
 *
 * Shortcuts and modal submissions. Slack posts both here as a form-encoded
 * `payload`.
 */
export const interactivityObservabilitySlackInteractivityPostMutation = (options?: Partial<Options<InteractivityObservabilitySlackInteractivityPostData>>): UseMutationOptions<unknown, AxiosError<DefaultError>, Options<InteractivityObservabilitySlackInteractivityPostData>> => {
    const mutationOptions: UseMutationOptions<unknown, AxiosError<DefaultError>, Options<InteractivityObservabilitySlackInteractivityPostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await SlackIntake.interactivityObservabilitySlackInteractivityPost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Ingest Deploy
 *
 * Upsert one deploy record (idempotent on merge_sha). Called by the prod deploy job.
 */
export const ingestDeployObservabilityDeploysPostMutation = (options?: Partial<Options<IngestDeployObservabilityDeploysPostData>>): UseMutationOptions<IngestDeployObservabilityDeploysPostResponse, AxiosError<IngestDeployObservabilityDeploysPostError>, Options<IngestDeployObservabilityDeploysPostData>> => {
    const mutationOptions: UseMutationOptions<IngestDeployObservabilityDeploysPostResponse, AxiosError<IngestDeployObservabilityDeploysPostError>, Options<IngestDeployObservabilityDeploysPostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await Observability.ingestDeployObservabilityDeploysPost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const healthCheckHealthGetQueryKey = (options?: Options<HealthCheckHealthGetData>) => createQueryKey('healthCheckHealthGet', options);

/**
 * Health Check
 *
 * Public health check endpoint for basic liveness probe.
 *
 * This is a lightweight endpoint with no external dependencies.
 * Use for:
 * - Kubernetes/Docker liveness probes
 * - Load balancer health checks
 * - Public status pages
 *
 * Returns 200 if the application is running.
 */
export const healthCheckHealthGetOptions = (options?: Options<HealthCheckHealthGetData>) => queryOptions<unknown, AxiosError<DefaultError>, unknown, ReturnType<typeof healthCheckHealthGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await Health.healthCheckHealthGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: healthCheckHealthGetQueryKey(options)
});

export const readinessCheckGreenthumbGetQueryKey = (options?: Options<ReadinessCheckGreenthumbGetData>) => createQueryKey('readinessCheckGreenthumbGet', options);

/**
 * Readiness Check
 *
 * Private readiness check endpoint with authentication.
 *
 * Validates that critical dependencies are operational.
 * Use for:
 * - CI/CD deployment validation
 * - Kubernetes readiness probes
 * - Internal monitoring
 *
 * Requires x-health-token header matching CORE_HEALTH_TOKEN.
 *
 * TODO: Add dependency checks for:
 * - Database connectivity
 * - Redis connectivity
 * - S3 connectivity
 *
 * Returns:
 * - 200: All systems ready
 * - 401: Invalid or missing health token
 * - 503: Dependencies not ready (to be implemented)
 */
export const readinessCheckGreenthumbGetOptions = (options?: Options<ReadinessCheckGreenthumbGetData>) => queryOptions<unknown, AxiosError<DefaultError>, unknown, ReturnType<typeof readinessCheckGreenthumbGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await Health.readinessCheckGreenthumbGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: readinessCheckGreenthumbGetQueryKey(options)
});

export const readRootGetQueryKey = (options?: Options<ReadRootGetData>) => createQueryKey('readRootGet', options);

/**
 * Read Root
 */
export const readRootGetOptions = (options?: Options<ReadRootGetData>) => queryOptions<unknown, AxiosError<DefaultError>, unknown, ReturnType<typeof readRootGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await Default.readRootGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: readRootGetQueryKey(options)
});
